import * as E from "react";
import qt, { forwardRef as tn, useRef as at, useEffect as wt, useState as vt, useLayoutEffect as ma, createElement as ts, useMemo as rs, Fragment as ns, createContext as as, useContext as is } from "react";
import * as Ni from "react-dom";
import os, { createPortal as ss } from "react-dom";
var Bt = /* @__PURE__ */ ((e) => (e.Sm = "sm", e.Md = "md", e.Lg = "lg", e.Xl = "xl", e))(Bt || {});
const Ue = (e, t = 16) => `${e / t}rem`;
function Pi(e) {
  return Object.entries(e).reduce(
    (r, [n, i]) => (r[n] = `${i}px`, r),
    {}
  );
}
const ls = {
  primary: {
    0: "#000000",
    10: "#061244",
    20: "#182b8a",
    30: "#3131ff",
    40: "#2563f5",
    50: "#3f80f0",
    60: "#5b9cfe",
    70: "#85b5fb",
    80: "#adceff",
    90: "#d5e8ff",
    100: "#ffffff"
  },
  secondary: {
    0: "#000000",
    10: "#051631",
    20: "#17345f",
    30: "#2d4c7a",
    40: "#4b648a",
    50: "#637ca2",
    60: "#7e97bd",
    70: "#96b3d5",
    80: "#b6cde8",
    90: "#dde9f7",
    100: "#ffffff"
  },
  tertiary: {
    0: "#000000",
    10: "#071f22",
    20: "#18393b",
    30: "#185b60",
    40: "#317479",
    50: "#498c91",
    60: "#64a7ac",
    70: "#7fc2c7",
    80: "#9adde2",
    90: "#c2f1f4",
    100: "#ffffff"
  },
  error: {
    0: "#000000",
    10: "#330009",
    20: "#610012",
    30: "#b51431",
    40: "#ce2d4a",
    50: "#e64562",
    60: "#ff607d",
    70: "#ff889e",
    80: "#ffb0be",
    90: "#ffd9e0",
    100: "#ffffff"
  },
  neutral: {
    0: "#000000",
    4: "#0a0f17",
    6: "#0f141c",
    10: "#171d26",
    12: "#1c212b",
    20: "#253041",
    30: "#3c4656",
    40: "#545e6e",
    50: "#6e7787",
    60: "#8892a1",
    70: "#a8b2c0",
    80: "#cad4e2",
    90: "#dde4f0",
    92: "#e3eaf6",
    96: "#eff4fa",
    98: "#f8fafc",
    100: "#ffffff"
  },
  warning: {
    10: "#422C00",
    20: "#2D1E00",
    60: "#BE8F32",
    90: "#FFE3AB"
  }
}, us = {
  "shader-primary-dark": {
    0: "#bed8ff00",
    8: "#bed8ff14",
    12: "#bed8ff1e",
    16: "#bed8ff28",
    48: "#bed8ff7a",
    72: "#bed8ffb7"
  },
  "shader-inverted-dark": {
    0: "#002f6d00",
    8: "#002f6d14",
    12: "#002f6d1e",
    16: "#002f6d28",
    48: "#002f6d7a",
    72: "#002f6db7"
  },
  "shader-neutral-dark": {
    0: "#bed8ff00",
    8: "#bed8ff14",
    12: "#bed8ff1e",
    16: "#bed8ff28",
    48: "#bed8ff7a",
    72: "#bed8ffb7"
  },
  "shader-primary-light": {
    0: "#0067ee00",
    8: "#0067ee14",
    12: "#0067ee1e",
    16: "#0067ee28",
    48: "#0067ee7a",
    72: "#0067eeb7"
  },
  "shader-inverted-light": {
    0: "#bed8ff00",
    8: "#bed8ff14",
    12: "#bed8ff1e",
    16: "#bed8ff28",
    48: "#bed8ff7a",
    72: "#bed8ffb7"
  },
  "shader-neutral-light": {
    0: "#002f6d00",
    8: "#002f6d14",
    12: "#002f6d1e",
    16: "#002f6d28",
    48: "#002f6d7a",
    72: "#002f6db7"
  }
}, cs = {
  none: Ue(0),
  sm: Ue(2),
  DEFAULT: Ue(4),
  md: Ue(6),
  lg: Ue(8),
  xl: Ue(12),
  "2xl": Ue(16),
  "3xl": Ue(24),
  full: Ue(120)
}, fs = {
  none: Ue(0),
  xxxs: Ue(2),
  xxs: Ue(4),
  xs: Ue(8),
  sm: Ue(12),
  md: Ue(16),
  lg: Ue(24),
  xl: Ue(32),
  "2xl": Ue(48)
}, ds = {
  0: "0",
  8: "0.08",
  12: "0.12",
  16: "0.16",
  40: "0.4",
  60: "0.6",
  80: "0.8",
  100: "1"
}, vs = {
  "text-label-sm": [
    "11px",
    {
      lineHeight: "16px",
      letterSpacing: "0.2px",
      fontWeight: 500
    }
  ],
  "text-label-md": [
    "12px",
    {
      lineHeight: "16px",
      letterSpacing: "-0.1px",
      fontWeight: 500
    }
  ],
  "text-label-lg": [
    "14px",
    {
      lineHeight: "20px",
      letterSpacing: "-0.1px",
      fontWeight: 500
    }
  ]
}, ms = {
  "text-body-sm": [
    "12px",
    {
      lineHeight: "16px",
      letterSpacing: "0.1px",
      fontWeight: 400
    }
  ],
  "text-body-md": [
    "14px",
    {
      lineHeight: "20px",
      letterSpacing: "-0.1px",
      fontWeight: 400
    }
  ],
  "text-body-lg": [
    "16px",
    {
      lineHeight: "24px",
      letterSpacing: "0.1px",
      fontWeight: 400
    }
  ]
}, hs = {
  "text-body-ds-sm": [
    "12px",
    {
      lineHeight: "16px",
      letterSpacing: "0.1px",
      fontWeight: 400
    }
  ],
  "text-body-ds-md": [
    "14px",
    {
      lineHeight: "20px",
      letterSpacing: "-0.1px",
      fontWeight: 400
    }
  ],
  "text-body-ds-lg": [
    "16px",
    {
      lineHeight: "24px",
      letterSpacing: "0.2px",
      fontWeight: 400
    }
  ]
}, ps = {
  "text-title-sm": [
    "14px",
    {
      lineHeight: "120%",
      letterSpacing: "-0.1px",
      fontWeight: 500
    }
  ],
  "text-title-md": [
    "16px",
    {
      lineHeight: "120%",
      letterSpacing: "-0.15px",
      fontWeight: 500
    }
  ],
  "text-title-lg": [
    "20px",
    {
      lineHeight: "120%",
      letterSpacing: "-0.4px",
      fontWeight: 500
    }
  ]
}, gs = {
  "text-headline-sm": [
    "24px",
    {
      lineHeight: "120%",
      letterSpacing: "-0.2px",
      fontWeight: 500
    }
  ],
  "text-headline-md": [
    "28px",
    {
      lineHeight: "120%",
      letterSpacing: "-0.4px",
      fontWeight: 500
    }
  ],
  "text-headline-lg": [
    "32px",
    {
      lineHeight: "120%",
      letterSpacing: "-0.4px",
      fontWeight: 500
    }
  ]
}, xs = {
  "text-display-sm": [
    "36px",
    {
      lineHeight: "120%",
      fontWeight: 500
    }
  ],
  "text-display-md": [
    "48px",
    {
      lineHeight: "120%",
      fontWeight: 500
    }
  ],
  "text-display-lg": [
    "60px",
    {
      lineHeight: "120%",
      fontWeight: 500
    }
  ]
}, bs = {
  ...vs,
  ...ms,
  ...hs,
  ...ps,
  ...gs,
  ...xs
}, ys = Object.entries(bs).reduce(
  (e, [t, r]) => {
    const n = t.startsWith("text-") ? t.replace("text-", "") : t;
    return { ...e, [n]: r };
  },
  {}
), Ai = {
  "xs--rs": ["4px", "8px"],
  "sm--rs": ["8px", "12px"],
  "md--rs": ["16px", "24px"]
};
function _s(e, t) {
  const r = [
    Bt.Sm,
    Bt.Md,
    Bt.Lg,
    Bt.Xl
  ], n = Ai[e];
  let i = `${n[0]}`;
  for (let s = 1; s < n.length; s++)
    if (n[s]) {
      const u = t[r[s]];
      u && (i = `clamp(${i}, (100vw - ${u}) * 99, ${n[s]})`);
    }
  return i;
}
function ws(e) {
  return Object.keys(Ai).reduce((r, n) => {
    const i = _s(
      n,
      e
    );
    return {
      ...r,
      [n]: i
    };
  }, {});
}
var xn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _a(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Di = {}, Ii = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  function t(n, i) {
    return {
      handler: n,
      config: i
    };
  }
  t.withOptions = function(n, i = () => ({})) {
    const s = function(u) {
      return {
        __options: u,
        handler: n(u),
        config: i(u)
      };
    };
    return s.__isOptionsFunction = !0, s.__pluginFunction = n, s.__configFunction = i, s;
  };
  const r = t;
})(Ii);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  const t = /* @__PURE__ */ r(Ii);
  function r(i) {
    return i.__esModule ? i : {
      default: i
    };
  }
  const n = t.default;
})(Di);
let Jn = Di;
var Es = (Jn.__esModule ? Jn : { default: Jn }).default;
const Ss = /* @__PURE__ */ _a(Es), Cs = Ss(({ addVariant: e }) => {
  e("firefox", "@-moz-document url-prefix()");
}), Li = {
  content: ["./src/**/*.{html,js,jsx,ts,tsx}"],
  darkMode: "class",
  plugins: [Cs],
  theme: {
    extend: {
      fontSize: {
        ...ys
      },
      borderRadius: {
        ...cs
      },
      spacing: (e) => {
        const t = e.theme("screens"), r = ws(t);
        return {
          ...fs,
          ...r
        };
      },
      opacity: {
        ...ds,
        30: "0.3"
      },
      colors: {
        ...ls,
        ...us
      },
      fontFamily: {
        "alliance-no2": ["AllianceNo2", "sans-serif"],
        inter: ["Inter", "sans-serif"]
      }
    }
  }
};
var Pn = { exports: {} };
Pn.exports;
(function(e, t) {
  var r = 200, n = "__lodash_hash_undefined__", i = 800, s = 16, u = 9007199254740991, c = "[object Arguments]", h = "[object Array]", m = "[object AsyncFunction]", y = "[object Boolean]", x = "[object Date]", j = "[object Error]", R = "[object Function]", T = "[object GeneratorFunction]", k = "[object Map]", N = "[object Number]", P = "[object Null]", V = "[object Object]", D = "[object Proxy]", z = "[object RegExp]", H = "[object Set]", Y = "[object String]", W = "[object Undefined]", G = "[object WeakMap]", ce = "[object ArrayBuffer]", Ne = "[object DataView]", Ve = "[object Float32Array]", ze = "[object Float64Array]", Pe = "[object Int8Array]", Re = "[object Int16Array]", Ee = "[object Int32Array]", Q = "[object Uint8Array]", B = "[object Uint8ClampedArray]", re = "[object Uint16Array]", ye = "[object Uint32Array]", je = /[\\^$.*+?()[\]{}|]/g, _e = /^\[object .+?Constructor\]$/, g = /^(?:0|[1-9]\d*)$/, O = {};
  O[Ve] = O[ze] = O[Pe] = O[Re] = O[Ee] = O[Q] = O[B] = O[re] = O[ye] = !0, O[c] = O[h] = O[ce] = O[y] = O[Ne] = O[x] = O[j] = O[R] = O[k] = O[N] = O[V] = O[z] = O[H] = O[Y] = O[G] = !1;
  var ae = typeof xn == "object" && xn && xn.Object === Object && xn, fe = typeof self == "object" && self && self.Object === Object && self, oe = ae || fe || Function("return this")(), he = t && !t.nodeType && t, de = he && !0 && e && !e.nodeType && e, ge = de && de.exports === he, me = ge && ae.process, Ie = function() {
    try {
      var f = de && de.require && de.require("util").types;
      return f || me && me.binding && me.binding("util");
    } catch {
    }
  }(), mt = Ie && Ie.isTypedArray;
  function st(f, p, w) {
    switch (w.length) {
      case 0:
        return f.call(p);
      case 1:
        return f.call(p, w[0]);
      case 2:
        return f.call(p, w[0], w[1]);
      case 3:
        return f.call(p, w[0], w[1], w[2]);
    }
    return f.apply(p, w);
  }
  function It(f, p) {
    for (var w = -1, q = Array(f); ++w < f; )
      q[w] = p(w);
    return q;
  }
  function lt(f) {
    return function(p) {
      return f(p);
    };
  }
  function Qe(f, p) {
    return f == null ? void 0 : f[p];
  }
  function U(f, p) {
    return function(w) {
      return f(p(w));
    };
  }
  var K = Array.prototype, ne = Function.prototype, se = Object.prototype, Oe = oe["__core-js_shared__"], xe = ne.toString, le = se.hasOwnProperty, Ke = function() {
    var f = /[^.]+$/.exec(Oe && Oe.keys && Oe.keys.IE_PROTO || "");
    return f ? "Symbol(src)_1." + f : "";
  }(), He = se.toString, Xe = xe.call(Object), it = RegExp(
    "^" + xe.call(le).replace(je, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), ht = ge ? oe.Buffer : void 0, Lt = oe.Symbol, St = oe.Uint8Array;
  ht && ht.allocUnsafe;
  var pt = U(Object.getPrototypeOf, Object), $t = Object.create, rr = se.propertyIsEnumerable, nr = K.splice, Je = Lt ? Lt.toStringTag : void 0, gt = function() {
    try {
      var f = lr(Object, "defineProperty");
      return f({}, "", {}), f;
    } catch {
    }
  }(), ar = ht ? ht.isBuffer : void 0, Ct = Math.max, xt = Date.now, ot = lr(oe, "Map"), Ze = lr(Object, "create"), ut = /* @__PURE__ */ function() {
    function f() {
    }
    return function(p) {
      if (!Ot(p))
        return {};
      if ($t)
        return $t(p);
      f.prototype = p;
      var w = new f();
      return f.prototype = void 0, w;
    };
  }();
  function qe(f) {
    var p = -1, w = f == null ? 0 : f.length;
    for (this.clear(); ++p < w; ) {
      var q = f[p];
      this.set(q[0], q[1]);
    }
  }
  function bt() {
    this.__data__ = Ze ? Ze(null) : {}, this.size = 0;
  }
  function Gt(f) {
    var p = this.has(f) && delete this.__data__[f];
    return this.size -= p ? 1 : 0, p;
  }
  function Ht(f) {
    var p = this.__data__;
    if (Ze) {
      var w = p[f];
      return w === n ? void 0 : w;
    }
    return le.call(p, f) ? p[f] : void 0;
  }
  function Yt(f) {
    var p = this.__data__;
    return Ze ? p[f] !== void 0 : le.call(p, f);
  }
  function Mt(f, p) {
    var w = this.__data__;
    return this.size += this.has(f) ? 0 : 1, w[f] = Ze && p === void 0 ? n : p, this;
  }
  qe.prototype.clear = bt, qe.prototype.delete = Gt, qe.prototype.get = Ht, qe.prototype.has = Yt, qe.prototype.set = Mt;
  function rt(f) {
    var p = -1, w = f == null ? 0 : f.length;
    for (this.clear(); ++p < w; ) {
      var q = f[p];
      this.set(q[0], q[1]);
    }
  }
  function yt() {
    this.__data__ = [], this.size = 0;
  }
  function jt(f) {
    var p = this.__data__, w = $e(p, f);
    if (w < 0)
      return !1;
    var q = p.length - 1;
    return w == q ? p.pop() : nr.call(p, w, 1), --this.size, !0;
  }
  function Rt(f) {
    var p = this.__data__, w = $e(p, f);
    return w < 0 ? void 0 : p[w][1];
  }
  function zt(f) {
    return $e(this.__data__, f) > -1;
  }
  function ir(f, p) {
    var w = this.__data__, q = $e(w, f);
    return q < 0 ? (++this.size, w.push([f, p])) : w[q][1] = p, this;
  }
  rt.prototype.clear = yt, rt.prototype.delete = jt, rt.prototype.get = Rt, rt.prototype.has = zt, rt.prototype.set = ir;
  function ct(f) {
    var p = -1, w = f == null ? 0 : f.length;
    for (this.clear(); ++p < w; ) {
      var q = f[p];
      this.set(q[0], q[1]);
    }
  }
  function or() {
    this.size = 0, this.__data__ = {
      hash: new qe(),
      map: new (ot || rt)(),
      string: new qe()
    };
  }
  function v(f) {
    var p = Ft(this, f).delete(f);
    return this.size -= p ? 1 : 0, p;
  }
  function l(f) {
    return Ft(this, f).get(f);
  }
  function b(f) {
    return Ft(this, f).has(f);
  }
  function S(f, p) {
    var w = Ft(this, f), q = w.size;
    return w.set(f, p), this.size += w.size == q ? 0 : 1, this;
  }
  ct.prototype.clear = or, ct.prototype.delete = v, ct.prototype.get = l, ct.prototype.has = b, ct.prototype.set = S;
  function F(f) {
    var p = this.__data__ = new rt(f);
    this.size = p.size;
  }
  function J() {
    this.__data__ = new rt(), this.size = 0;
  }
  function X(f) {
    var p = this.__data__, w = p.delete(f);
    return this.size = p.size, w;
  }
  function $(f) {
    return this.__data__.get(f);
  }
  function ee(f) {
    return this.__data__.has(f);
  }
  function ve(f, p) {
    var w = this.__data__;
    if (w instanceof rt) {
      var q = w.__data__;
      if (!ot || q.length < r - 1)
        return q.push([f, p]), this.size = ++w.size, this;
      w = this.__data__ = new ct(q);
    }
    return w.set(f, p), this.size = w.size, this;
  }
  F.prototype.clear = J, F.prototype.delete = X, F.prototype.get = $, F.prototype.has = ee, F.prototype.set = ve;
  function ie(f, p) {
    var w = Hr(f), q = !w && Sr(f), be = !w && !q && Yr(f), ke = !w && !q && !be && mn(f), De = w || q || be || ke, Se = De ? It(f.length, String) : [], a = Se.length;
    for (var d in f)
      De && // Safari 9 has enumerable `arguments.length` in strict mode.
      (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      be && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      ke && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
      Ur(d, a)) || Se.push(d);
    return Se;
  }
  function pe(f, p, w) {
    (w !== void 0 && !Er(f[p], w) || w === void 0 && !(p in f)) && Te(f, p, w);
  }
  function Fe(f, p, w) {
    var q = f[p];
    (!(le.call(f, p) && Er(q, w)) || w === void 0 && !(p in f)) && Te(f, p, w);
  }
  function $e(f, p) {
    for (var w = f.length; w--; )
      if (Er(f[w][0], p))
        return w;
    return -1;
  }
  function Te(f, p, w) {
    p == "__proto__" && gt ? gt(f, p, {
      configurable: !0,
      enumerable: !0,
      value: w,
      writable: !0
    }) : f[p] = w;
  }
  var We = Wr();
  function ft(f) {
    return f == null ? f === void 0 ? W : P : Je && Je in Object(f) ? yr(f) : wr(f);
  }
  function Kt(f) {
    return ur(f) && ft(f) == c;
  }
  function Fr(f) {
    if (!Ot(f) || _r(f))
      return !1;
    var p = zr(f) ? it : _e;
    return p.test(Kn(f));
  }
  function sr(f) {
    return ur(f) && Kr(f.length) && !!O[ft(f)];
  }
  function nn(f) {
    if (!Ot(f))
      return fn(f);
    var p = $r(f), w = [];
    for (var q in f)
      q == "constructor" && (p || !le.call(f, q)) || w.push(q);
    return w;
  }
  function Br(f, p, w, q, be) {
    f !== p && We(p, function(ke, De) {
      if (be || (be = new F()), Ot(ke))
        an(f, p, De, w, Br, q, be);
      else {
        var Se = q ? q(kt(f, De), ke, De + "", f, p, be) : void 0;
        Se === void 0 && (Se = ke), pe(f, De, Se);
      }
    }, cr);
  }
  function an(f, p, w, q, be, ke, De) {
    var Se = kt(f, w), a = kt(p, w), d = De.get(a);
    if (d) {
      pe(f, w, d);
      return;
    }
    var _ = ke ? ke(Se, a, w + "", f, p, De) : void 0, C = _ === void 0;
    if (C) {
      var M = Hr(a), te = !M && Yr(a), Z = !M && !te && mn(a);
      _ = a, M || te || Z ? Hr(Se) ? _ = Se : vn(Se) ? _ = Un(Se) : te ? (C = !1, _ = ln(a)) : Z ? (C = !1, _ = cn(a)) : _ = [] : Xn(a) || Sr(a) ? (_ = Se, Sr(Se) ? _ = hn(Se) : (!Ot(Se) || zr(Se)) && (_ = Gn(a))) : C = !1;
    }
    C && (De.set(a, _), be(_, a, q, ke, De), De.delete(a)), pe(f, w, _);
  }
  function on(f, p) {
    return Gr(zn(f, p, Xr), f + "");
  }
  var sn = gt ? function(f, p) {
    return gt(f, "toString", {
      configurable: !0,
      enumerable: !1,
      value: Xt(p),
      writable: !0
    });
  } : Xr;
  function ln(f, p) {
    return f.slice();
  }
  function un(f) {
    var p = new f.constructor(f.byteLength);
    return new St(p).set(new St(f)), p;
  }
  function cn(f, p) {
    var w = un(f.buffer);
    return new f.constructor(w, f.byteOffset, f.length);
  }
  function Un(f, p) {
    var w = -1, q = f.length;
    for (p || (p = Array(q)); ++w < q; )
      p[w] = f[w];
    return p;
  }
  function $n(f, p, w, q) {
    var be = !w;
    w || (w = {});
    for (var ke = -1, De = p.length; ++ke < De; ) {
      var Se = p[ke], a = void 0;
      a === void 0 && (a = f[Se]), be ? Te(w, Se, a) : Fe(w, Se, a);
    }
    return w;
  }
  function Vr(f) {
    return on(function(p, w) {
      var q = -1, be = w.length, ke = be > 1 ? w[be - 1] : void 0, De = be > 2 ? w[2] : void 0;
      for (ke = f.length > 3 && typeof ke == "function" ? (be--, ke) : void 0, De && Hn(w[0], w[1], De) && (ke = be < 3 ? void 0 : ke, be = 1), p = Object(p); ++q < be; ) {
        var Se = w[q];
        Se && f(p, Se, q, ke);
      }
      return p;
    });
  }
  function Wr(f) {
    return function(p, w, q) {
      for (var be = -1, ke = Object(p), De = q(p), Se = De.length; Se--; ) {
        var a = De[++be];
        if (w(ke[a], a, ke) === !1)
          break;
      }
      return p;
    };
  }
  function Ft(f, p) {
    var w = f.__data__;
    return Yn(p) ? w[typeof p == "string" ? "string" : "hash"] : w.map;
  }
  function lr(f, p) {
    var w = Qe(f, p);
    return Fr(w) ? w : void 0;
  }
  function yr(f) {
    var p = le.call(f, Je), w = f[Je];
    try {
      f[Je] = void 0;
      var q = !0;
    } catch {
    }
    var be = He.call(f);
    return q && (p ? f[Je] = w : delete f[Je]), be;
  }
  function Gn(f) {
    return typeof f.constructor == "function" && !$r(f) ? ut(pt(f)) : {};
  }
  function Ur(f, p) {
    var w = typeof f;
    return p = p ?? u, !!p && (w == "number" || w != "symbol" && g.test(f)) && f > -1 && f % 1 == 0 && f < p;
  }
  function Hn(f, p, w) {
    if (!Ot(w))
      return !1;
    var q = typeof p;
    return (q == "number" ? Cr(w) && Ur(p, w.length) : q == "string" && p in w) ? Er(w[p], f) : !1;
  }
  function Yn(f) {
    var p = typeof f;
    return p == "string" || p == "number" || p == "symbol" || p == "boolean" ? f !== "__proto__" : f === null;
  }
  function _r(f) {
    return !!Ke && Ke in f;
  }
  function $r(f) {
    var p = f && f.constructor, w = typeof p == "function" && p.prototype || se;
    return f === w;
  }
  function fn(f) {
    var p = [];
    if (f != null)
      for (var w in Object(f))
        p.push(w);
    return p;
  }
  function wr(f) {
    return He.call(f);
  }
  function zn(f, p, w) {
    return p = Ct(p === void 0 ? f.length - 1 : p, 0), function() {
      for (var q = arguments, be = -1, ke = Ct(q.length - p, 0), De = Array(ke); ++be < ke; )
        De[be] = q[p + be];
      be = -1;
      for (var Se = Array(p + 1); ++be < p; )
        Se[be] = q[be];
      return Se[p] = w(De), st(f, this, Se);
    };
  }
  function kt(f, p) {
    if (!(p === "constructor" && typeof f[p] == "function") && p != "__proto__")
      return f[p];
  }
  var Gr = dn(sn);
  function dn(f) {
    var p = 0, w = 0;
    return function() {
      var q = xt(), be = s - (q - w);
      if (w = q, be > 0) {
        if (++p >= i)
          return arguments[0];
      } else
        p = 0;
      return f.apply(void 0, arguments);
    };
  }
  function Kn(f) {
    if (f != null) {
      try {
        return xe.call(f);
      } catch {
      }
      try {
        return f + "";
      } catch {
      }
    }
    return "";
  }
  function Er(f, p) {
    return f === p || f !== f && p !== p;
  }
  var Sr = Kt(/* @__PURE__ */ function() {
    return arguments;
  }()) ? Kt : function(f) {
    return ur(f) && le.call(f, "callee") && !rr.call(f, "callee");
  }, Hr = Array.isArray;
  function Cr(f) {
    return f != null && Kr(f.length) && !zr(f);
  }
  function vn(f) {
    return ur(f) && Cr(f);
  }
  var Yr = ar || pn;
  function zr(f) {
    if (!Ot(f))
      return !1;
    var p = ft(f);
    return p == R || p == T || p == m || p == D;
  }
  function Kr(f) {
    return typeof f == "number" && f > -1 && f % 1 == 0 && f <= u;
  }
  function Ot(f) {
    var p = typeof f;
    return f != null && (p == "object" || p == "function");
  }
  function ur(f) {
    return f != null && typeof f == "object";
  }
  function Xn(f) {
    if (!ur(f) || ft(f) != V)
      return !1;
    var p = pt(f);
    if (p === null)
      return !0;
    var w = le.call(p, "constructor") && p.constructor;
    return typeof w == "function" && w instanceof w && xe.call(w) == Xe;
  }
  var mn = mt ? lt(mt) : sr;
  function hn(f) {
    return $n(f, cr(f));
  }
  function cr(f) {
    return Cr(f) ? ie(f) : nn(f);
  }
  var Zn = Vr(function(f, p, w) {
    Br(f, p, w);
  });
  function Xt(f) {
    return function() {
      return f;
    };
  }
  function Xr(f) {
    return f;
  }
  function pn() {
    return !1;
  }
  e.exports = Zn;
})(Pn, Pn.exports);
var js = Pn.exports;
const Mi = /* @__PURE__ */ _a(js), Rs = {
  [Bt.Sm]: 768,
  [Bt.Md]: 1024,
  [Bt.Lg]: 1400,
  [Bt.Xl]: 1920
}, La = Pi(Rs), Zf = Mi({}, Li, {
  theme: {
    screens: La,
    container: {
      center: !0,
      screens: La,
      padding: {
        DEFAULT: Ue(20),
        md: Ue(48),
        lg: Ue(120),
        xl: Ue(240)
      }
    }
  }
}), ks = {
  default: 0
}, Os = Pi(ks), qf = Mi({}, Li, {
  theme: {
    screens: Os
  },
  corePlugins: {
    container: !1
  }
});
var ha = { exports: {} }, Zr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ma;
function Ts() {
  if (Ma) return Zr;
  Ma = 1;
  var e = qt, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(c, h, m) {
    var y, x = {}, j = null, R = null;
    m !== void 0 && (j = "" + m), h.key !== void 0 && (j = "" + h.key), h.ref !== void 0 && (R = h.ref);
    for (y in h) n.call(h, y) && !s.hasOwnProperty(y) && (x[y] = h[y]);
    if (c && c.defaultProps) for (y in h = c.defaultProps, h) x[y] === void 0 && (x[y] = h[y]);
    return { $$typeof: t, type: c, key: j, ref: R, props: x, _owner: i.current };
  }
  return Zr.Fragment = r, Zr.jsx = u, Zr.jsxs = u, Zr;
}
var qr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fa;
function Ns() {
  return Fa || (Fa = 1, process.env.NODE_ENV !== "production" && function() {
    var e = qt, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), c = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), y = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), j = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), T = Symbol.iterator, k = "@@iterator";
    function N(v) {
      if (v === null || typeof v != "object")
        return null;
      var l = T && v[T] || v[k];
      return typeof l == "function" ? l : null;
    }
    var P = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function V(v) {
      {
        for (var l = arguments.length, b = new Array(l > 1 ? l - 1 : 0), S = 1; S < l; S++)
          b[S - 1] = arguments[S];
        D("error", v, b);
      }
    }
    function D(v, l, b) {
      {
        var S = P.ReactDebugCurrentFrame, F = S.getStackAddendum();
        F !== "" && (l += "%s", b = b.concat([F]));
        var J = b.map(function(X) {
          return String(X);
        });
        J.unshift("Warning: " + l), Function.prototype.apply.call(console[v], console, J);
      }
    }
    var z = !1, H = !1, Y = !1, W = !1, G = !1, ce;
    ce = Symbol.for("react.module.reference");
    function Ne(v) {
      return !!(typeof v == "string" || typeof v == "function" || v === n || v === s || G || v === i || v === m || v === y || W || v === R || z || H || Y || typeof v == "object" && v !== null && (v.$$typeof === j || v.$$typeof === x || v.$$typeof === u || v.$$typeof === c || v.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      v.$$typeof === ce || v.getModuleId !== void 0));
    }
    function Ve(v, l, b) {
      var S = v.displayName;
      if (S)
        return S;
      var F = l.displayName || l.name || "";
      return F !== "" ? b + "(" + F + ")" : b;
    }
    function ze(v) {
      return v.displayName || "Context";
    }
    function Pe(v) {
      if (v == null)
        return null;
      if (typeof v.tag == "number" && V("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof v == "function")
        return v.displayName || v.name || null;
      if (typeof v == "string")
        return v;
      switch (v) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case s:
          return "Profiler";
        case i:
          return "StrictMode";
        case m:
          return "Suspense";
        case y:
          return "SuspenseList";
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case c:
            var l = v;
            return ze(l) + ".Consumer";
          case u:
            var b = v;
            return ze(b._context) + ".Provider";
          case h:
            return Ve(v, v.render, "ForwardRef");
          case x:
            var S = v.displayName || null;
            return S !== null ? S : Pe(v.type) || "Memo";
          case j: {
            var F = v, J = F._payload, X = F._init;
            try {
              return Pe(X(J));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Re = Object.assign, Ee = 0, Q, B, re, ye, je, _e, g;
    function O() {
    }
    O.__reactDisabledLog = !0;
    function ae() {
      {
        if (Ee === 0) {
          Q = console.log, B = console.info, re = console.warn, ye = console.error, je = console.group, _e = console.groupCollapsed, g = console.groupEnd;
          var v = {
            configurable: !0,
            enumerable: !0,
            value: O,
            writable: !0
          };
          Object.defineProperties(console, {
            info: v,
            log: v,
            warn: v,
            error: v,
            group: v,
            groupCollapsed: v,
            groupEnd: v
          });
        }
        Ee++;
      }
    }
    function fe() {
      {
        if (Ee--, Ee === 0) {
          var v = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Re({}, v, {
              value: Q
            }),
            info: Re({}, v, {
              value: B
            }),
            warn: Re({}, v, {
              value: re
            }),
            error: Re({}, v, {
              value: ye
            }),
            group: Re({}, v, {
              value: je
            }),
            groupCollapsed: Re({}, v, {
              value: _e
            }),
            groupEnd: Re({}, v, {
              value: g
            })
          });
        }
        Ee < 0 && V("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var oe = P.ReactCurrentDispatcher, he;
    function de(v, l, b) {
      {
        if (he === void 0)
          try {
            throw Error();
          } catch (F) {
            var S = F.stack.trim().match(/\n( *(at )?)/);
            he = S && S[1] || "";
          }
        return `
` + he + v;
      }
    }
    var ge = !1, me;
    {
      var Ie = typeof WeakMap == "function" ? WeakMap : Map;
      me = new Ie();
    }
    function mt(v, l) {
      if (!v || ge)
        return "";
      {
        var b = me.get(v);
        if (b !== void 0)
          return b;
      }
      var S;
      ge = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var J;
      J = oe.current, oe.current = null, ae();
      try {
        if (l) {
          var X = function() {
            throw Error();
          };
          if (Object.defineProperty(X.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(X, []);
            } catch (Te) {
              S = Te;
            }
            Reflect.construct(v, [], X);
          } else {
            try {
              X.call();
            } catch (Te) {
              S = Te;
            }
            v.call(X.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Te) {
            S = Te;
          }
          v();
        }
      } catch (Te) {
        if (Te && S && typeof Te.stack == "string") {
          for (var $ = Te.stack.split(`
`), ee = S.stack.split(`
`), ve = $.length - 1, ie = ee.length - 1; ve >= 1 && ie >= 0 && $[ve] !== ee[ie]; )
            ie--;
          for (; ve >= 1 && ie >= 0; ve--, ie--)
            if ($[ve] !== ee[ie]) {
              if (ve !== 1 || ie !== 1)
                do
                  if (ve--, ie--, ie < 0 || $[ve] !== ee[ie]) {
                    var pe = `
` + $[ve].replace(" at new ", " at ");
                    return v.displayName && pe.includes("<anonymous>") && (pe = pe.replace("<anonymous>", v.displayName)), typeof v == "function" && me.set(v, pe), pe;
                  }
                while (ve >= 1 && ie >= 0);
              break;
            }
        }
      } finally {
        ge = !1, oe.current = J, fe(), Error.prepareStackTrace = F;
      }
      var Fe = v ? v.displayName || v.name : "", $e = Fe ? de(Fe) : "";
      return typeof v == "function" && me.set(v, $e), $e;
    }
    function st(v, l, b) {
      return mt(v, !1);
    }
    function It(v) {
      var l = v.prototype;
      return !!(l && l.isReactComponent);
    }
    function lt(v, l, b) {
      if (v == null)
        return "";
      if (typeof v == "function")
        return mt(v, It(v));
      if (typeof v == "string")
        return de(v);
      switch (v) {
        case m:
          return de("Suspense");
        case y:
          return de("SuspenseList");
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case h:
            return st(v.render);
          case x:
            return lt(v.type, l, b);
          case j: {
            var S = v, F = S._payload, J = S._init;
            try {
              return lt(J(F), l, b);
            } catch {
            }
          }
        }
      return "";
    }
    var Qe = Object.prototype.hasOwnProperty, U = {}, K = P.ReactDebugCurrentFrame;
    function ne(v) {
      if (v) {
        var l = v._owner, b = lt(v.type, v._source, l ? l.type : null);
        K.setExtraStackFrame(b);
      } else
        K.setExtraStackFrame(null);
    }
    function se(v, l, b, S, F) {
      {
        var J = Function.call.bind(Qe);
        for (var X in v)
          if (J(v, X)) {
            var $ = void 0;
            try {
              if (typeof v[X] != "function") {
                var ee = Error((S || "React class") + ": " + b + " type `" + X + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[X] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              $ = v[X](l, X, S, b, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ve) {
              $ = ve;
            }
            $ && !($ instanceof Error) && (ne(F), V("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", S || "React class", b, X, typeof $), ne(null)), $ instanceof Error && !($.message in U) && (U[$.message] = !0, ne(F), V("Failed %s type: %s", b, $.message), ne(null));
          }
      }
    }
    var Oe = Array.isArray;
    function xe(v) {
      return Oe(v);
    }
    function le(v) {
      {
        var l = typeof Symbol == "function" && Symbol.toStringTag, b = l && v[Symbol.toStringTag] || v.constructor.name || "Object";
        return b;
      }
    }
    function Ke(v) {
      try {
        return He(v), !1;
      } catch {
        return !0;
      }
    }
    function He(v) {
      return "" + v;
    }
    function Xe(v) {
      if (Ke(v))
        return V("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", le(v)), He(v);
    }
    var it = P.ReactCurrentOwner, ht = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Lt, St;
    function pt(v) {
      if (Qe.call(v, "ref")) {
        var l = Object.getOwnPropertyDescriptor(v, "ref").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return v.ref !== void 0;
    }
    function $t(v) {
      if (Qe.call(v, "key")) {
        var l = Object.getOwnPropertyDescriptor(v, "key").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return v.key !== void 0;
    }
    function rr(v, l) {
      typeof v.ref == "string" && it.current;
    }
    function nr(v, l) {
      {
        var b = function() {
          Lt || (Lt = !0, V("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        b.isReactWarning = !0, Object.defineProperty(v, "key", {
          get: b,
          configurable: !0
        });
      }
    }
    function Je(v, l) {
      {
        var b = function() {
          St || (St = !0, V("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        b.isReactWarning = !0, Object.defineProperty(v, "ref", {
          get: b,
          configurable: !0
        });
      }
    }
    var gt = function(v, l, b, S, F, J, X) {
      var $ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: v,
        key: l,
        ref: b,
        props: X,
        // Record the component responsible for creating this element.
        _owner: J
      };
      return $._store = {}, Object.defineProperty($._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty($, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: S
      }), Object.defineProperty($, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze($.props), Object.freeze($)), $;
    };
    function ar(v, l, b, S, F) {
      {
        var J, X = {}, $ = null, ee = null;
        b !== void 0 && (Xe(b), $ = "" + b), $t(l) && (Xe(l.key), $ = "" + l.key), pt(l) && (ee = l.ref, rr(l, F));
        for (J in l)
          Qe.call(l, J) && !ht.hasOwnProperty(J) && (X[J] = l[J]);
        if (v && v.defaultProps) {
          var ve = v.defaultProps;
          for (J in ve)
            X[J] === void 0 && (X[J] = ve[J]);
        }
        if ($ || ee) {
          var ie = typeof v == "function" ? v.displayName || v.name || "Unknown" : v;
          $ && nr(X, ie), ee && Je(X, ie);
        }
        return gt(v, $, ee, F, S, it.current, X);
      }
    }
    var Ct = P.ReactCurrentOwner, xt = P.ReactDebugCurrentFrame;
    function ot(v) {
      if (v) {
        var l = v._owner, b = lt(v.type, v._source, l ? l.type : null);
        xt.setExtraStackFrame(b);
      } else
        xt.setExtraStackFrame(null);
    }
    var Ze;
    Ze = !1;
    function ut(v) {
      return typeof v == "object" && v !== null && v.$$typeof === t;
    }
    function qe() {
      {
        if (Ct.current) {
          var v = Pe(Ct.current.type);
          if (v)
            return `

Check the render method of \`` + v + "`.";
        }
        return "";
      }
    }
    function bt(v) {
      return "";
    }
    var Gt = {};
    function Ht(v) {
      {
        var l = qe();
        if (!l) {
          var b = typeof v == "string" ? v : v.displayName || v.name;
          b && (l = `

Check the top-level render call using <` + b + ">.");
        }
        return l;
      }
    }
    function Yt(v, l) {
      {
        if (!v._store || v._store.validated || v.key != null)
          return;
        v._store.validated = !0;
        var b = Ht(l);
        if (Gt[b])
          return;
        Gt[b] = !0;
        var S = "";
        v && v._owner && v._owner !== Ct.current && (S = " It was passed a child from " + Pe(v._owner.type) + "."), ot(v), V('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', b, S), ot(null);
      }
    }
    function Mt(v, l) {
      {
        if (typeof v != "object")
          return;
        if (xe(v))
          for (var b = 0; b < v.length; b++) {
            var S = v[b];
            ut(S) && Yt(S, l);
          }
        else if (ut(v))
          v._store && (v._store.validated = !0);
        else if (v) {
          var F = N(v);
          if (typeof F == "function" && F !== v.entries)
            for (var J = F.call(v), X; !(X = J.next()).done; )
              ut(X.value) && Yt(X.value, l);
        }
      }
    }
    function rt(v) {
      {
        var l = v.type;
        if (l == null || typeof l == "string")
          return;
        var b;
        if (typeof l == "function")
          b = l.propTypes;
        else if (typeof l == "object" && (l.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        l.$$typeof === x))
          b = l.propTypes;
        else
          return;
        if (b) {
          var S = Pe(l);
          se(b, v.props, "prop", S, v);
        } else if (l.PropTypes !== void 0 && !Ze) {
          Ze = !0;
          var F = Pe(l);
          V("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof l.getDefaultProps == "function" && !l.getDefaultProps.isReactClassApproved && V("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function yt(v) {
      {
        for (var l = Object.keys(v.props), b = 0; b < l.length; b++) {
          var S = l[b];
          if (S !== "children" && S !== "key") {
            ot(v), V("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", S), ot(null);
            break;
          }
        }
        v.ref !== null && (ot(v), V("Invalid attribute `ref` supplied to `React.Fragment`."), ot(null));
      }
    }
    var jt = {};
    function Rt(v, l, b, S, F, J) {
      {
        var X = Ne(v);
        if (!X) {
          var $ = "";
          (v === void 0 || typeof v == "object" && v !== null && Object.keys(v).length === 0) && ($ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = bt();
          ee ? $ += ee : $ += qe();
          var ve;
          v === null ? ve = "null" : xe(v) ? ve = "array" : v !== void 0 && v.$$typeof === t ? (ve = "<" + (Pe(v.type) || "Unknown") + " />", $ = " Did you accidentally export a JSX literal instead of a component?") : ve = typeof v, V("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ve, $);
        }
        var ie = ar(v, l, b, F, J);
        if (ie == null)
          return ie;
        if (X) {
          var pe = l.children;
          if (pe !== void 0)
            if (S)
              if (xe(pe)) {
                for (var Fe = 0; Fe < pe.length; Fe++)
                  Mt(pe[Fe], v);
                Object.freeze && Object.freeze(pe);
              } else
                V("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Mt(pe, v);
        }
        if (Qe.call(l, "key")) {
          var $e = Pe(v), Te = Object.keys(l).filter(function(Kt) {
            return Kt !== "key";
          }), We = Te.length > 0 ? "{key: someKey, " + Te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!jt[$e + We]) {
            var ft = Te.length > 0 ? "{" + Te.join(": ..., ") + ": ...}" : "{}";
            V(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, We, $e, ft, $e), jt[$e + We] = !0;
          }
        }
        return v === n ? yt(ie) : rt(ie), ie;
      }
    }
    function zt(v, l, b) {
      return Rt(v, l, b, !0);
    }
    function ir(v, l, b) {
      return Rt(v, l, b, !1);
    }
    var ct = ir, or = zt;
    qr.Fragment = n, qr.jsx = ct, qr.jsxs = or;
  }()), qr;
}
process.env.NODE_ENV === "production" ? ha.exports = Ts() : ha.exports = Ns();
var o = ha.exports, Fi = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var s = "", u = 0; u < arguments.length; u++) {
        var c = arguments[u];
        c && (s = i(s, n(c)));
      }
      return s;
    }
    function n(s) {
      if (typeof s == "string" || typeof s == "number")
        return s;
      if (typeof s != "object")
        return "";
      if (Array.isArray(s))
        return r.apply(null, s);
      if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]"))
        return s.toString();
      var u = "";
      for (var c in s)
        t.call(s, c) && s[c] && (u = i(u, c));
      return u;
    }
    function i(s, u) {
      return u ? s ? s + " " + u : s + u : s;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(Fi);
var Ps = Fi.exports;
const A = /* @__PURE__ */ _a(Ps);
var Ge = /* @__PURE__ */ ((e) => (e.Neutral = "neutral", e.PrimarySolid = "primary-solid", e.PrimarySoft = "primary-fill", e.Success = "success", e.Warning = "warning", e.Error = "error", e))(Ge || {});
const As = {
  [Ge.PrimarySolid]: "bg-primary-30",
  [Ge.Neutral]: "bg-neutral-92 dark:bg-neutral-12",
  [Ge.PrimarySoft]: "bg-primary-90 dark:bg-primary-10",
  [Ge.Success]: "bg-tertiary-90 dark:bg-tertiary-10",
  [Ge.Warning]: "bg-warning-90 dark:bg-warning-20",
  [Ge.Error]: "bg-error-90 dark:bg-error-10"
}, Ds = {
  [Ge.PrimarySolid]: "text-primary-100",
  [Ge.Neutral]: "text-neutral-10 dark:text-neutral-92",
  [Ge.PrimarySoft]: "text-primary-20 dark:text-primary-90",
  [Ge.Success]: "text-tertiary-20 dark:text-tertiary-90",
  [Ge.Warning]: "text-warning-10 dark:text-warning-90",
  [Ge.Error]: "text-error-20 dark:text-error-90"
}, Is = {
  [Ge.PrimarySolid]: "border-primary-30",
  [Ge.Neutral]: "border-neutral-92 dark:border-neutral-12",
  [Ge.PrimarySoft]: "border-primary-90 dark:border-primary-10",
  [Ge.Success]: "border-tertiary-90 dark:border-tertiary-10",
  [Ge.Warning]: "border-warning-90 dark:border-warning-20",
  [Ge.Error]: "border-error-90 dark:border-error-10"
}, Ls = "text-label-md";
function An({ type: e, label: t }) {
  const r = As[e], n = Ds[e], i = Is[e], s = t ? "px-xs py-xxs" : "h-1.5 w-1.5";
  return /* @__PURE__ */ o.jsx(
    "div",
    {
      className: A(
        "inline-flex items-center space-x-2 rounded-full border disabled:opacity-30",
        r,
        i,
        s
      ),
      children: /* @__PURE__ */ o.jsx("span", { className: A(Ls, n), children: t })
    }
  );
}
var tt = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(tt || {}), Ce = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e.Ghost = "ghost", e.Outlined = "outlined", e.Destructive = "destructive", e))(Ce || {}), Mn = /* @__PURE__ */ ((e) => (e.Button = "button", e.Submit = "submit", e.Reset = "reset", e))(Mn || {});
const Ms = {
  [tt.Small]: "px-md py-xs",
  [tt.Medium]: "px-md py-sm"
}, Fs = {
  [tt.Small]: "p-xs",
  [tt.Medium]: "p-sm"
}, Bs = {
  [Ce.Primary]: "bg-primary-30",
  [Ce.Secondary]: "bg-neutral-90 dark:bg-neutral-20",
  [Ce.Ghost]: "bg-transparent",
  [Ce.Outlined]: "bg-transparent border border-neutral-50",
  [Ce.Destructive]: "bg-error-90 dark:bg-error-20"
}, Vs = {
  [Ce.Primary]: "bg-neutral-80 dark:bg-neutral-30",
  [Ce.Secondary]: "bg-neutral-90 dark:bg-neutral-20",
  [Ce.Ghost]: "bg-transparent",
  [Ce.Outlined]: "bg-transparent border border-neutral-50",
  [Ce.Destructive]: "bg-error-90 dark:bg-error-20"
}, vr = "text-neutral-10 dark:text-neutral-92", Ws = {
  [Ce.Primary]: "text-primary-100",
  [Ce.Secondary]: vr,
  [Ce.Ghost]: vr,
  [Ce.Outlined]: vr,
  [Ce.Destructive]: "text-error-20 dark:text-error-90"
}, Us = {
  [tt.Small]: "text-label-md",
  [tt.Medium]: "text-label-lg"
}, $s = {
  [Ce.Primary]: vr,
  [Ce.Secondary]: vr,
  [Ce.Ghost]: vr,
  [Ce.Outlined]: vr,
  [Ce.Destructive]: "text-error-20 dark:text-error-90"
};
function _t({
  icon: e,
  text: t,
  disabled: r,
  onClick: n,
  fullWidth: i,
  htmlType: s = Mn.Button,
  size: u = tt.Medium,
  type: c = Ce.Primary,
  iconAfterText: h = !1,
  tabIndex: m = 0,
  testId: y
}) {
  const x = e && !t ? Fs[u] : Ms[u], j = Us[u], R = r ? Vs[c] : Bs[c], T = r ? $s[c] : Ws[c];
  return /* @__PURE__ */ o.jsxs(
    "button",
    {
      onClick: n,
      type: s,
      className: A(
        "state-layer relative flex items-center justify-center gap-2 rounded-full transition-all duration-150 ease-in disabled:cursor-not-allowed disabled:opacity-40",
        x,
        R,
        i && "w-full",
        h ? "flex-row-reverse" : "flex-row"
      ),
      disabled: r,
      tabIndex: m,
      "data-testid": y,
      children: [
        e && /* @__PURE__ */ o.jsx("span", { className: A(T), children: e }),
        t && /* @__PURE__ */ o.jsx("span", { className: A("font-inter", T, j), children: t })
      ]
    }
  );
}
function Jf({
  htmlType: e = Mn.Button,
  children: t,
  tabIndex: r = 0,
  ...n
}) {
  return /* @__PURE__ */ o.jsx(
    "button",
    {
      className: "flex items-center justify-center rounded-xl border border-neutral-70 px-sm text-body-md text-neutral-40 disabled:opacity-40 dark:border-neutral-40 dark:text-neutral-60",
      type: e,
      tabIndex: r,
      ...n,
      children: t
    }
  );
}
function nt({
  htmlType: e = Mn.Button,
  children: t,
  className: r,
  tabIndex: n = 0,
  testId: i,
  ...s
}) {
  return /* @__PURE__ */ o.jsx(
    "button",
    {
      type: e,
      ...s,
      className: A("appearance-none", r),
      tabIndex: n,
      "data-testid": i,
      children: t
    }
  );
}
var Gs = Object.create, Bi = Object.defineProperty, Hs = Object.getOwnPropertyDescriptor, Vi = Object.getOwnPropertyNames, Ys = Object.getPrototypeOf, zs = Object.prototype.hasOwnProperty, Lr = (e, t) => function() {
  return t || (0, e[Vi(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, Ks = (e, t, r, n) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let i of Vi(t))
      !zs.call(e, i) && i !== r && Bi(e, i, { get: () => t[i], enumerable: !(n = Hs(t, i)) || n.enumerable });
  return e;
}, I = (e, t, r) => (r = e != null ? Gs(Ys(e)) : {}, Ks(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  !e || !e.__esModule ? Bi(r, "default", { value: e, enumerable: !0 }) : r,
  e
)), Xs = Lr({
  "../../node_modules/.pnpm/react@18.3.1/node_modules/react/cjs/react.production.min.js"(e) {
    var t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), c = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), y = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), j = Symbol.iterator;
    function R(g) {
      return g === null || typeof g != "object" ? null : (g = j && g[j] || g["@@iterator"], typeof g == "function" ? g : null);
    }
    var T = { isMounted: function() {
      return !1;
    }, enqueueForceUpdate: function() {
    }, enqueueReplaceState: function() {
    }, enqueueSetState: function() {
    } }, k = Object.assign, N = {};
    function P(g, O, ae) {
      this.props = g, this.context = O, this.refs = N, this.updater = ae || T;
    }
    P.prototype.isReactComponent = {}, P.prototype.setState = function(g, O) {
      if (typeof g != "object" && typeof g != "function" && g != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
      this.updater.enqueueSetState(this, g, O, "setState");
    }, P.prototype.forceUpdate = function(g) {
      this.updater.enqueueForceUpdate(this, g, "forceUpdate");
    };
    function V() {
    }
    V.prototype = P.prototype;
    function D(g, O, ae) {
      this.props = g, this.context = O, this.refs = N, this.updater = ae || T;
    }
    var z = D.prototype = new V();
    z.constructor = D, k(z, P.prototype), z.isPureReactComponent = !0;
    var H = Array.isArray, Y = Object.prototype.hasOwnProperty, W = { current: null }, G = { key: !0, ref: !0, __self: !0, __source: !0 };
    function ce(g, O, ae) {
      var fe, oe = {}, he = null, de = null;
      if (O != null) for (fe in O.ref !== void 0 && (de = O.ref), O.key !== void 0 && (he = "" + O.key), O) Y.call(O, fe) && !G.hasOwnProperty(fe) && (oe[fe] = O[fe]);
      var ge = arguments.length - 2;
      if (ge === 1) oe.children = ae;
      else if (1 < ge) {
        for (var me = Array(ge), Ie = 0; Ie < ge; Ie++) me[Ie] = arguments[Ie + 2];
        oe.children = me;
      }
      if (g && g.defaultProps) for (fe in ge = g.defaultProps, ge) oe[fe] === void 0 && (oe[fe] = ge[fe]);
      return { $$typeof: t, type: g, key: he, ref: de, props: oe, _owner: W.current };
    }
    function Ne(g, O) {
      return { $$typeof: t, type: g.type, key: O, ref: g.ref, props: g.props, _owner: g._owner };
    }
    function Ve(g) {
      return typeof g == "object" && g !== null && g.$$typeof === t;
    }
    function ze(g) {
      var O = { "=": "=0", ":": "=2" };
      return "$" + g.replace(/[=:]/g, function(ae) {
        return O[ae];
      });
    }
    var Pe = /\/+/g;
    function Re(g, O) {
      return typeof g == "object" && g !== null && g.key != null ? ze("" + g.key) : O.toString(36);
    }
    function Ee(g, O, ae, fe, oe) {
      var he = typeof g;
      (he === "undefined" || he === "boolean") && (g = null);
      var de = !1;
      if (g === null) de = !0;
      else switch (he) {
        case "string":
        case "number":
          de = !0;
          break;
        case "object":
          switch (g.$$typeof) {
            case t:
            case r:
              de = !0;
          }
      }
      if (de) return de = g, oe = oe(de), g = fe === "" ? "." + Re(de, 0) : fe, H(oe) ? (ae = "", g != null && (ae = g.replace(Pe, "$&/") + "/"), Ee(oe, O, ae, "", function(Ie) {
        return Ie;
      })) : oe != null && (Ve(oe) && (oe = Ne(oe, ae + (!oe.key || de && de.key === oe.key ? "" : ("" + oe.key).replace(Pe, "$&/") + "/") + g)), O.push(oe)), 1;
      if (de = 0, fe = fe === "" ? "." : fe + ":", H(g)) for (var ge = 0; ge < g.length; ge++) {
        he = g[ge];
        var me = fe + Re(he, ge);
        de += Ee(he, O, ae, me, oe);
      }
      else if (me = R(g), typeof me == "function") for (g = me.call(g), ge = 0; !(he = g.next()).done; ) he = he.value, me = fe + Re(he, ge++), de += Ee(he, O, ae, me, oe);
      else if (he === "object") throw O = String(g), Error("Objects are not valid as a React child (found: " + (O === "[object Object]" ? "object with keys {" + Object.keys(g).join(", ") + "}" : O) + "). If you meant to render a collection of children, use an array instead.");
      return de;
    }
    function Q(g, O, ae) {
      if (g == null) return g;
      var fe = [], oe = 0;
      return Ee(g, fe, "", "", function(he) {
        return O.call(ae, he, oe++);
      }), fe;
    }
    function B(g) {
      if (g._status === -1) {
        var O = g._result;
        O = O(), O.then(function(ae) {
          (g._status === 0 || g._status === -1) && (g._status = 1, g._result = ae);
        }, function(ae) {
          (g._status === 0 || g._status === -1) && (g._status = 2, g._result = ae);
        }), g._status === -1 && (g._status = 0, g._result = O);
      }
      if (g._status === 1) return g._result.default;
      throw g._result;
    }
    var re = { current: null }, ye = { transition: null }, je = { ReactCurrentDispatcher: re, ReactCurrentBatchConfig: ye, ReactCurrentOwner: W };
    function _e() {
      throw Error("act(...) is not supported in production builds of React.");
    }
    e.Children = { map: Q, forEach: function(g, O, ae) {
      Q(g, function() {
        O.apply(this, arguments);
      }, ae);
    }, count: function(g) {
      var O = 0;
      return Q(g, function() {
        O++;
      }), O;
    }, toArray: function(g) {
      return Q(g, function(O) {
        return O;
      }) || [];
    }, only: function(g) {
      if (!Ve(g)) throw Error("React.Children.only expected to receive a single React element child.");
      return g;
    } }, e.Component = P, e.Fragment = n, e.Profiler = s, e.PureComponent = D, e.StrictMode = i, e.Suspense = m, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = je, e.act = _e, e.cloneElement = function(g, O, ae) {
      if (g == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + g + ".");
      var fe = k({}, g.props), oe = g.key, he = g.ref, de = g._owner;
      if (O != null) {
        if (O.ref !== void 0 && (he = O.ref, de = W.current), O.key !== void 0 && (oe = "" + O.key), g.type && g.type.defaultProps) var ge = g.type.defaultProps;
        for (me in O) Y.call(O, me) && !G.hasOwnProperty(me) && (fe[me] = O[me] === void 0 && ge !== void 0 ? ge[me] : O[me]);
      }
      var me = arguments.length - 2;
      if (me === 1) fe.children = ae;
      else if (1 < me) {
        ge = Array(me);
        for (var Ie = 0; Ie < me; Ie++) ge[Ie] = arguments[Ie + 2];
        fe.children = ge;
      }
      return { $$typeof: t, type: g.type, key: oe, ref: he, props: fe, _owner: de };
    }, e.createContext = function(g) {
      return g = { $$typeof: c, _currentValue: g, _currentValue2: g, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, g.Provider = { $$typeof: u, _context: g }, g.Consumer = g;
    }, e.createElement = ce, e.createFactory = function(g) {
      var O = ce.bind(null, g);
      return O.type = g, O;
    }, e.createRef = function() {
      return { current: null };
    }, e.forwardRef = function(g) {
      return { $$typeof: h, render: g };
    }, e.isValidElement = Ve, e.lazy = function(g) {
      return { $$typeof: x, _payload: { _status: -1, _result: g }, _init: B };
    }, e.memo = function(g, O) {
      return { $$typeof: y, type: g, compare: O === void 0 ? null : O };
    }, e.startTransition = function(g) {
      var O = ye.transition;
      ye.transition = {};
      try {
        g();
      } finally {
        ye.transition = O;
      }
    }, e.unstable_act = _e, e.useCallback = function(g, O) {
      return re.current.useCallback(g, O);
    }, e.useContext = function(g) {
      return re.current.useContext(g);
    }, e.useDebugValue = function() {
    }, e.useDeferredValue = function(g) {
      return re.current.useDeferredValue(g);
    }, e.useEffect = function(g, O) {
      return re.current.useEffect(g, O);
    }, e.useId = function() {
      return re.current.useId();
    }, e.useImperativeHandle = function(g, O, ae) {
      return re.current.useImperativeHandle(g, O, ae);
    }, e.useInsertionEffect = function(g, O) {
      return re.current.useInsertionEffect(g, O);
    }, e.useLayoutEffect = function(g, O) {
      return re.current.useLayoutEffect(g, O);
    }, e.useMemo = function(g, O) {
      return re.current.useMemo(g, O);
    }, e.useReducer = function(g, O, ae) {
      return re.current.useReducer(g, O, ae);
    }, e.useRef = function(g) {
      return re.current.useRef(g);
    }, e.useState = function(g) {
      return re.current.useState(g);
    }, e.useSyncExternalStore = function(g, O, ae) {
      return re.current.useSyncExternalStore(g, O, ae);
    }, e.useTransition = function() {
      return re.current.useTransition();
    }, e.version = "18.3.1";
  }
}), Zs = Lr({
  "../../node_modules/.pnpm/react@18.3.1/node_modules/react/cjs/react.development.js"(e, t) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var r = "18.3.1", n = Symbol.for("react.element"), i = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), h = Symbol.for("react.provider"), m = Symbol.for("react.context"), y = Symbol.for("react.forward_ref"), x = Symbol.for("react.suspense"), j = Symbol.for("react.suspense_list"), R = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, P = "@@iterator";
      function V(a) {
        if (a === null || typeof a != "object")
          return null;
        var d = N && a[N] || a[P];
        return typeof d == "function" ? d : null;
      }
      var D = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, z = {
        transition: null
      }, H = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, Y = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, W = {}, G = null;
      function ce(a) {
        G = a;
      }
      W.setExtraStackFrame = function(a) {
        G = a;
      }, W.getCurrentStack = null, W.getStackAddendum = function() {
        var a = "";
        G && (a += G);
        var d = W.getCurrentStack;
        return d && (a += d() || ""), a;
      };
      var Ne = !1, Ve = !1, ze = !1, Pe = !1, Re = !1, Ee = {
        ReactCurrentDispatcher: D,
        ReactCurrentBatchConfig: z,
        ReactCurrentOwner: Y
      };
      Ee.ReactDebugCurrentFrame = W, Ee.ReactCurrentActQueue = H;
      function Q(a) {
        {
          for (var d = arguments.length, _ = new Array(d > 1 ? d - 1 : 0), C = 1; C < d; C++)
            _[C - 1] = arguments[C];
          re("warn", a, _);
        }
      }
      function B(a) {
        {
          for (var d = arguments.length, _ = new Array(d > 1 ? d - 1 : 0), C = 1; C < d; C++)
            _[C - 1] = arguments[C];
          re("error", a, _);
        }
      }
      function re(a, d, _) {
        {
          var C = Ee.ReactDebugCurrentFrame, M = C.getStackAddendum();
          M !== "" && (d += "%s", _ = _.concat([M]));
          var te = _.map(function(Z) {
            return String(Z);
          });
          te.unshift("Warning: " + d), Function.prototype.apply.call(console[a], console, te);
        }
      }
      var ye = {};
      function je(a, d) {
        {
          var _ = a.constructor, C = _ && (_.displayName || _.name) || "ReactClass", M = C + "." + d;
          if (ye[M])
            return;
          B("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", d, C), ye[M] = !0;
        }
      }
      var _e = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(a) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(a, d, _) {
          je(a, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(a, d, _, C) {
          je(a, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(a, d, _, C) {
          je(a, "setState");
        }
      }, g = Object.assign, O = {};
      Object.freeze(O);
      function ae(a, d, _) {
        this.props = a, this.context = d, this.refs = O, this.updater = _ || _e;
      }
      ae.prototype.isReactComponent = {}, ae.prototype.setState = function(a, d) {
        if (typeof a != "object" && typeof a != "function" && a != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, a, d, "setState");
      }, ae.prototype.forceUpdate = function(a) {
        this.updater.enqueueForceUpdate(this, a, "forceUpdate");
      };
      {
        var fe = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, oe = function(a, d) {
          Object.defineProperty(ae.prototype, a, {
            get: function() {
              Q("%s(...) is deprecated in plain JavaScript React classes. %s", d[0], d[1]);
            }
          });
        };
        for (var he in fe)
          fe.hasOwnProperty(he) && oe(he, fe[he]);
      }
      function de() {
      }
      de.prototype = ae.prototype;
      function ge(a, d, _) {
        this.props = a, this.context = d, this.refs = O, this.updater = _ || _e;
      }
      var me = ge.prototype = new de();
      me.constructor = ge, g(me, ae.prototype), me.isPureReactComponent = !0;
      function Ie() {
        var a = {
          current: null
        };
        return Object.seal(a), a;
      }
      var mt = Array.isArray;
      function st(a) {
        return mt(a);
      }
      function It(a) {
        {
          var d = typeof Symbol == "function" && Symbol.toStringTag, _ = d && a[Symbol.toStringTag] || a.constructor.name || "Object";
          return _;
        }
      }
      function lt(a) {
        try {
          return Qe(a), !1;
        } catch {
          return !0;
        }
      }
      function Qe(a) {
        return "" + a;
      }
      function U(a) {
        if (lt(a))
          return B("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", It(a)), Qe(a);
      }
      function K(a, d, _) {
        var C = a.displayName;
        if (C)
          return C;
        var M = d.displayName || d.name || "";
        return M !== "" ? _ + "(" + M + ")" : _;
      }
      function ne(a) {
        return a.displayName || "Context";
      }
      function se(a) {
        if (a == null)
          return null;
        if (typeof a.tag == "number" && B("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
          return a.displayName || a.name || null;
        if (typeof a == "string")
          return a;
        switch (a) {
          case s:
            return "Fragment";
          case i:
            return "Portal";
          case c:
            return "Profiler";
          case u:
            return "StrictMode";
          case x:
            return "Suspense";
          case j:
            return "SuspenseList";
        }
        if (typeof a == "object")
          switch (a.$$typeof) {
            case m:
              var d = a;
              return ne(d) + ".Consumer";
            case h:
              var _ = a;
              return ne(_._context) + ".Provider";
            case y:
              return K(a, a.render, "ForwardRef");
            case R:
              var C = a.displayName || null;
              return C !== null ? C : se(a.type) || "Memo";
            case T: {
              var M = a, te = M._payload, Z = M._init;
              try {
                return se(Z(te));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var Oe = Object.prototype.hasOwnProperty, xe = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, le, Ke, He;
      He = {};
      function Xe(a) {
        if (Oe.call(a, "ref")) {
          var d = Object.getOwnPropertyDescriptor(a, "ref").get;
          if (d && d.isReactWarning)
            return !1;
        }
        return a.ref !== void 0;
      }
      function it(a) {
        if (Oe.call(a, "key")) {
          var d = Object.getOwnPropertyDescriptor(a, "key").get;
          if (d && d.isReactWarning)
            return !1;
        }
        return a.key !== void 0;
      }
      function ht(a, d) {
        var _ = function() {
          le || (le = !0, B("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        _.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: _,
          configurable: !0
        });
      }
      function Lt(a, d) {
        var _ = function() {
          Ke || (Ke = !0, B("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        _.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: _,
          configurable: !0
        });
      }
      function St(a) {
        if (typeof a.ref == "string" && Y.current && a.__self && Y.current.stateNode !== a.__self) {
          var d = se(Y.current.type);
          He[d] || (B('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', d, a.ref), He[d] = !0);
        }
      }
      var pt = function(a, d, _, C, M, te, Z) {
        var ue = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: a,
          key: d,
          ref: _,
          props: Z,
          // Record the component responsible for creating this element.
          _owner: te
        };
        return ue._store = {}, Object.defineProperty(ue._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(ue, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: C
        }), Object.defineProperty(ue, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: M
        }), Object.freeze && (Object.freeze(ue.props), Object.freeze(ue)), ue;
      };
      function $t(a, d, _) {
        var C, M = {}, te = null, Z = null, ue = null, we = null;
        if (d != null) {
          Xe(d) && (Z = d.ref, St(d)), it(d) && (U(d.key), te = "" + d.key), ue = d.__self === void 0 ? null : d.__self, we = d.__source === void 0 ? null : d.__source;
          for (C in d)
            Oe.call(d, C) && !xe.hasOwnProperty(C) && (M[C] = d[C]);
        }
        var Ae = arguments.length - 2;
        if (Ae === 1)
          M.children = _;
        else if (Ae > 1) {
          for (var Le = Array(Ae), Me = 0; Me < Ae; Me++)
            Le[Me] = arguments[Me + 2];
          Object.freeze && Object.freeze(Le), M.children = Le;
        }
        if (a && a.defaultProps) {
          var Be = a.defaultProps;
          for (C in Be)
            M[C] === void 0 && (M[C] = Be[C]);
        }
        if (te || Z) {
          var Ye = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          te && ht(M, Ye), Z && Lt(M, Ye);
        }
        return pt(a, te, Z, ue, we, Y.current, M);
      }
      function rr(a, d) {
        var _ = pt(a.type, d, a.ref, a._self, a._source, a._owner, a.props);
        return _;
      }
      function nr(a, d, _) {
        if (a == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
        var C, M = g({}, a.props), te = a.key, Z = a.ref, ue = a._self, we = a._source, Ae = a._owner;
        if (d != null) {
          Xe(d) && (Z = d.ref, Ae = Y.current), it(d) && (U(d.key), te = "" + d.key);
          var Le;
          a.type && a.type.defaultProps && (Le = a.type.defaultProps);
          for (C in d)
            Oe.call(d, C) && !xe.hasOwnProperty(C) && (d[C] === void 0 && Le !== void 0 ? M[C] = Le[C] : M[C] = d[C]);
        }
        var Me = arguments.length - 2;
        if (Me === 1)
          M.children = _;
        else if (Me > 1) {
          for (var Be = Array(Me), Ye = 0; Ye < Me; Ye++)
            Be[Ye] = arguments[Ye + 2];
          M.children = Be;
        }
        return pt(a.type, te, Z, ue, we, Ae, M);
      }
      function Je(a) {
        return typeof a == "object" && a !== null && a.$$typeof === n;
      }
      var gt = ".", ar = ":";
      function Ct(a) {
        var d = /[=:]/g, _ = {
          "=": "=0",
          ":": "=2"
        }, C = a.replace(d, function(M) {
          return _[M];
        });
        return "$" + C;
      }
      var xt = !1, ot = /\/+/g;
      function Ze(a) {
        return a.replace(ot, "$&/");
      }
      function ut(a, d) {
        return typeof a == "object" && a !== null && a.key != null ? (U(a.key), Ct("" + a.key)) : d.toString(36);
      }
      function qe(a, d, _, C, M) {
        var te = typeof a;
        (te === "undefined" || te === "boolean") && (a = null);
        var Z = !1;
        if (a === null)
          Z = !0;
        else
          switch (te) {
            case "string":
            case "number":
              Z = !0;
              break;
            case "object":
              switch (a.$$typeof) {
                case n:
                case i:
                  Z = !0;
              }
          }
        if (Z) {
          var ue = a, we = M(ue), Ae = C === "" ? gt + ut(ue, 0) : C;
          if (st(we)) {
            var Le = "";
            Ae != null && (Le = Ze(Ae) + "/"), qe(we, d, Le, "", function(es) {
              return es;
            });
          } else we != null && (Je(we) && (we.key && (!ue || ue.key !== we.key) && U(we.key), we = rr(
            we,
            // Keep both the (mapped) and old keys if they differ, just as
            // traverseAllChildren used to do for objects as children
            _ + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
            (we.key && (!ue || ue.key !== we.key) ? (
              // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
              // eslint-disable-next-line react-internal/safe-string-coercion
              Ze("" + we.key) + "/"
            ) : "") + Ae
          )), d.push(we));
          return 1;
        }
        var Me, Be, Ye = 0, et = C === "" ? gt : C + ar;
        if (st(a))
          for (var gn = 0; gn < a.length; gn++)
            Me = a[gn], Be = et + ut(Me, gn), Ye += qe(Me, d, _, Be, M);
        else {
          var qn = V(a);
          if (typeof qn == "function") {
            var Aa = a;
            qn === Aa.entries && (xt || Q("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), xt = !0);
            for (var Jo = qn.call(Aa), Da, Qo = 0; !(Da = Jo.next()).done; )
              Me = Da.value, Be = et + ut(Me, Qo++), Ye += qe(Me, d, _, Be, M);
          } else if (te === "object") {
            var Ia = String(a);
            throw new Error("Objects are not valid as a React child (found: " + (Ia === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : Ia) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return Ye;
      }
      function bt(a, d, _) {
        if (a == null)
          return a;
        var C = [], M = 0;
        return qe(a, C, "", "", function(te) {
          return d.call(_, te, M++);
        }), C;
      }
      function Gt(a) {
        var d = 0;
        return bt(a, function() {
          d++;
        }), d;
      }
      function Ht(a, d, _) {
        bt(a, function() {
          d.apply(this, arguments);
        }, _);
      }
      function Yt(a) {
        return bt(a, function(d) {
          return d;
        }) || [];
      }
      function Mt(a) {
        if (!Je(a))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return a;
      }
      function rt(a) {
        var d = {
          $$typeof: m,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: a,
          _currentValue2: a,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        d.Provider = {
          $$typeof: h,
          _context: d
        };
        var _ = !1, C = !1, M = !1;
        {
          var te = {
            $$typeof: m,
            _context: d
          };
          Object.defineProperties(te, {
            Provider: {
              get: function() {
                return C || (C = !0, B("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), d.Provider;
              },
              set: function(Z) {
                d.Provider = Z;
              }
            },
            _currentValue: {
              get: function() {
                return d._currentValue;
              },
              set: function(Z) {
                d._currentValue = Z;
              }
            },
            _currentValue2: {
              get: function() {
                return d._currentValue2;
              },
              set: function(Z) {
                d._currentValue2 = Z;
              }
            },
            _threadCount: {
              get: function() {
                return d._threadCount;
              },
              set: function(Z) {
                d._threadCount = Z;
              }
            },
            Consumer: {
              get: function() {
                return _ || (_ = !0, B("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), d.Consumer;
              }
            },
            displayName: {
              get: function() {
                return d.displayName;
              },
              set: function(Z) {
                M || (Q("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", Z), M = !0);
              }
            }
          }), d.Consumer = te;
        }
        return d._currentRenderer = null, d._currentRenderer2 = null, d;
      }
      var yt = -1, jt = 0, Rt = 1, zt = 2;
      function ir(a) {
        if (a._status === yt) {
          var d = a._result, _ = d();
          if (_.then(function(te) {
            if (a._status === jt || a._status === yt) {
              var Z = a;
              Z._status = Rt, Z._result = te;
            }
          }, function(te) {
            if (a._status === jt || a._status === yt) {
              var Z = a;
              Z._status = zt, Z._result = te;
            }
          }), a._status === yt) {
            var C = a;
            C._status = jt, C._result = _;
          }
        }
        if (a._status === Rt) {
          var M = a._result;
          return M === void 0 && B(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, M), "default" in M || B(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, M), M.default;
        } else
          throw a._result;
      }
      function ct(a) {
        var d = {
          // We use these fields to store the result.
          _status: yt,
          _result: a
        }, _ = {
          $$typeof: T,
          _payload: d,
          _init: ir
        };
        {
          var C, M;
          Object.defineProperties(_, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return C;
              },
              set: function(te) {
                B("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), C = te, Object.defineProperty(_, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return M;
              },
              set: function(te) {
                B("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), M = te, Object.defineProperty(_, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return _;
      }
      function or(a) {
        a != null && a.$$typeof === R ? B("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof a != "function" ? B("forwardRef requires a render function but was given %s.", a === null ? "null" : typeof a) : a.length !== 0 && a.length !== 2 && B("forwardRef render functions accept exactly two parameters: props and ref. %s", a.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), a != null && (a.defaultProps != null || a.propTypes != null) && B("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var d = {
          $$typeof: y,
          render: a
        };
        {
          var _;
          Object.defineProperty(d, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return _;
            },
            set: function(C) {
              _ = C, !a.name && !a.displayName && (a.displayName = C);
            }
          });
        }
        return d;
      }
      var v;
      v = Symbol.for("react.module.reference");
      function l(a) {
        return !!(typeof a == "string" || typeof a == "function" || a === s || a === c || Re || a === u || a === x || a === j || Pe || a === k || Ne || Ve || ze || typeof a == "object" && a !== null && (a.$$typeof === T || a.$$typeof === R || a.$$typeof === h || a.$$typeof === m || a.$$typeof === y || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        a.$$typeof === v || a.getModuleId !== void 0));
      }
      function b(a, d) {
        l(a) || B("memo: The first argument must be a component. Instead received: %s", a === null ? "null" : typeof a);
        var _ = {
          $$typeof: R,
          type: a,
          compare: d === void 0 ? null : d
        };
        {
          var C;
          Object.defineProperty(_, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return C;
            },
            set: function(M) {
              C = M, !a.name && !a.displayName && (a.displayName = M);
            }
          });
        }
        return _;
      }
      function S() {
        var a = D.current;
        return a === null && B(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), a;
      }
      function F(a) {
        var d = S();
        if (a._context !== void 0) {
          var _ = a._context;
          _.Consumer === a ? B("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : _.Provider === a && B("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return d.useContext(a);
      }
      function J(a) {
        var d = S();
        return d.useState(a);
      }
      function X(a, d, _) {
        var C = S();
        return C.useReducer(a, d, _);
      }
      function $(a) {
        var d = S();
        return d.useRef(a);
      }
      function ee(a, d) {
        var _ = S();
        return _.useEffect(a, d);
      }
      function ve(a, d) {
        var _ = S();
        return _.useInsertionEffect(a, d);
      }
      function ie(a, d) {
        var _ = S();
        return _.useLayoutEffect(a, d);
      }
      function pe(a, d) {
        var _ = S();
        return _.useCallback(a, d);
      }
      function Fe(a, d) {
        var _ = S();
        return _.useMemo(a, d);
      }
      function $e(a, d, _) {
        var C = S();
        return C.useImperativeHandle(a, d, _);
      }
      function Te(a, d) {
        {
          var _ = S();
          return _.useDebugValue(a, d);
        }
      }
      function We() {
        var a = S();
        return a.useTransition();
      }
      function ft(a) {
        var d = S();
        return d.useDeferredValue(a);
      }
      function Kt() {
        var a = S();
        return a.useId();
      }
      function Fr(a, d, _) {
        var C = S();
        return C.useSyncExternalStore(a, d, _);
      }
      var sr = 0, nn, Br, an, on, sn, ln, un;
      function cn() {
      }
      cn.__reactDisabledLog = !0;
      function Un() {
        {
          if (sr === 0) {
            nn = console.log, Br = console.info, an = console.warn, on = console.error, sn = console.group, ln = console.groupCollapsed, un = console.groupEnd;
            var a = {
              configurable: !0,
              enumerable: !0,
              value: cn,
              writable: !0
            };
            Object.defineProperties(console, {
              info: a,
              log: a,
              warn: a,
              error: a,
              group: a,
              groupCollapsed: a,
              groupEnd: a
            });
          }
          sr++;
        }
      }
      function $n() {
        {
          if (sr--, sr === 0) {
            var a = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: g({}, a, {
                value: nn
              }),
              info: g({}, a, {
                value: Br
              }),
              warn: g({}, a, {
                value: an
              }),
              error: g({}, a, {
                value: on
              }),
              group: g({}, a, {
                value: sn
              }),
              groupCollapsed: g({}, a, {
                value: ln
              }),
              groupEnd: g({}, a, {
                value: un
              })
            });
          }
          sr < 0 && B("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Vr = Ee.ReactCurrentDispatcher, Wr;
      function Ft(a, d, _) {
        {
          if (Wr === void 0)
            try {
              throw Error();
            } catch (M) {
              var C = M.stack.trim().match(/\n( *(at )?)/);
              Wr = C && C[1] || "";
            }
          return `
` + Wr + a;
        }
      }
      var lr = !1, yr;
      {
        var Gn = typeof WeakMap == "function" ? WeakMap : Map;
        yr = new Gn();
      }
      function Ur(a, d) {
        if (!a || lr)
          return "";
        {
          var _ = yr.get(a);
          if (_ !== void 0)
            return _;
        }
        var C;
        lr = !0;
        var M = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var te;
        te = Vr.current, Vr.current = null, Un();
        try {
          if (d) {
            var Z = function() {
              throw Error();
            };
            if (Object.defineProperty(Z.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Z, []);
              } catch (et) {
                C = et;
              }
              Reflect.construct(a, [], Z);
            } else {
              try {
                Z.call();
              } catch (et) {
                C = et;
              }
              a.call(Z.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (et) {
              C = et;
            }
            a();
          }
        } catch (et) {
          if (et && C && typeof et.stack == "string") {
            for (var ue = et.stack.split(`
`), we = C.stack.split(`
`), Ae = ue.length - 1, Le = we.length - 1; Ae >= 1 && Le >= 0 && ue[Ae] !== we[Le]; )
              Le--;
            for (; Ae >= 1 && Le >= 0; Ae--, Le--)
              if (ue[Ae] !== we[Le]) {
                if (Ae !== 1 || Le !== 1)
                  do
                    if (Ae--, Le--, Le < 0 || ue[Ae] !== we[Le]) {
                      var Me = `
` + ue[Ae].replace(" at new ", " at ");
                      return a.displayName && Me.includes("<anonymous>") && (Me = Me.replace("<anonymous>", a.displayName)), typeof a == "function" && yr.set(a, Me), Me;
                    }
                  while (Ae >= 1 && Le >= 0);
                break;
              }
          }
        } finally {
          lr = !1, Vr.current = te, $n(), Error.prepareStackTrace = M;
        }
        var Be = a ? a.displayName || a.name : "", Ye = Be ? Ft(Be) : "";
        return typeof a == "function" && yr.set(a, Ye), Ye;
      }
      function Hn(a, d, _) {
        return Ur(a, !1);
      }
      function Yn(a) {
        var d = a.prototype;
        return !!(d && d.isReactComponent);
      }
      function _r(a, d, _) {
        if (a == null)
          return "";
        if (typeof a == "function")
          return Ur(a, Yn(a));
        if (typeof a == "string")
          return Ft(a);
        switch (a) {
          case x:
            return Ft("Suspense");
          case j:
            return Ft("SuspenseList");
        }
        if (typeof a == "object")
          switch (a.$$typeof) {
            case y:
              return Hn(a.render);
            case R:
              return _r(a.type, d, _);
            case T: {
              var C = a, M = C._payload, te = C._init;
              try {
                return _r(te(M), d, _);
              } catch {
              }
            }
          }
        return "";
      }
      var $r = {}, fn = Ee.ReactDebugCurrentFrame;
      function wr(a) {
        if (a) {
          var d = a._owner, _ = _r(a.type, a._source, d ? d.type : null);
          fn.setExtraStackFrame(_);
        } else
          fn.setExtraStackFrame(null);
      }
      function zn(a, d, _, C, M) {
        {
          var te = Function.call.bind(Oe);
          for (var Z in a)
            if (te(a, Z)) {
              var ue = void 0;
              try {
                if (typeof a[Z] != "function") {
                  var we = Error((C || "React class") + ": " + _ + " type `" + Z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[Z] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw we.name = "Invariant Violation", we;
                }
                ue = a[Z](d, Z, C, _, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Ae) {
                ue = Ae;
              }
              ue && !(ue instanceof Error) && (wr(M), B("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", C || "React class", _, Z, typeof ue), wr(null)), ue instanceof Error && !(ue.message in $r) && ($r[ue.message] = !0, wr(M), B("Failed %s type: %s", _, ue.message), wr(null));
            }
        }
      }
      function kt(a) {
        if (a) {
          var d = a._owner, _ = _r(a.type, a._source, d ? d.type : null);
          ce(_);
        } else
          ce(null);
      }
      var Gr;
      Gr = !1;
      function dn() {
        if (Y.current) {
          var a = se(Y.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
      function Kn(a) {
        if (a !== void 0) {
          var d = a.fileName.replace(/^.*[\\\/]/, ""), _ = a.lineNumber;
          return `

Check your code at ` + d + ":" + _ + ".";
        }
        return "";
      }
      function Er(a) {
        return a != null ? Kn(a.__source) : "";
      }
      var Sr = {};
      function Hr(a) {
        var d = dn();
        if (!d) {
          var _ = typeof a == "string" ? a : a.displayName || a.name;
          _ && (d = `

Check the top-level render call using <` + _ + ">.");
        }
        return d;
      }
      function Cr(a, d) {
        if (!(!a._store || a._store.validated || a.key != null)) {
          a._store.validated = !0;
          var _ = Hr(d);
          if (!Sr[_]) {
            Sr[_] = !0;
            var C = "";
            a && a._owner && a._owner !== Y.current && (C = " It was passed a child from " + se(a._owner.type) + "."), kt(a), B('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', _, C), kt(null);
          }
        }
      }
      function vn(a, d) {
        if (typeof a == "object") {
          if (st(a))
            for (var _ = 0; _ < a.length; _++) {
              var C = a[_];
              Je(C) && Cr(C, d);
            }
          else if (Je(a))
            a._store && (a._store.validated = !0);
          else if (a) {
            var M = V(a);
            if (typeof M == "function" && M !== a.entries)
              for (var te = M.call(a), Z; !(Z = te.next()).done; )
                Je(Z.value) && Cr(Z.value, d);
          }
        }
      }
      function Yr(a) {
        {
          var d = a.type;
          if (d == null || typeof d == "string")
            return;
          var _;
          if (typeof d == "function")
            _ = d.propTypes;
          else if (typeof d == "object" && (d.$$typeof === y || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          d.$$typeof === R))
            _ = d.propTypes;
          else
            return;
          if (_) {
            var C = se(d);
            zn(_, a.props, "prop", C, a);
          } else if (d.PropTypes !== void 0 && !Gr) {
            Gr = !0;
            var M = se(d);
            B("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", M || "Unknown");
          }
          typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && B("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function zr(a) {
        {
          for (var d = Object.keys(a.props), _ = 0; _ < d.length; _++) {
            var C = d[_];
            if (C !== "children" && C !== "key") {
              kt(a), B("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", C), kt(null);
              break;
            }
          }
          a.ref !== null && (kt(a), B("Invalid attribute `ref` supplied to `React.Fragment`."), kt(null));
        }
      }
      function Kr(a, d, _) {
        var C = l(a);
        if (!C) {
          var M = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (M += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Er(d);
          te ? M += te : M += dn();
          var Z;
          a === null ? Z = "null" : st(a) ? Z = "array" : a !== void 0 && a.$$typeof === n ? (Z = "<" + (se(a.type) || "Unknown") + " />", M = " Did you accidentally export a JSX literal instead of a component?") : Z = typeof a, B("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Z, M);
        }
        var ue = $t.apply(this, arguments);
        if (ue == null)
          return ue;
        if (C)
          for (var we = 2; we < arguments.length; we++)
            vn(arguments[we], a);
        return a === s ? zr(ue) : Yr(ue), ue;
      }
      var Ot = !1;
      function ur(a) {
        var d = Kr.bind(null, a);
        return d.type = a, Ot || (Ot = !0, Q("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(d, "type", {
          enumerable: !1,
          get: function() {
            return Q("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: a
            }), a;
          }
        }), d;
      }
      function Xn(a, d, _) {
        for (var C = nr.apply(this, arguments), M = 2; M < arguments.length; M++)
          vn(arguments[M], C.type);
        return Yr(C), C;
      }
      function mn(a, d) {
        var _ = z.transition;
        z.transition = {};
        var C = z.transition;
        z.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          a();
        } finally {
          if (z.transition = _, _ === null && C._updatedFibers) {
            var M = C._updatedFibers.size;
            M > 10 && Q("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), C._updatedFibers.clear();
          }
        }
      }
      var hn = !1, cr = null;
      function Zn(a) {
        if (cr === null)
          try {
            var d = ("require" + Math.random()).slice(0, 7), _ = t && t[d];
            cr = _.call(t, "timers").setImmediate;
          } catch {
            cr = function(M) {
              hn === !1 && (hn = !0, typeof MessageChannel > "u" && B("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var te = new MessageChannel();
              te.port1.onmessage = M, te.port2.postMessage(void 0);
            };
          }
        return cr(a);
      }
      var Xt = 0, Xr = !1;
      function pn(a) {
        {
          var d = Xt;
          Xt++, H.current === null && (H.current = []);
          var _ = H.isBatchingLegacy, C;
          try {
            if (H.isBatchingLegacy = !0, C = a(), !_ && H.didScheduleLegacyUpdate) {
              var M = H.current;
              M !== null && (H.didScheduleLegacyUpdate = !1, q(M));
            }
          } catch (Be) {
            throw f(d), Be;
          } finally {
            H.isBatchingLegacy = _;
          }
          if (C !== null && typeof C == "object" && typeof C.then == "function") {
            var te = C, Z = !1, ue = {
              then: function(Be, Ye) {
                Z = !0, te.then(function(et) {
                  f(d), Xt === 0 ? p(et, Be, Ye) : Be(et);
                }, function(et) {
                  f(d), Ye(et);
                });
              }
            };
            return !Xr && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              Z || (Xr = !0, B("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), ue;
          } else {
            var we = C;
            if (f(d), Xt === 0) {
              var Ae = H.current;
              Ae !== null && (q(Ae), H.current = null);
              var Le = {
                then: function(Be, Ye) {
                  H.current === null ? (H.current = [], p(we, Be, Ye)) : Be(we);
                }
              };
              return Le;
            } else {
              var Me = {
                then: function(Be, Ye) {
                  Be(we);
                }
              };
              return Me;
            }
          }
        }
      }
      function f(a) {
        a !== Xt - 1 && B("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Xt = a;
      }
      function p(a, d, _) {
        {
          var C = H.current;
          if (C !== null)
            try {
              q(C), Zn(function() {
                C.length === 0 ? (H.current = null, d(a)) : p(a, d, _);
              });
            } catch (M) {
              _(M);
            }
          else
            d(a);
        }
      }
      var w = !1;
      function q(a) {
        if (!w) {
          w = !0;
          var d = 0;
          try {
            for (; d < a.length; d++) {
              var _ = a[d];
              do
                _ = _(!0);
              while (_ !== null);
            }
            a.length = 0;
          } catch (C) {
            throw a = a.slice(d + 1), C;
          } finally {
            w = !1;
          }
        }
      }
      var be = Kr, ke = Xn, De = ur, Se = {
        map: bt,
        forEach: Ht,
        count: Gt,
        toArray: Yt,
        only: Mt
      };
      e.Children = Se, e.Component = ae, e.Fragment = s, e.Profiler = c, e.PureComponent = ge, e.StrictMode = u, e.Suspense = x, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ee, e.act = pn, e.cloneElement = ke, e.createContext = rt, e.createElement = be, e.createFactory = De, e.createRef = Ie, e.forwardRef = or, e.isValidElement = Je, e.lazy = ct, e.memo = b, e.startTransition = mn, e.unstable_act = pn, e.useCallback = pe, e.useContext = F, e.useDebugValue = Te, e.useDeferredValue = ft, e.useEffect = ee, e.useId = Kt, e.useImperativeHandle = $e, e.useInsertionEffect = ve, e.useLayoutEffect = ie, e.useMemo = Fe, e.useReducer = X, e.useRef = $, e.useState = J, e.useSyncExternalStore = Fr, e.useTransition = We, e.version = r, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }
}), Wi = Lr({
  "../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js"(e, t) {
    process.env.NODE_ENV === "production" ? t.exports = Xs() : t.exports = Zs();
  }
}), qs = Lr({
  "../../node_modules/.pnpm/react@18.3.1/node_modules/react/cjs/react-jsx-runtime.production.min.js"(e) {
    var t = Wi(), r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, u = { key: !0, ref: !0, __self: !0, __source: !0 };
    function c(h, m, y) {
      var x, j = {}, R = null, T = null;
      y !== void 0 && (R = "" + y), m.key !== void 0 && (R = "" + m.key), m.ref !== void 0 && (T = m.ref);
      for (x in m) i.call(m, x) && !u.hasOwnProperty(x) && (j[x] = m[x]);
      if (h && h.defaultProps) for (x in m = h.defaultProps, m) j[x] === void 0 && (j[x] = m[x]);
      return { $$typeof: r, type: h, key: R, ref: T, props: j, _owner: s.current };
    }
    e.Fragment = n, e.jsx = c, e.jsxs = c;
  }
}), Js = Lr({
  "../../node_modules/.pnpm/react@18.3.1/node_modules/react/cjs/react-jsx-runtime.development.js"(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = Wi(), r = Symbol.for("react.element"), n = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), h = Symbol.for("react.context"), m = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), x = Symbol.for("react.suspense_list"), j = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), k = Symbol.iterator, N = "@@iterator";
      function P(l) {
        if (l === null || typeof l != "object")
          return null;
        var b = k && l[k] || l[N];
        return typeof b == "function" ? b : null;
      }
      var V = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function D(l) {
        {
          for (var b = arguments.length, S = new Array(b > 1 ? b - 1 : 0), F = 1; F < b; F++)
            S[F - 1] = arguments[F];
          z("error", l, S);
        }
      }
      function z(l, b, S) {
        {
          var F = V.ReactDebugCurrentFrame, J = F.getStackAddendum();
          J !== "" && (b += "%s", S = S.concat([J]));
          var X = S.map(function($) {
            return String($);
          });
          X.unshift("Warning: " + b), Function.prototype.apply.call(console[l], console, X);
        }
      }
      var H = !1, Y = !1, W = !1, G = !1, ce = !1, Ne;
      Ne = Symbol.for("react.module.reference");
      function Ve(l) {
        return !!(typeof l == "string" || typeof l == "function" || l === i || l === u || ce || l === s || l === y || l === x || G || l === T || H || Y || W || typeof l == "object" && l !== null && (l.$$typeof === R || l.$$typeof === j || l.$$typeof === c || l.$$typeof === h || l.$$typeof === m || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        l.$$typeof === Ne || l.getModuleId !== void 0));
      }
      function ze(l, b, S) {
        var F = l.displayName;
        if (F)
          return F;
        var J = b.displayName || b.name || "";
        return J !== "" ? S + "(" + J + ")" : S;
      }
      function Pe(l) {
        return l.displayName || "Context";
      }
      function Re(l) {
        if (l == null)
          return null;
        if (typeof l.tag == "number" && D("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof l == "function")
          return l.displayName || l.name || null;
        if (typeof l == "string")
          return l;
        switch (l) {
          case i:
            return "Fragment";
          case n:
            return "Portal";
          case u:
            return "Profiler";
          case s:
            return "StrictMode";
          case y:
            return "Suspense";
          case x:
            return "SuspenseList";
        }
        if (typeof l == "object")
          switch (l.$$typeof) {
            case h:
              var b = l;
              return Pe(b) + ".Consumer";
            case c:
              var S = l;
              return Pe(S._context) + ".Provider";
            case m:
              return ze(l, l.render, "ForwardRef");
            case j:
              var F = l.displayName || null;
              return F !== null ? F : Re(l.type) || "Memo";
            case R: {
              var J = l, X = J._payload, $ = J._init;
              try {
                return Re($(X));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var Ee = Object.assign, Q = 0, B, re, ye, je, _e, g, O;
      function ae() {
      }
      ae.__reactDisabledLog = !0;
      function fe() {
        {
          if (Q === 0) {
            B = console.log, re = console.info, ye = console.warn, je = console.error, _e = console.group, g = console.groupCollapsed, O = console.groupEnd;
            var l = {
              configurable: !0,
              enumerable: !0,
              value: ae,
              writable: !0
            };
            Object.defineProperties(console, {
              info: l,
              log: l,
              warn: l,
              error: l,
              group: l,
              groupCollapsed: l,
              groupEnd: l
            });
          }
          Q++;
        }
      }
      function oe() {
        {
          if (Q--, Q === 0) {
            var l = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: Ee({}, l, {
                value: B
              }),
              info: Ee({}, l, {
                value: re
              }),
              warn: Ee({}, l, {
                value: ye
              }),
              error: Ee({}, l, {
                value: je
              }),
              group: Ee({}, l, {
                value: _e
              }),
              groupCollapsed: Ee({}, l, {
                value: g
              }),
              groupEnd: Ee({}, l, {
                value: O
              })
            });
          }
          Q < 0 && D("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var he = V.ReactCurrentDispatcher, de;
      function ge(l, b, S) {
        {
          if (de === void 0)
            try {
              throw Error();
            } catch (J) {
              var F = J.stack.trim().match(/\n( *(at )?)/);
              de = F && F[1] || "";
            }
          return `
` + de + l;
        }
      }
      var me = !1, Ie;
      {
        var mt = typeof WeakMap == "function" ? WeakMap : Map;
        Ie = new mt();
      }
      function st(l, b) {
        if (!l || me)
          return "";
        {
          var S = Ie.get(l);
          if (S !== void 0)
            return S;
        }
        var F;
        me = !0;
        var J = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var X;
        X = he.current, he.current = null, fe();
        try {
          if (b) {
            var $ = function() {
              throw Error();
            };
            if (Object.defineProperty($.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct($, []);
              } catch (We) {
                F = We;
              }
              Reflect.construct(l, [], $);
            } else {
              try {
                $.call();
              } catch (We) {
                F = We;
              }
              l.call($.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (We) {
              F = We;
            }
            l();
          }
        } catch (We) {
          if (We && F && typeof We.stack == "string") {
            for (var ee = We.stack.split(`
`), ve = F.stack.split(`
`), ie = ee.length - 1, pe = ve.length - 1; ie >= 1 && pe >= 0 && ee[ie] !== ve[pe]; )
              pe--;
            for (; ie >= 1 && pe >= 0; ie--, pe--)
              if (ee[ie] !== ve[pe]) {
                if (ie !== 1 || pe !== 1)
                  do
                    if (ie--, pe--, pe < 0 || ee[ie] !== ve[pe]) {
                      var Fe = `
` + ee[ie].replace(" at new ", " at ");
                      return l.displayName && Fe.includes("<anonymous>") && (Fe = Fe.replace("<anonymous>", l.displayName)), typeof l == "function" && Ie.set(l, Fe), Fe;
                    }
                  while (ie >= 1 && pe >= 0);
                break;
              }
          }
        } finally {
          me = !1, he.current = X, oe(), Error.prepareStackTrace = J;
        }
        var $e = l ? l.displayName || l.name : "", Te = $e ? ge($e) : "";
        return typeof l == "function" && Ie.set(l, Te), Te;
      }
      function It(l, b, S) {
        return st(l, !1);
      }
      function lt(l) {
        var b = l.prototype;
        return !!(b && b.isReactComponent);
      }
      function Qe(l, b, S) {
        if (l == null)
          return "";
        if (typeof l == "function")
          return st(l, lt(l));
        if (typeof l == "string")
          return ge(l);
        switch (l) {
          case y:
            return ge("Suspense");
          case x:
            return ge("SuspenseList");
        }
        if (typeof l == "object")
          switch (l.$$typeof) {
            case m:
              return It(l.render);
            case j:
              return Qe(l.type, b, S);
            case R: {
              var F = l, J = F._payload, X = F._init;
              try {
                return Qe(X(J), b, S);
              } catch {
              }
            }
          }
        return "";
      }
      var U = Object.prototype.hasOwnProperty, K = {}, ne = V.ReactDebugCurrentFrame;
      function se(l) {
        if (l) {
          var b = l._owner, S = Qe(l.type, l._source, b ? b.type : null);
          ne.setExtraStackFrame(S);
        } else
          ne.setExtraStackFrame(null);
      }
      function Oe(l, b, S, F, J) {
        {
          var X = Function.call.bind(U);
          for (var $ in l)
            if (X(l, $)) {
              var ee = void 0;
              try {
                if (typeof l[$] != "function") {
                  var ve = Error((F || "React class") + ": " + S + " type `" + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[$] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw ve.name = "Invariant Violation", ve;
                }
                ee = l[$](b, $, F, S, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ie) {
                ee = ie;
              }
              ee && !(ee instanceof Error) && (se(J), D("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", F || "React class", S, $, typeof ee), se(null)), ee instanceof Error && !(ee.message in K) && (K[ee.message] = !0, se(J), D("Failed %s type: %s", S, ee.message), se(null));
            }
        }
      }
      var xe = Array.isArray;
      function le(l) {
        return xe(l);
      }
      function Ke(l) {
        {
          var b = typeof Symbol == "function" && Symbol.toStringTag, S = b && l[Symbol.toStringTag] || l.constructor.name || "Object";
          return S;
        }
      }
      function He(l) {
        try {
          return Xe(l), !1;
        } catch {
          return !0;
        }
      }
      function Xe(l) {
        return "" + l;
      }
      function it(l) {
        if (He(l))
          return D("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ke(l)), Xe(l);
      }
      var ht = V.ReactCurrentOwner, Lt = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, St, pt;
      function $t(l) {
        if (U.call(l, "ref")) {
          var b = Object.getOwnPropertyDescriptor(l, "ref").get;
          if (b && b.isReactWarning)
            return !1;
        }
        return l.ref !== void 0;
      }
      function rr(l) {
        if (U.call(l, "key")) {
          var b = Object.getOwnPropertyDescriptor(l, "key").get;
          if (b && b.isReactWarning)
            return !1;
        }
        return l.key !== void 0;
      }
      function nr(l, b) {
        typeof l.ref == "string" && ht.current;
      }
      function Je(l, b) {
        {
          var S = function() {
            St || (St = !0, D("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", b));
          };
          S.isReactWarning = !0, Object.defineProperty(l, "key", {
            get: S,
            configurable: !0
          });
        }
      }
      function gt(l, b) {
        {
          var S = function() {
            pt || (pt = !0, D("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", b));
          };
          S.isReactWarning = !0, Object.defineProperty(l, "ref", {
            get: S,
            configurable: !0
          });
        }
      }
      var ar = function(l, b, S, F, J, X, $) {
        var ee = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: r,
          // Built-in properties that belong on the element
          type: l,
          key: b,
          ref: S,
          props: $,
          // Record the component responsible for creating this element.
          _owner: X
        };
        return ee._store = {}, Object.defineProperty(ee._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(ee, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: F
        }), Object.defineProperty(ee, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: J
        }), Object.freeze && (Object.freeze(ee.props), Object.freeze(ee)), ee;
      };
      function Ct(l, b, S, F, J) {
        {
          var X, $ = {}, ee = null, ve = null;
          S !== void 0 && (it(S), ee = "" + S), rr(b) && (it(b.key), ee = "" + b.key), $t(b) && (ve = b.ref, nr(b, J));
          for (X in b)
            U.call(b, X) && !Lt.hasOwnProperty(X) && ($[X] = b[X]);
          if (l && l.defaultProps) {
            var ie = l.defaultProps;
            for (X in ie)
              $[X] === void 0 && ($[X] = ie[X]);
          }
          if (ee || ve) {
            var pe = typeof l == "function" ? l.displayName || l.name || "Unknown" : l;
            ee && Je($, pe), ve && gt($, pe);
          }
          return ar(l, ee, ve, J, F, ht.current, $);
        }
      }
      var xt = V.ReactCurrentOwner, ot = V.ReactDebugCurrentFrame;
      function Ze(l) {
        if (l) {
          var b = l._owner, S = Qe(l.type, l._source, b ? b.type : null);
          ot.setExtraStackFrame(S);
        } else
          ot.setExtraStackFrame(null);
      }
      var ut;
      ut = !1;
      function qe(l) {
        return typeof l == "object" && l !== null && l.$$typeof === r;
      }
      function bt() {
        {
          if (xt.current) {
            var l = Re(xt.current.type);
            if (l)
              return `

Check the render method of \`` + l + "`.";
          }
          return "";
        }
      }
      function Gt(l) {
        return "";
      }
      var Ht = {};
      function Yt(l) {
        {
          var b = bt();
          if (!b) {
            var S = typeof l == "string" ? l : l.displayName || l.name;
            S && (b = `

Check the top-level render call using <` + S + ">.");
          }
          return b;
        }
      }
      function Mt(l, b) {
        {
          if (!l._store || l._store.validated || l.key != null)
            return;
          l._store.validated = !0;
          var S = Yt(b);
          if (Ht[S])
            return;
          Ht[S] = !0;
          var F = "";
          l && l._owner && l._owner !== xt.current && (F = " It was passed a child from " + Re(l._owner.type) + "."), Ze(l), D('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', S, F), Ze(null);
        }
      }
      function rt(l, b) {
        {
          if (typeof l != "object")
            return;
          if (le(l))
            for (var S = 0; S < l.length; S++) {
              var F = l[S];
              qe(F) && Mt(F, b);
            }
          else if (qe(l))
            l._store && (l._store.validated = !0);
          else if (l) {
            var J = P(l);
            if (typeof J == "function" && J !== l.entries)
              for (var X = J.call(l), $; !($ = X.next()).done; )
                qe($.value) && Mt($.value, b);
          }
        }
      }
      function yt(l) {
        {
          var b = l.type;
          if (b == null || typeof b == "string")
            return;
          var S;
          if (typeof b == "function")
            S = b.propTypes;
          else if (typeof b == "object" && (b.$$typeof === m || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          b.$$typeof === j))
            S = b.propTypes;
          else
            return;
          if (S) {
            var F = Re(b);
            Oe(S, l.props, "prop", F, l);
          } else if (b.PropTypes !== void 0 && !ut) {
            ut = !0;
            var J = Re(b);
            D("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", J || "Unknown");
          }
          typeof b.getDefaultProps == "function" && !b.getDefaultProps.isReactClassApproved && D("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function jt(l) {
        {
          for (var b = Object.keys(l.props), S = 0; S < b.length; S++) {
            var F = b[S];
            if (F !== "children" && F !== "key") {
              Ze(l), D("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", F), Ze(null);
              break;
            }
          }
          l.ref !== null && (Ze(l), D("Invalid attribute `ref` supplied to `React.Fragment`."), Ze(null));
        }
      }
      var Rt = {};
      function zt(l, b, S, F, J, X) {
        {
          var $ = Ve(l);
          if (!$) {
            var ee = "";
            (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (ee += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var ve = Gt();
            ve ? ee += ve : ee += bt();
            var ie;
            l === null ? ie = "null" : le(l) ? ie = "array" : l !== void 0 && l.$$typeof === r ? (ie = "<" + (Re(l.type) || "Unknown") + " />", ee = " Did you accidentally export a JSX literal instead of a component?") : ie = typeof l, D("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ie, ee);
          }
          var pe = Ct(l, b, S, J, X);
          if (pe == null)
            return pe;
          if ($) {
            var Fe = b.children;
            if (Fe !== void 0)
              if (F)
                if (le(Fe)) {
                  for (var $e = 0; $e < Fe.length; $e++)
                    rt(Fe[$e], l);
                  Object.freeze && Object.freeze(Fe);
                } else
                  D("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                rt(Fe, l);
          }
          if (U.call(b, "key")) {
            var Te = Re(l), We = Object.keys(b).filter(function(Fr) {
              return Fr !== "key";
            }), ft = We.length > 0 ? "{key: someKey, " + We.join(": ..., ") + ": ...}" : "{key: someKey}";
            if (!Rt[Te + ft]) {
              var Kt = We.length > 0 ? "{" + We.join(": ..., ") + ": ...}" : "{}";
              D(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ft, Te, Kt, Te), Rt[Te + ft] = !0;
            }
          }
          return l === i ? jt(pe) : yt(pe), pe;
        }
      }
      function ir(l, b, S) {
        return zt(l, b, S, !0);
      }
      function ct(l, b, S) {
        return zt(l, b, S, !1);
      }
      var or = ct, v = ir;
      e.Fragment = i, e.jsx = or, e.jsxs = v;
    }();
  }
}), L = Lr({
  "../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js"(e, t) {
    process.env.NODE_ENV === "production" ? t.exports = qs() : t.exports = Js();
  }
});
I(L());
I(L());
I(L());
var Ba = I(L());
function Ui(e) {
  return /* @__PURE__ */ (0, Ba.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, Ba.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M4 12.004a1 1 0 0 0 .293.703l6 6a1 1 0 0 0 1.414-1.414L7.414 13H19a1 1 0 1 0 0-2H7.414l4.293-4.293a1 1 0 0 0-1.414-1.414l-6 6a1 1 0 0 0-.293.705z"
        }
      )
    }
  );
}
I(L());
var Va = I(L());
function Qs(e) {
  return /* @__PURE__ */ (0, Va.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, Va.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M11.45 15.335a1 1 0 0 0 1.257-.128l5-5a1 1 0 0 0-1.414-1.414L12 13.086 7.707 8.793a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 .157.128"
        }
      )
    }
  );
}
I(L());
var Wa = I(L());
function el(e) {
  return /* @__PURE__ */ (0, Wa.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, Wa.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M8.165 11.45a1 1 0 0 0 .128 1.257l5 5a1 1 0 0 0 1.414-1.414L10.414 12l4.293-4.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0-.128.157"
        }
      )
    }
  );
}
var Ua = I(L());
function wa(e) {
  return /* @__PURE__ */ (0, Ua.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, Ua.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "m10.707 6.293 5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L13.586 12 9.293 7.707a1 1 0 0 1 1.414-1.414"
        }
      )
    }
  );
}
var $a = I(L());
function tl(e) {
  return /* @__PURE__ */ (0, $a.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, $a.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M17.483 6.29a1 1 0 0 0-.705-.29h-8.07a1 1 0 1 0 0 2h5.656l-8.071 8.071a1 1 0 1 0 1.414 1.414l8.071-8.07v5.656a1 1 0 1 0 2 0v-8.07a1 1 0 0 0-.291-.706l-.002-.002z"
        }
      )
    }
  );
}
I(L());
I(L());
I(L());
var Ga = I(L());
function rl(e) {
  return /* @__PURE__ */ (0, Ga.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, Ga.jsx)(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m10.26 13.845 5.95-5.95a.994.994 0 0 1 1.405-.008.994.994 0 0 1-.008 1.406L10.95 15.95a.994.994 0 0 1-1.406.008l-2.846-2.845a.994.994 0 0 1 .01-1.406.994.994 0 0 1 1.405-.009z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var Ha = I(L());
function nl(e) {
  return /* @__PURE__ */ (0, Ha.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, Ha.jsx)(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m4.21-14.104-5.95 5.95-2.147-2.148a.994.994 0 0 0-1.406.009.994.994 0 0 0-.009 1.405l2.846 2.846a.994.994 0 0 0 1.406-.008l6.657-6.657a.994.994 0 0 0 .008-1.406.994.994 0 0 0-1.405.009",
          clipRule: "evenodd"
        }
      )
    }
  );
}
I(L());
I(L());
var Ya = I(L());
function rn(e) {
  return /* @__PURE__ */ (0, Ya.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, Ya.jsx)(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18.707 6.707a1 1 0 0 0-1.414-1.414L12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.415L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414L12 13.414l5.293 5.294a1 1 0 0 0 1.414-1.415L13.414 12z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var za = I(L());
function Ea(e) {
  return /* @__PURE__ */ (0, za.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, za.jsx)(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3v-1H6a3 3 0 0 1-3-3zm6 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1zm6-11h-5a3 3 0 0 0-3 3v5H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
I(L());
I(L());
var Ka = I(L());
function al(e) {
  return /* @__PURE__ */ (0, Ka.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, Ka.jsx)("rect", { width: 10, height: 2, x: 7, y: 11, fill: "currentColor", rx: 1 })
    }
  );
}
I(L());
I(L());
I(L());
I(L());
var Qn = I(L());
function il(e) {
  return /* @__PURE__ */ (0, Qn.jsxs)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ (0, Qn.jsx)(
          "path",
          {
            fill: "currentColor",
            d: "M11.165 11.45a1 1 0 0 0 .128 1.257l5 5a1 1 0 0 0 1.414-1.414L13.414 12l4.293-4.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0-.128.157"
          }
        ),
        /* @__PURE__ */ (0, Qn.jsx)(
          "path",
          {
            fill: "currentColor",
            d: "M5.165 11.45a1 1 0 0 0 .128 1.257l5 5a1 1 0 0 0 1.414-1.414L7.414 12l4.293-4.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0-.128.157"
          }
        )
      ]
    }
  );
}
var ea = I(L());
function ol(e) {
  return /* @__PURE__ */ (0, ea.jsxs)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ (0, ea.jsx)(
          "path",
          {
            fill: "currentColor",
            d: "M11.835 11.45a1 1 0 0 1-.128 1.257l-5 5a1 1 0 0 1-1.414-1.414L9.586 12 5.293 7.707a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 .128.157"
          }
        ),
        /* @__PURE__ */ (0, ea.jsx)(
          "path",
          {
            fill: "currentColor",
            d: "M17.835 11.45a1 1 0 0 1-.128 1.257l-5 5a1 1 0 0 1-1.414-1.414L15.586 12l-4.293-4.293a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 .128.157"
          }
        )
      ]
    }
  );
}
I(L());
I(L());
I(L());
I(L());
I(L());
I(L());
I(L());
I(L());
I(L());
I(L());
I(L());
var Xa = I(L());
function Fn(e) {
  return /* @__PURE__ */ (0, Xa.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, Xa.jsx)(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-14.4A1.2 1.2 0 1 0 12 9a1.2 1.2 0 0 0 0-2.4m1.2 9a1.2 1.2 0 0 1-2.4 0V12a1.2 1.2 0 0 1 2.4 0z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var Za = I(L());
function sl(e) {
  return /* @__PURE__ */ (0, Za.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, Za.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M18.27 2.259c0 .695-.568 1.259-1.268 1.259s-1.267-.564-1.267-1.259S16.302 1 17.002 1s1.268.564 1.268 1.259m1.425 17.785c0 .695-.568 1.259-1.268 1.259s-1.267-.564-1.267-1.26c0-.695.567-1.258 1.267-1.258s1.268.563 1.268 1.259m-2.33-13.379a1.06 1.06 0 0 0 1.063-1.056 1.06 1.06 0 0 0-1.063-1.057A1.06 1.06 0 0 0 16.3 5.61a1.06 1.06 0 0 0 1.064 1.056Zm3.891-.651a1.06 1.06 0 0 1-1.063 1.056 1.06 1.06 0 0 1-1.064-1.056 1.06 1.06 0 0 1 1.064-1.057 1.06 1.06 0 0 1 1.063 1.057m-4.253 3.329c.5 0 .905-.403.905-.9 0-.496-.405-.9-.905-.9s-.906.404-.906.9c0 .497.406.9.906.9m3.734-.52c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.496.405-.9.906-.9.5 0 .905.404.905.9m1.357 1.777c.5 0 .906-.402.906-.899s-.405-.9-.906-.9c-.5 0-.905.403-.905.9s.405.9.905.9Zm-2.309.495a.79.79 0 0 1-.792.787.79.79 0 0 1-.791-.787c0-.434.354-.786.791-.786s.792.352.792.786m-3.62.404a.79.79 0 0 0 .792-.787.79.79 0 0 0-.792-.786.79.79 0 0 0-.791.786c0 .435.354.787.791.787m5.907.471a.79.79 0 0 1-.791.787.79.79 0 0 1-.792-.786.79.79 0 0 1 .792-.787.79.79 0 0 1 .791.787Zm-4.21 1.554c.375 0 .68-.302.68-.675a.677.677 0 0 0-.68-.675.68.68 0 0 0-.68.675c0 .373.304.675.68.675m2.968.178a.68.68 0 0 1-.68.676.677.677 0 0 1-.68-.676c0-.373.304-.675.68-.675.375 0 .68.302.68.675m-5.774-.582c.375 0 .68-.302.68-.675a.68.68 0 0 0-.68-.675.68.68 0 0 0-.68.675c0 .373.304.675.68.675m2.127.943c0 .31-.254.561-.566.561a.564.564 0 0 1-.566-.562c0-.31.253-.561.566-.561s.566.251.566.562m.407 2.114a.496.496 0 0 0 .498-.494.496.496 0 0 0-.498-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m-.791-.09a.407.407 0 0 1-.408.405.407.407 0 0 1-.408-.405c0-.223.182-.405.408-.405s.408.181.408.405m-1.472-.765a.496.496 0 0 0 .498-.494.496.496 0 0 0-.498-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m-.973-1.64c0 .31-.254.562-.566.562a.564.564 0 0 1-.566-.562c0-.31.253-.562.566-.562s.566.251.566.562m-.588-3.666a.564.564 0 0 0 .566-.562.564.564 0 0 0-.566-.562.564.564 0 0 0-.565.562c0 .31.253.562.565.562m.745-2.473a.496.496 0 0 1-.497.494.496.496 0 0 1-.498-.494c0-.273.223-.494.498-.494s.498.22.498.494Zm.047-1.123a.406.406 0 0 0 .407-.406.406.406 0 0 0-.407-.405.407.407 0 0 0-.408.405c0 .224.182.406.408.406m-.452-1.26a.496.496 0 0 1-.498.494.496.496 0 0 1-.498-.494c0-.273.223-.494.498-.494s.498.22.498.494m4.776 10.32a.564.564 0 0 0 .566-.561.564.564 0 0 0-.566-.562.564.564 0 0 0-.566.562c0 .31.253.562.566.562ZM12.883 4.439c0 .31-.254.562-.566.562a.564.564 0 0 1-.566-.562c0-.31.254-.562.566-.562s.566.251.566.562m-.18 2.945a.564.564 0 0 0 .566-.562.564.564 0 0 0-.566-.561.564.564 0 0 0-.566.561c0 .31.253.562.566.562m.045 1.597a.677.677 0 0 1-.68.676.68.68 0 0 1-.679-.676c0-.373.304-.675.68-.675.375 0 .68.302.68.675Zm-2.74.676a.79.79 0 0 0 .791-.786.79.79 0 0 0-.791-.787.79.79 0 0 0-.792.787c0 .434.354.786.792.786m-1.494-.36c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.497.406-.9.906-.9s.905.403.905.9m-3.529 2.18a1.06 1.06 0 0 0 1.063-1.056 1.06 1.06 0 0 0-1.063-1.056A1.06 1.06 0 0 0 3.92 10.42a1.06 1.06 0 0 0 1.064 1.056Zm-1.45.9c0 .696-.568 1.26-1.268 1.26S1 13.073 1 12.377c0-.695.567-1.259 1.267-1.259s1.268.564 1.268 1.26Zm.386-3.531A1.06 1.06 0 0 0 4.985 7.79 1.06 1.06 0 0 0 3.92 6.733 1.06 1.06 0 0 0 2.858 7.79 1.06 1.06 0 0 0 3.92 8.846Zm3.53-2.181c0 .497-.405.9-.906.9a.903.903 0 0 1-.905-.9c0-.496.405-.9.905-.9s.906.404.906.9M6.162 5.182c.5 0 .905-.403.905-.9 0-.496-.405-.9-.905-.9s-.906.404-.906.9c0 .497.406.9.906.9m3.19-1.326a.79.79 0 0 1-.791.787.79.79 0 0 1-.792-.787c0-.434.354-.786.792-.786.437 0 .791.352.791.786m1.268.788c.375 0 .68-.303.68-.675a.677.677 0 0 0-.68-.676.68.68 0 0 0-.68.675c0 .373.304.676.68.676m1.063 1.708a.68.68 0 0 1-.68.675.677.677 0 0 1-.68-.675c0-.373.305-.675.68-.675s.68.302.68.675m-2.739.695a.79.79 0 0 0 .792-.786.79.79 0 0 0-.792-.786.79.79 0 0 0-.791.786c0 .434.354.786.791.786m-1.832 5.578a.407.407 0 0 1-.408.405.407.407 0 0 1-.408-.405c0-.223.182-.405.408-.405s.408.181.408.405m1.221.201a.496.496 0 0 0 .497-.494.496.496 0 0 0-.497-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m2.354-1.236c0 .31-.253.562-.565.562a.564.564 0 0 1-.566-.562c0-.31.253-.562.566-.562s.565.252.565.562m-.135 2.361c.375 0 .68-.302.68-.675a.677.677 0 0 0-.68-.675.677.677 0 0 0-.68.675c0 .373.304.675.68.675m-1.608-.135c0 .31-.253.562-.566.562a.564.564 0 0 1-.565-.562c0-.31.253-.562.565-.562.313 0 .566.252.566.562m-2.488.538a.496.496 0 0 0 .498-.494.496.496 0 0 0-.498-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m.588.991c0 .31-.254.562-.566.562a.564.564 0 0 1-.566-.562c0-.31.253-.562.566-.562s.566.252.566.562m1.742.855c.376 0 .68-.303.68-.675a.677.677 0 0 0-.68-.676.677.677 0 0 0-.68.675c0 .373.305.676.68.676m3.484-1.08a.79.79 0 0 1-.79.786.79.79 0 0 1-.792-.786c0-.435.354-.787.791-.787s.792.352.792.787Zm.794 2.743c.5 0 .906-.402.906-.9 0-.496-.406-.899-.906-.899s-.905.403-.905.9.405.9.905.9Zm-2.536-.518a.79.79 0 0 1-.792.786.79.79 0 0 1-.792-.787.79.79 0 0 1 .792-.786.79.79 0 0 1 .792.787m-2.669 2.316a.79.79 0 0 0 .791-.786.79.79 0 0 0-.792-.786.79.79 0 0 0-.791.786c0 .434.354.786.792.786m2.466 1.079c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.496.405-.9.906-.9.5 0 .905.404.905.9M13.584 22a1.06 1.06 0 0 0 1.064-1.056 1.06 1.06 0 0 0-1.064-1.057 1.06 1.06 0 0 0-1.063 1.057A1.06 1.06 0 0 0 13.584 22m-1.379-2.788c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.497.405-.9.905-.9s.906.403.906.9m3.123.54a1.06 1.06 0 0 0 1.063-1.057 1.06 1.06 0 0 0-1.063-1.056 1.06 1.06 0 0 0-1.064 1.056 1.06 1.06 0 0 0 1.064 1.057m-7.741-2.699a.677.677 0 0 1-.68.676.677.677 0 0 1-.68-.676c0-.373.305-.675.68-.675s.68.302.68.675"
        }
      )
    }
  );
}
I(L());
I(L());
I(L());
I(L());
I(L());
I(L());
I(L());
I(L());
I(L());
var qa = I(L());
function $i(e) {
  return /* @__PURE__ */ (0, qa.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, qa.jsx)(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.533 9.321A7 7 0 1 0 19 12a1 1 0 1 1 2 0 9 9 0 1 1-9-9 1 1 0 1 1 0 2 7 7 0 0 0-6.467 4.321",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var Ja = I(L());
function ll(e) {
  return /* @__PURE__ */ (0, Ja.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, Ja.jsx)(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 11V8.104C8 6.176 9.577 5 11.5 5s3.482 1.176 3.482 3.104L15 11h2.018L17 8.104C17 5.285 14.31 3 11.5 3S6 5.285 6 8.104V11c-1.183 0-2 .962-2 2.15v5.7C4 20.039 4.96 21 6.143 21h10.714A2.146 2.146 0 0 0 19 18.85v-5.7c0-1.188-.817-2.15-2-2.15zm5.321 5.272c0 .95-.767 1.72-1.714 1.72s-1.714-.77-1.714-1.72.767-1.72 1.714-1.72 1.714.77 1.714 1.72",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var Qa = I(L());
function ul(e) {
  return /* @__PURE__ */ (0, Qa.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, Qa.jsx)(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 11V8.104C8 6.5 9.577 5 11.5 5S15 6.5 15 8h2c0-2.82-2.69-5-5.5-5S6 5.285 6 8.104V11c-1.183 0-2 .962-2 2.15v5.7C4 20.039 4.96 21 6.143 21h10.714A2.146 2.146 0 0 0 19 18.85v-5.7c0-1.188-.96-2.15-2.143-2.15zm5.321 5.272c0 .95-.767 1.72-1.714 1.72s-1.714-.77-1.714-1.72.767-1.72 1.714-1.72 1.714.77 1.714 1.72",
          clipRule: "evenodd"
        }
      )
    }
  );
}
I(L());
var ei = I(L());
function cl(e) {
  return /* @__PURE__ */ (0, ei.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, ei.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M21 9a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2h16a1 1 0 0 1 1 1m0 6a1 1 0 0 1-1 1H10a1 1 0 1 1 0-2h10a1 1 0 0 1 1 1"
        }
      )
    }
  );
}
I(L());
var ti = I(L());
function Gi(e) {
  return /* @__PURE__ */ (0, ti.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, ti.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M5 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m9-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0m7 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        }
      )
    }
  );
}
I(L());
I(L());
I(L());
I(L());
I(L());
var ta = I(L());
function fl(e) {
  return /* @__PURE__ */ (0, ta.jsxs)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ (0, ta.jsx)(
          "path",
          {
            fill: "currentColor",
            d: "M11 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
          }
        ),
        /* @__PURE__ */ (0, ta.jsx)(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M2 8a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v8a6 6 0 0 1-6 6H8a6 6 0 0 1-6-6zm2 0a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v3.871a19.13 19.13 0 0 1-16 0zm0 6.051V16a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-1.949a21.13 21.13 0 0 1-16 0",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
I(L());
I(L());
var ri = I(L());
function Hi(e) {
  return /* @__PURE__ */ (0, ri.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, ri.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
        }
      )
    }
  );
}
var ra = I(L());
function dl(e) {
  return /* @__PURE__ */ (0, ra.jsxs)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ (0, ra.jsx)(
          "path",
          {
            fill: "currentColor",
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
          }
        ),
        /* @__PURE__ */ (0, ra.jsx)("path", { fill: "currentColor", d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10" })
      ]
    }
  );
}
I(L());
I(L());
I(L());
I(L());
var ni = I(L());
function vl(e) {
  return /* @__PURE__ */ (0, ni.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, ni.jsx)(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11 4a7 7 0 1 0 3.594 13.008l3.699 3.7a1 1 0 0 0 1.414-1.415l-3.555-3.555A7 7 0 0 0 11 4m-5 7a5 5 0 1 1 10 0 5 5 0 0 1-10 0",
          clipRule: "evenodd"
        }
      )
    }
  );
}
I(L());
I(L());
I(L());
I(L());
var ai = I(L());
function ml(e) {
  return /* @__PURE__ */ (0, ai.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, ai.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M12 6a1 1 0 0 0-1 1v9.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L13 16.586V7a1 1 0 0 0-1-1"
        }
      )
    }
  );
}
var ii = I(L());
function oi(e) {
  return /* @__PURE__ */ (0, ii.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, ii.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M11.293 4.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 7.414V17a1 1 0 1 1-2 0V7.414L8.707 9.707a1 1 0 0 1-1.414-1.414z"
        }
      )
    }
  );
}
I(L());
I(L());
I(L());
I(L());
var si = I(L());
function hl(e) {
  return /* @__PURE__ */ (0, si.jsx)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ (0, si.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M17.35 9c.578 0 .867.681.459 1.08l-4.85 4.735a.66.66 0 0 1-.917 0l-4.85-4.735C6.781 9.68 7.071 9 7.648 9z"
        }
      )
    }
  );
}
I(L());
I(L());
I(L());
I(L());
I(L());
I(L());
I(L());
var na = I(L());
function Yi(e) {
  return /* @__PURE__ */ (0, na.jsxs)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ (0, na.jsx)(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M18.72 6.695a1 1 0 1 0-1.44-1.39l-1.518 1.572C14.601 6.348 13.331 6 12 6 8.739 6 5.843 8.092 4.017 9.805c-1.29 1.212-1.29 3.178 0 4.39a18 18 0 0 0 2.666 2.083l-1.695 1.755a1 1 0 0 0 1.438 1.39zM8.67 14.219l5.431-5.623a4 4 0 0 0-5.43 5.623Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ (0, na.jsx)(
          "path",
          {
            fill: "currentColor",
            d: "M16 12a4 4 0 0 1-3.975 4l-1.749 1.81c.56.122 1.136.19 1.724.19 3.26 0 6.157-2.092 7.983-3.805 1.29-1.212 1.29-3.178 0-4.39a20 20 0 0 0-1.071-.936l-2.914 3.017z"
          }
        )
      ]
    }
  );
}
var aa = I(L());
function zi(e) {
  return /* @__PURE__ */ (0, aa.jsxs)(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ (0, aa.jsx)("path", { fill: "currentColor", d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4" }),
        /* @__PURE__ */ (0, aa.jsx)(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M19.983 9.805c1.29 1.212 1.29 3.178 0 4.39C18.157 15.908 15.26 18 12 18c-3.261 0-6.157-2.092-7.983-3.805-1.29-1.212-1.29-3.178 0-4.39C5.843 8.092 8.74 6 12 6s6.157 2.092 7.983 3.805M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
I(L());
/*! Bundled license information:

react/cjs/react.production.min.js:
  (**
   * @license React
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react/cjs/react.development.js:
  (**
   * @license React
   * react.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react/cjs/react-jsx-runtime.production.min.js:
  (**
   * @license React
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react/cjs/react-jsx-runtime.development.js:
  (**
   * @license React
   * react-jsx-runtime.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)
*/
function Qf({
  label: e,
  isChecked: t,
  isDisabled: r,
  onChange: n
}) {
  const i = t ? dl : Hi;
  return /* @__PURE__ */ o.jsxs(
    "label",
    {
      className: A("group flex flex-row gap-x-1 text-center", {
        disabled: r,
        "cursor-pointer": !r
      }),
      children: [
        /* @__PURE__ */ o.jsxs(
          "div",
          {
            className: A("relative flex h-10 w-10 items-center justify-center rounded-full", {
              "state-layer": !r
            }),
            children: [
              /* @__PURE__ */ o.jsx(
                "input",
                {
                  type: "radio",
                  checked: t,
                  onChange: n,
                  disabled: r,
                  className: A("peer appearance-none disabled:opacity-40")
                }
              ),
              /* @__PURE__ */ o.jsx(
                "span",
                {
                  className: `absolute
                    text-neutral-40 peer-checked:text-primary-30 peer-disabled:opacity-40 peer-checked:peer-disabled:text-neutral-40 dark:text-neutral-60 dark:peer-checked:peer-disabled:text-neutral-40 [&_svg]:h-6 [&_svg]:w-6
                `,
                  children: /* @__PURE__ */ o.jsx(i, {})
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ o.jsx("span", { className: "inline-flex items-center justify-center text-label-lg text-neutral-40 group-[.disabled]:text-opacity-40 dark:text-neutral-60 group-[.disabled]:dark:text-opacity-40", children: e })
      ]
    }
  );
}
const pl = "bg-transparent", gl = "bg-primary-100 dark:bg-neutral-6", xl = "text-neutral-60 dark:text-neutral-40", bl = "enabled:hover:text-neutral-40 enabled:dark:hover:text-neutral-60", yl = "enabled:focused:text-neutral-40 enabled:dark:focused:text-neutral-60", _l = `${xl} ${bl} ${yl}`, wl = "text-neutral-10 dark:text-neutral-92", El = `
    relative
    before:content-['']
    border-b
    border-shader-neutral-light-8
    dark:border-shader-neutral-dark-8
    before:block
    before:w-full
    before:border-b
    before:absolute
    before:bottom-[-0.8px]
    before:left-0
    enabled:before:w-[calc(100%-16px)]
    enabled:before:left-2
    enabled:before:border-primary-30
    enabled:before:dark:border-primary-80`, Sl = `
    relative
    before:content-['']
    before:block
    before:w-full
    before:border-b
    before:border-shader-neutral-light-8
    before:dark:border-shader-neutral-dark-8
    before:absolute
    before:bottom-0
    before:left-0
    hover:before:w-[calc(100%-16px)]
    hover:before:left-2
    hover:before:border-neutral-70
    hover:before:dark:border-neutral-40`;
var Tr = /* @__PURE__ */ ((e) => (e.Rounded = "rounded", e.Underlined = "underlined", e))(Tr || {});
function ed({
  icon: e,
  label: t,
  selected: r,
  disabled: n,
  onClick: i,
  type: s = Tr.Rounded,
  isNested: u = !1
}) {
  const c = s === Tr.Underlined, h = r ? c ? "bg-transparent" : gl : pl, m = c ? r ? El : Sl : "", y = r ? wl : _l, x = c ? u ? "px-md py-sm" : "px-lg py-md" : "px-sm py-[6px]", j = c ? "" : "rounded-full", R = u ? c ? "text-title-sm" : "text-label-md" : c ? "text-title-md" : "text-label-lg";
  return /* @__PURE__ */ o.jsx(
    nt,
    {
      onClick: i,
      className: A(
        "enabled:state-layer relative flex items-center disabled:opacity-40",
        h,
        y,
        x,
        j,
        m,
        {
          "pl-xs": !!e && !c
        }
      ),
      disabled: n,
      children: /* @__PURE__ */ o.jsxs("div", { className: A("flex flex-row items-center justify-center gap-2", R), children: [
        e && /* @__PURE__ */ o.jsx("span", { children: e }),
        /* @__PURE__ */ o.jsx("span", { className: "shrink-0 font-inter", children: t })
      ] })
    }
  );
}
const Ki = tn(
  ({
    isChecked: e,
    isIndeterminate: t,
    label: r,
    isLabelFirst: n,
    isDisabled: i,
    onCheckedChange: s,
    name: u
  }, c) => {
    const h = at(null);
    wt(() => {
      h.current && (h.current.indeterminate = t ?? !1);
    }, [t, h]);
    const m = t ? al : rl;
    function y(x) {
      c && (typeof c == "function" ? c(x) : c.current = x), h.current = x;
    }
    return /* @__PURE__ */ o.jsxs(
      "div",
      {
        className: A("group inline-flex", n ? "flex-row-reverse" : "flex-row", {
          disabled: i,
          "gap-x-2": r
        }),
        children: [
          /* @__PURE__ */ o.jsx(
            "input",
            {
              id: u,
              name: u,
              type: "checkbox",
              className: "peer hidden appearance-none",
              checked: e,
              ref: y,
              disabled: i,
              onChange: (x) => {
                s == null || s(x);
              }
            }
          ),
          /* @__PURE__ */ o.jsx(
            "span",
            {
              onClick: () => {
                var x;
                return (x = h.current) == null ? void 0 : x.click();
              },
              className: "peer-enabled:state-layer relative inset-0 flex h-5 w-5 items-center justify-center rounded border border-neutral-80 text-neutral-40 group-[.disabled]:cursor-not-allowed peer-disabled:text-neutral-70 peer-disabled:text-opacity-40 peer-disabled:opacity-40 peer-[&:is(:checked,:indeterminate)]:border-primary-30 peer-[&:is(:checked,:indeterminate)]:bg-primary-30 peer-[&:is(:checked,:indeterminate)]:text-white peer-[&:not(:checked,:indeterminate)]:text-opacity-40 disabled:peer-[&:not(:checked,:indeterminate)]:border-neutral-70 dark:border-neutral-20 dark:text-neutral-60 dark:peer-disabled:text-neutral-30 dark:peer-disabled:text-opacity-40 dark:peer-disabled:peer-[&:not(:checked,:indeterminate)]:border-neutral-30 dark:peer-disabled:peer-[&:is(:checked,:indeterminate)]:bg-neutral-40 peer-disabled:[&:is(:checked,:indeterminate)]:border-neutral-60 peer-disabled:[&:is(:checked,:indeterminate)]:bg-neutral-60 dark:peer-disabled:[&:is(:checked,:indeterminate)]:border-neutral-40 [&_svg]:h-4 [&_svg]:w-4 peer-[&:not(:checked,:indeterminate)]:[&_svg]:hidden",
              children: /* @__PURE__ */ o.jsx(m, {})
            }
          ),
          /* @__PURE__ */ o.jsx(Cl, { label: r, name: u })
        ]
      }
    );
  }
);
function Cl({ label: e, name: t }) {
  return /* @__PURE__ */ o.jsx(
    "label",
    {
      htmlFor: t,
      className: "text-label-lg text-neutral-40 group-[.disabled]:cursor-not-allowed group-[.disabled]:text-opacity-40 dark:text-neutral-60 group-[.disabled]:dark:text-opacity-40",
      children: e
    }
  );
}
var mr = /* @__PURE__ */ ((e) => (e.Vertical = "vertical", e.Horizontal = "horizontal", e))(mr || {});
const jl = "bg-shader-neutral-light-8 dark:bg-shader-neutral-dark-8", Rl = {
  [mr.Horizontal]: "w-full",
  [mr.Vertical]: "h-full"
}, kl = "1px";
function Ol({
  type: e = mr.Horizontal,
  width: t,
  height: r,
  lineHeight: n = kl
}) {
  const i = {
    ...e === mr.Horizontal ? { height: n } : { width: n }
  };
  let s = Rl[e];
  return t && e === mr.Horizontal ? s = t : r && e === mr.Vertical && (s = r), /* @__PURE__ */ o.jsx("div", { className: A(jl, s), style: i });
}
var Cn = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(Cn || {}), fr = /* @__PURE__ */ ((e) => (e.Top = "top", e.Bottom = "bottom", e.Left = "left", e.Right = "right", e))(fr || {});
function Mr({
  text: e,
  position: t = fr.Top,
  maxWidth: r = "max-w-[200px]",
  offset: n = 8,
  openDelay: i = 0,
  closeDelay: s = 100,
  children: u
}) {
  const c = at(null), h = at(null), [m, y] = vt(!1), [x, j] = vt({ top: 0, left: 0 }), R = at(), T = at(), k = () => {
    clearTimeout(R.current), clearTimeout(T.current);
  }, N = () => {
    k(), R.current = setTimeout(() => y(!0), i);
  }, P = () => {
    k(), T.current = setTimeout(() => y(!1), s);
  };
  return ma(() => {
    var H;
    if (!m) return;
    const D = (H = c.current) == null ? void 0 : H.getBoundingClientRect();
    if (!D) return;
    const z = {
      [fr.Top]: {
        top: D.top - n,
        left: D.left + D.width / 2,
        transform: "translate(-50%, -100%)"
      },
      [fr.Bottom]: {
        top: D.bottom + n,
        left: D.left + D.width / 2,
        transform: "translate(-50%, 0)"
      },
      [fr.Left]: {
        top: D.top + D.height / 2,
        left: D.left - n,
        transform: "translate(-100%, -50%)"
      },
      [fr.Right]: {
        top: D.top + D.height / 2,
        left: D.right + n,
        transform: "translate(0, -50%)"
      }
    }[t];
    j({ top: z.top, left: z.left }), h.current.style.transform = z.transform;
  }, [m, t, n]), ma(() => {
    if (!m) return;
    const D = () => {
      var H;
      const z = (H = c.current) == null ? void 0 : H.getBoundingClientRect();
      z && j((Y) => ({ ...Y, left: z.left + z.width / 2 }));
    };
    return window.addEventListener("scroll", D, !0), window.addEventListener("resize", D), () => {
      window.removeEventListener("scroll", D, !0), window.removeEventListener("resize", D);
    };
  }, [m]), /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(
      "div",
      {
        ref: c,
        className: "inline-block cursor-pointer",
        onMouseEnter: N,
        onFocus: N,
        onMouseLeave: P,
        onBlur: P,
        children: u
      }
    ),
    m && ss(
      /* @__PURE__ */ o.jsx(
        "div",
        {
          ref: h,
          role: "tooltip",
          style: {
            position: "fixed",
            top: x.top,
            left: x.left,
            transition: "opacity .15s ease",
            opacity: 1
          },
          className: A("z-[999] w-max rounded bg-neutral-80 p-xs text-neutral-10 dark:bg-neutral-30 dark:text-neutral-92", r),
          onMouseEnter: N,
          onMouseLeave: P,
          children: /* @__PURE__ */ o.jsx("p", { className: "w-full break-words", children: e })
        }
      ),
      document.body
    )
  ] });
}
function td({
  keyText: e,
  value: t,
  tooltipPosition: r,
  tooltipText: n,
  supportingLabel: i,
  size: s = Cn.Small,
  isTruncated: u = !1,
  copyText: c,
  onCopySuccess: h,
  onCopyError: m,
  fullwidth: y,
  isReverse: x = !1,
  valueHoverTitle: j
}) {
  const R = x ? "flex-row-reverse" : "flex-row";
  async function T(k) {
    if (navigator.clipboard && c)
      try {
        await navigator.clipboard.writeText(c), h == null || h(k, c);
      } catch (N) {
        console.error("Failed to copy:", N), m == null || m(N, c);
      }
  }
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: A(
        "flex w-full items-baseline gap-xs py-xxs font-inter",
        R,
        {
          "justify-between": y
        }
      ),
      children: [
        /* @__PURE__ */ o.jsxs(
          "div",
          {
            className: A("flex shrink-0 flex-row items-center gap-x-0.5", {
              "w-1/4": !y
            }),
            children: [
              /* @__PURE__ */ o.jsx("span", { className: "text-body-md text-neutral-40 dark:text-neutral-60", children: e }),
              n && /* @__PURE__ */ o.jsx(Mr, { text: n, position: r, children: /* @__PURE__ */ o.jsx(Fn, { className: "text-neutral-60 dark:text-neutral-40" }) })
            ]
          }
        ),
        /* @__PURE__ */ o.jsxs(
          "div",
          {
            className: A("flex flex-row items-baseline gap-1 break-all", {
              "w-3/4": !y,
              truncate: u
            }),
            children: [
              /* @__PURE__ */ o.jsx(
                "span",
                {
                  title: j,
                  className: A(
                    "text-neutral-10 dark:text-neutral-92",
                    s === Cn.Medium ? "text-body-lg" : "text-body-md",
                    { truncate: u }
                  ),
                  children: t
                }
              ),
              i && /* @__PURE__ */ o.jsx(
                "span",
                {
                  className: A(
                    "text-neutral-60 dark:text-neutral-40",
                    s === Cn.Medium ? "text-body-md" : "text-body-sm"
                  ),
                  children: i
                }
              ),
              /* @__PURE__ */ o.jsx("div", { className: "self-center", children: c && /* @__PURE__ */ o.jsx(nt, { onClick: T, children: /* @__PURE__ */ o.jsx(Ea, { className: "text-neutral-60 dark:text-neutral-40" }) }) })
            ]
          }
        )
      ]
    }
  );
}
var dt = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e))(dt || {});
const Tl = {
  [dt.Small]: "text-title-sm",
  [dt.Medium]: "text-title-md",
  [dt.Large]: "text-title-lg"
}, Nl = {
  [dt.Small]: "text-label-md",
  [dt.Medium]: "text-label-md",
  [dt.Large]: "text-label-lg"
}, Pl = {
  [dt.Small]: "text-label-md",
  [dt.Medium]: "text-label-md",
  [dt.Large]: "text-label-lg"
};
function rd({
  size: e = dt.Medium,
  isCentered: t,
  supportingLabel: r,
  label: n,
  text: i,
  tooltipPosition: s,
  tooltipText: u
}) {
  const c = Tl[e], h = Nl[e], m = Pl[e], y = t ? "items-center" : "items-start", x = e === dt.Small ? "gap-0.5" : "gap-1";
  return /* @__PURE__ */ o.jsxs("div", { className: A("flex flex-col", y, x), children: [
    /* @__PURE__ */ o.jsxs("div", { className: "flex flex-row flex-wrap items-center gap-0.5", children: [
      /* @__PURE__ */ o.jsx(
        "span",
        {
          className: A("font-inter text-neutral-10 dark:text-neutral-92", c),
          children: i
        }
      ),
      r && /* @__PURE__ */ o.jsx(
        "span",
        {
          className: A(
            "font-inter text-neutral-60 dark:text-neutral-40",
            h
          ),
          children: r
        }
      )
    ] }),
    /* @__PURE__ */ o.jsx("div", { className: "flex flex-row items-center gap-x-0.5", children: /* @__PURE__ */ o.jsxs(
      "span",
      {
        className: A(
          "flex items-center font-inter text-neutral-60 dark:text-neutral-40",
          m
        ),
        children: [
          n,
          u && /* @__PURE__ */ o.jsx("div", { className: "ml-xxxs flex items-center", children: /* @__PURE__ */ o.jsx(Mr, { text: u, position: s, children: /* @__PURE__ */ o.jsx(Fn, { className: "text-neutral-60 dark:text-neutral-40" }) }) })
        ]
      }
    ) })
  ] });
}
function Al({
  showRightIcon: e,
  hideBottomBorder: t,
  onClick: r,
  isDisabled: n,
  children: i,
  isHighlighted: s
}) {
  function u(h) {
    (h.key === "Enter" || h.key === " ") && !n && r && r();
  }
  function c() {
    !n && r && r();
  }
  return /* @__PURE__ */ o.jsx(
    "div",
    {
      className: A(
        "w-full",
        {
          "border-b border-shader-neutral-light-8 pb-xs dark:border-shader-neutral-dark-8": !t
        },
        { "opacity-40": n }
      ),
      children: /* @__PURE__ */ o.jsxs(
        "div",
        {
          onClick: c,
          role: "button",
          tabIndex: 0,
          onKeyDown: u,
          className: A(
            "relative flex flex-row items-center justify-between px-md py-sm text-neutral-10 dark:text-neutral-92",
            !n && r ? "cursor-pointer" : "cursor-default",
            {
              "bg-shader-primary-dark-16 dark:bg-shader-inverted-dark-16": s,
              "state-layer": !n
            }
          ),
          children: [
            i,
            e && /* @__PURE__ */ o.jsx(
              _t,
              {
                size: tt.Small,
                type: Ce.Ghost,
                disabled: n,
                icon: /* @__PURE__ */ o.jsx(wa, {})
              }
            )
          ]
        }
      )
    }
  );
}
function nd({
  title: e,
  titleCentered: t,
  onBack: r,
  onClose: n,
  testId: i
}) {
  const s = t ? "text-center" : r ? "ml-1" : "", u = t && (!r || !n);
  return /* @__PURE__ */ o.jsxs("div", { className: "flex min-h-[56px] w-full items-center bg-neutral-100 px-md--rs pb-xs pt-sm text-neutral-10 dark:bg-neutral-6 dark:text-neutral-92 [&_svg]:h-5 [&_svg]:w-5", children: [
    r ? /* @__PURE__ */ o.jsx(
      _t,
      {
        size: tt.Small,
        type: Ce.Ghost,
        onClick: r,
        icon: /* @__PURE__ */ o.jsx(Ui, {})
      }
    ) : u && /* @__PURE__ */ o.jsx("div", { className: "w-9" }),
    /* @__PURE__ */ o.jsx("div", { className: A("flex-grow", s), children: /* @__PURE__ */ o.jsx("span", { className: "font-inter text-title-lg", "data-testid": i, children: e }) }),
    n ? /* @__PURE__ */ o.jsx(
      _t,
      {
        size: tt.Small,
        type: Ce.Ghost,
        onClick: n,
        icon: /* @__PURE__ */ o.jsx(rn, {}),
        testId: "close-icon"
      }
    ) : u && /* @__PURE__ */ o.jsx("div", { className: "w-9" })
  ] });
}
function ad({
  children: e,
  hasBorder: t,
  bgColor: r = "bg-neutral-100 dark:bg-neutral-6"
}) {
  const n = t ? "border border-shader-neutral-light-8 dark:border-shader-neutral-dark-8" : "border border-transparent";
  return /* @__PURE__ */ o.jsx("div", { className: A("flex w-full flex-col rounded-xl", r, n), children: e });
}
var Vt = /* @__PURE__ */ ((e) => (e.Default = "default", e.Error = "error", e.Success = "success", e.Warning = "warning", e))(Vt || {}), jn = /* @__PURE__ */ ((e) => (e.Default = "default", e.Elevated = "elevated", e))(jn || {});
const Dl = {
  [Vt.Default]: "bg-primary-90 dark:bg-primary-10 text-primary-20 dark:text-primary-90",
  [Vt.Error]: "bg-error-90 dark:bg-error-10 text-error-20 dark:text-error-90",
  [Vt.Success]: "bg-tertiary-90 dark:bg-tertiary-10 text-tertiary-20 dark:text-tertiary-90",
  [Vt.Warning]: "bg-warning-90 dark:bg-warning-20 text-warning-10 dark:text-warning-90"
}, Il = {
  [Vt.Default]: "bg-primary-90 dark:bg-primary-10",
  [Vt.Error]: "bg-error-90 dark:bg-error-10",
  [Vt.Success]: "bg-tertiary-90 dark:bg-tertiary-10",
  [Vt.Warning]: "bg-warning-90 dark:bg-warning-20"
};
function id({
  icon: e,
  title: t,
  supportingText: r,
  type: n,
  style: i
}) {
  const s = Dl[n], u = i === jn.Elevated ? Il[n] : "";
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: A("flex flex-row items-start gap-4 py-xs pr-lg", u, {
        "rounded-lg pl-xs": i === jn.Elevated
      }),
      children: [
        e && /* @__PURE__ */ o.jsx(
          "span",
          {
            className: A(
              "flex items-center justify-center rounded-lg [&_svg]:h-4 [&_svg]:w-4",
              s,
              {
                "p-xs": i === jn.Default
              }
            ),
            children: e
          }
        ),
        /* @__PURE__ */ o.jsxs("div", { className: "flex flex-col gap-1", children: [
          t && /* @__PURE__ */ o.jsx("span", { className: "text-title-sm text-neutral-10 dark:text-neutral-92", children: t }),
          r && /* @__PURE__ */ o.jsx("span", { className: "text-body-sm text-neutral-40 dark:text-neutral-60", children: r })
        ] })
      ]
    }
  );
}
var Pt = /* @__PURE__ */ ((e) => (e.Default = "default", e.Error = "error", e.Warning = "warning", e.Success = "success", e))(Pt || {});
const li = {
  [Pt.Default]: "text-neutral-10 dark:text-neutral-92",
  [Pt.Error]: "text-error-20 dark:text-error-90",
  [Pt.Warning]: "text-warning-10 dark:text-warning-90",
  [Pt.Success]: "text-tertiary-20 dark:text-tertiary-90"
}, Ll = {
  [Pt.Default]: "bg-primary-90 dark:bg-primary-10",
  [Pt.Error]: "bg-error-90 dark:bg-error-10",
  [Pt.Warning]: "bg-warning-90 dark:bg-warning-20",
  [Pt.Success]: "bg-tertiary-90 dark:bg-tertiary-10"
};
function od({
  text: e,
  duration: t = 2e3,
  onClose: r,
  showClose: n,
  type: i = Pt.Default
}) {
  return wt(() => {
    if (t) {
      const s = setTimeout(r, t);
      return () => clearTimeout(s);
    }
  }, [t, r]), /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: A(
        "transition-all duration-300 ease-out",
        "z-99 bottom-0",
        "flex w-full items-center justify-between gap-xxs rounded-md py-sm pl-md pr-sm",
        Ll[i]
      ),
      children: [
        /* @__PURE__ */ o.jsx("div", { className: A("w-full text-left text-body-md", li[i]), children: e }),
        n && /* @__PURE__ */ o.jsx(
          rn,
          {
            className: A("h-5 w-5 cursor-pointer", li[i]),
            onClick: r
          }
        )
      ]
    }
  );
}
var pa = /* @__PURE__ */ ((e) => (e.Image = "image", e.Video = "video", e))(pa || {});
function sd({
  assetType: e = pa.Image,
  assetSrc: t,
  altText: r,
  onIconClick: n,
  onClick: i,
  icon: s = /* @__PURE__ */ o.jsx(Gi, {}),
  assetTitle: u,
  isHoverable: c = !0
}) {
  const [h, m] = vt(!1), y = (x) => {
    n == null || n(x), x == null || x.stopPropagation();
  };
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: A("relative aspect-square w-full overflow-hidden rounded-xl", {
        "group cursor-pointer": c
      }),
      onClick: i,
      children: [
        e === pa.Video ? /* @__PURE__ */ o.jsx("video", { src: t, className: "h-full w-full object-cover", autoPlay: !0, loop: !0, muted: !0 }) : h ? /* @__PURE__ */ o.jsx("div", { className: "flex h-full w-full items-center justify-center bg-neutral-96 dark:bg-neutral-10", children: /* @__PURE__ */ o.jsx(fl, { className: "h-4 w-4 text-neutral-40 dark:text-neutral-60" }) }) : /* @__PURE__ */ o.jsx(
          "img",
          {
            src: t,
            alt: r,
            className: "h-full w-full object-cover",
            onError: () => m(!0)
          }
        ),
        c && /* @__PURE__ */ o.jsx("div", { className: "absolute left-0 top-0 h-full w-full bg-cover bg-center bg-no-repeat group-hover:bg-shader-neutral-light-48 group-hover:transition group-hover:duration-300 group-hover:ease-in-out group-hover:dark:bg-shader-primary-dark-48" }),
        c && n && /* @__PURE__ */ o.jsx(
          nt,
          {
            className: "absolute right-2 top-2 h-9 w-9 cursor-pointer rounded-full p-xs opacity-0 transition-opacity duration-300 group-hover:bg-shader-neutral-light-72 group-hover:opacity-100 [&_svg]:h-5 [&_svg]:w-5 [&_svg]:text-primary-100",
            onClick: y,
            children: s
          }
        ),
        c && u && /* @__PURE__ */ o.jsx("div", { className: "absolute bottom-0 flex items-center justify-center p-xs opacity-0 transition-opacity duration-300 group-hover:opacity-100", children: /* @__PURE__ */ o.jsx("span", { className: "text-title-md text-neutral-100", children: u }) })
      ]
    }
  );
}
function ld({
  color: e = "text-primary-30 dark:text-primary-80",
  size: t = "w-5 h-5",
  text: r,
  testId: n
}) {
  return /* @__PURE__ */ o.jsxs("div", { className: "flex items-center justify-center gap-xs", children: [
    /* @__PURE__ */ o.jsx($i, { className: A("animate-spin", e, t), "data-testid": n }),
    r && /* @__PURE__ */ o.jsx("span", { className: A("text-body-sm", e), children: r })
  ] });
}
function Ml({ width: e = "w-full", height: t = "h-4" }) {
  return /* @__PURE__ */ o.jsx(
    "div",
    {
      className: A(
        "animate-pulse rounded-md bg-gradient-to-r from-shader-primary-light-8 bg-[length:1000px_100%] dark:from-shader-primary-dark-8",
        e,
        t
      )
    }
  );
}
function ud({
  children: e,
  widthClass: t = "w-full",
  heightClass: r = "h-3",
  hasSecondaryColors: n,
  isRounded: i = !0
}) {
  return /* @__PURE__ */ o.jsx(
    "div",
    {
      className: A(
        "animate-pulse rounded-full",
        t,
        r,
        i && "rounded-full",
        n ? "bg-neutral-80 dark:bg-neutral-10" : "bg-neutral-90 dark:bg-neutral-12"
      ),
      children: e
    }
  );
}
var tr = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e))(tr || {}), ga = /* @__PURE__ */ ((e) => (e.Left = "left", e.Right = "right", e))(ga || {});
const Fl = "relative inline-flex items-center p-xxs border rounded-full cursor-pointer", bn = {
  active: "bg-primary-30 border-primary-30",
  inactive: "bg-primary-100 dark:bg-neutral-6 border-neutral-70 dark:border-neutral-40",
  disabledActive: "bg-neutral-70 border-neutral-70",
  disabled: "opacity-40 cursor-not-allowed"
}, Bl = {
  [tr.Small]: "h-5 w-10",
  [tr.Default]: "h-6 w-12"
}, Vl = "absolute rounded-full transition-all duration-200 ease-in", ui = {
  [tr.Small]: {
    unchecked: "left-1",
    checked: "left-8 -translate-x-full"
  },
  [tr.Default]: {
    unchecked: "left-1",
    checked: "left-10 -translate-x-full"
  }
}, ci = {
  unchecked: "bg-neutral-60",
  checked: "bg-white"
}, Wl = {
  [tr.Small]: "h-3 w-3",
  [tr.Default]: "h-4 w-4"
}, Ul = "inline-flex items-center gap-2", $l = "text-label-lg text-neutral-40 dark:text-neutral-60", cd = tn(
  ({
    label: e,
    isToggled: t,
    labelPosition: r = ga.Right,
    isDisabled: n = !1,
    onChange: i,
    name: s,
    size: u = tr.Default,
    testId: c
  }, h) => {
    const m = at(null);
    function y(N) {
      const P = N.target.checked;
      i == null || i(P, N);
    }
    function x(N) {
      h && (typeof h == "function" ? h(N) : h.current = N), m.current = N;
    }
    const j = A(Fl, {
      [bn.active]: t && !n,
      [bn.inactive]: !t,
      [bn.disabledActive]: n && t,
      [bn.disabled]: n,
      [Bl[u]]: !0
    }), R = A(Vl, {
      [ui[u].unchecked]: !t,
      [ui[u].checked]: t,
      [ci.unchecked]: !t,
      [ci.checked]: t,
      [Wl[u]]: !0
    }), T = A(Ul, {
      "flex-row-reverse": r === ga.Left,
      "cursor-not-allowed": n
    }), k = A($l, {
      "opacity-40": n && !t
    });
    return /* @__PURE__ */ o.jsxs("div", { className: T, children: [
      /* @__PURE__ */ o.jsx(
        "input",
        {
          id: s,
          name: s,
          type: "checkbox",
          className: "sr-only",
          checked: t,
          ref: x,
          disabled: n,
          onChange: y,
          "data-testid": c
        }
      ),
      /* @__PURE__ */ o.jsx(
        "span",
        {
          role: "switch",
          onClick: () => {
            var N;
            return (N = m.current) == null ? void 0 : N.click();
          },
          className: j,
          children: /* @__PURE__ */ o.jsx("span", { className: R })
        }
      ),
      e && /* @__PURE__ */ o.jsx("label", { htmlFor: s, className: k, children: e })
    ] });
  }
);
function Gl({
  text: e,
  isCopyable: t,
  isExternal: r,
  externalLink: n,
  copyText: i = e,
  onCopySuccess: s,
  onCopyError: u,
  onOpen: c
}) {
  async function h(y) {
    if (navigator.clipboard) {
      y == null || y.stopPropagation();
      try {
        await navigator.clipboard.writeText(i), s == null || s(y, i);
      } catch (x) {
        console.error("Failed to copy:", x), u == null || u(x, i);
      }
    }
  }
  function m(y) {
    if (y == null || y.stopPropagation(), n) {
      const x = window.open(n, "_blank", "noopener noreferrer");
      x && (x.opener = null);
    } else
      c == null || c(y);
  }
  return /* @__PURE__ */ o.jsxs("div", { className: "group flex flex-row items-center gap-1 text-neutral-40 dark:text-neutral-60", children: [
    /* @__PURE__ */ o.jsx("span", { className: A("font-inter text-body-sm"), children: e }),
    t && /* @__PURE__ */ o.jsx(
      nt,
      {
        onClick: h,
        className: "opacity-0 group-hover:opacity-100",
        children: /* @__PURE__ */ o.jsx(Ea, {})
      }
    ),
    r && /* @__PURE__ */ o.jsx(
      nt,
      {
        onClick: m,
        className: "opacity-0 group-hover:opacity-100",
        children: /* @__PURE__ */ o.jsx(tl, {})
      }
    )
  ] });
}
var Wt = /* @__PURE__ */ ((e) => (e.Default = "default", e.Selected = "selected", e))(Wt || {});
const fi = "rounded-full", Hl = {
  [Wt.Default]: "bg-transparent",
  [Wt.Selected]: "bg-primary-90 dark:bg-primary-10"
}, Yl = "outline outline-1 outline-transparent hover:outline-shader-primary-light-8 active:outline-shader-primary-light-12 dark:hover:outline-shader-primary-dark-8 dark:active:outline-shader-primary-dark-12", zl = "hover:bg-shader-primary-light-8 active:bg-shader-primary-light-12 dark:hover:bg-shader-primary-dark-8 dark:active:bg-shader-primary-dark-12 focus:bg-shader-primary-light-12 dark:focus:bg-shader-primary-dark-12", Kl = `${Yl} ${zl}`, Xl = {
  [Wt.Default]: "border-neutral-70 dark:border-neutral-40",
  [Wt.Selected]: "border-transparent"
}, Zl = {
  [Wt.Default]: "text-neutral-40 dark:text-neutral-60",
  [Wt.Selected]: "text-neutral-10 dark:text-neutral-92"
}, ql = "focus-visible:shadow-[0_0_0_2px] focus-visible:shadow-primary-30 focus-visible:outline-none dark:focus-visible:shadow-primary-80";
function fd({
  label: e,
  showClose: t,
  selected: r,
  onClose: n,
  onClick: i,
  avatar: s,
  leadingElement: u,
  trailingElement: c,
  disabled: h
}) {
  const m = r ? Wt.Selected : Wt.Default;
  return /* @__PURE__ */ o.jsx(
    nt,
    {
      onClick: i,
      className: A(
        "border transition-all duration-500 ease-in-out disabled:opacity-40",
        fi,
        Hl[m],
        Xl[m],
        ql
      ),
      disabled: h,
      children: /* @__PURE__ */ o.jsxs(
        "span",
        {
          className: A(
            "flex h-full w-full flex-row items-center gap-x-2",
            s ? "py-xxs" : "py-[6px]",
            s ? "pl-xxs" : u ? "pl-xs" : "pl-sm",
            fi,
            !h && Kl,
            t ? "pr-xs" : "pr-sm",
            Zl[m]
          ),
          children: [
            s ?? u,
            /* @__PURE__ */ o.jsx("span", { className: "text-body-md", children: e }),
            c,
            t && /* @__PURE__ */ o.jsx(
              nt,
              {
                onClick: n,
                className: "cursor-pointer [&_svg]:h-4 [&_svg]:w-4",
                children: /* @__PURE__ */ o.jsx(rn, {})
              }
            )
          ]
        }
      )
    }
  );
}
var Nr = /* @__PURE__ */ ((e) => (e.Outlined = "outlined", e.Filled = "filled", e.Transparent = "transparent", e))(Nr || {});
const Jl = {
  [Nr.Outlined]: "bg-transparent",
  [Nr.Filled]: "bg-neutral-96 dark:bg-neutral-10",
  [Nr.Transparent]: "bg-transparent"
}, Ql = "border border-neutral-70 dark:border-neutral-40";
function dd({
  type: e = Nr.Filled,
  children: t,
  shape: r = Tr.Rounded
}) {
  const n = Jl[e], i = e === Nr.Outlined ? Ql : "", s = r === Tr.Rounded ? "rounded-full gap-1 p-xxs" : "", u = r === Tr.Rounded ? "flex-wrap" : "flex-nowrap overflow-x-auto";
  return /* @__PURE__ */ o.jsx(
    "div",
    {
      className: A("flex flex-row", n, i, s, u),
      children: t
    }
  );
}
var Dr = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(Dr || {});
const eu = {
  [Dr.Small]: "px-md py-sm--rs",
  [Dr.Medium]: "px-md--rs py-sm--rs"
}, tu = {
  [Dr.Small]: "text-title-md",
  [Dr.Medium]: "text-title-lg"
};
function vd({
  title: e,
  subtitle: t,
  trailingElement: r,
  tooltipText: n,
  supportingElement: i,
  tooltipPosition: s,
  size: u = Dr.Medium,
  testId: c
}) {
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: A("flex flex-row items-center justify-between", eu[u]),
      "data-testid": c,
      children: [
        /* @__PURE__ */ o.jsxs("div", { className: "flex flex-row items-center gap-x-xxxs", children: [
          /* @__PURE__ */ o.jsxs("div", { className: "flex flex-col justify-start", children: [
            /* @__PURE__ */ o.jsxs("div", { className: "flex flex-row items-center gap-x-0.5 text-neutral-10 dark:text-neutral-92", children: [
              /* @__PURE__ */ o.jsx("h4", { className: A(tu[u]), children: e }),
              n && /* @__PURE__ */ o.jsx(Mr, { text: n, position: s, children: /* @__PURE__ */ o.jsx(Fn, {}) })
            ] }),
            /* @__PURE__ */ o.jsx("p", { className: "text-label-md text-neutral-60 dark:text-neutral-40", children: t })
          ] }),
          i
        ] }),
        r
      ]
    }
  );
}
function Dn({ children: e, hasErrorStyles: t }) {
  return /* @__PURE__ */ o.jsx(
    "p",
    {
      className: A("text-label-lg text-neutral-40  dark:text-neutral-60 ", {
        ["group-[.errored]:text-error-30 dark:group-[.errored]:text-error-80"]: t
      }),
      children: e
    }
  );
}
const Xi = "w-full bg-transparent text-body-lg caret-primary-30 dark:caret-primary-80 focus:outline-none focus-visible:outline-none disabled:cursor-not-allowed", Zi = "text-neutral-10 dark:text-neutral-92", qi = "enabled:placeholder:text-neutral-40/40  dark:placeholder:text-neutral-60/40 enabled:dark:placeholder:text-neutral-60/40", Ji = "px-md py-sm rounded-lg border border-neutral-80 group-[.enabled]:cursor-text group-[.errored]:border-error-30 hover:group-[.enabled]:border-neutral-50 dark:border-neutral-20 dark:hover:border-neutral-60 dark:group-[.errored]:border-error-80 [&:has(input:focus)]:!border-primary-30 [&:has(input:focus)]:dark:!border-primary-80", ru = "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none disabled:cursor-not-allowed", nu = "flex flex-col gap-y-2 text-label-lg text-neutral-40 dark:text-neutral-60";
var Qi = /* @__PURE__ */ ((e) => (e.Label = "label", e.Div = "div", e))(Qi || {});
function Sa({
  label: e,
  caption: t,
  disabled: r,
  errorMessage: n,
  amountCounter: i,
  required: s,
  labelHtmlTag: u = "label",
  children: c
}) {
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: A("group flex w-full flex-col gap-y-2", {
        "cursor-not-allowed opacity-40": r,
        errored: n,
        enabled: !r,
        required: s
      }),
      children: [
        e ? /* @__PURE__ */ o.jsxs(au, { labelHtmlTag: u, children: [
          e,
          c
        ] }) : c,
        (n || t || i) && /* @__PURE__ */ o.jsxs(
          "div",
          {
            className: A(
              "flex flex-row items-center",
              t || n ? "justify-between" : "justify-end"
            ),
            children: [
              (n || t) && /* @__PURE__ */ o.jsx(Dn, { hasErrorStyles: !0, children: n || t }),
              i && /* @__PURE__ */ o.jsx(Dn, { children: i })
            ]
          }
        )
      ]
    }
  );
}
function au({
  labelHtmlTag: e,
  children: t
}) {
  return ts(e, { className: nu }, t);
}
var Tt = /* @__PURE__ */ ((e) => (e.Text = "text", e.Password = "password", e.Number = "number", e.NumericFormat = "numericFormat", e))(Tt || {}), iu = /* @__PURE__ */ ((e) => (e.None = "none", e.Vertical = "vertical", e))(iu || {});
function eo(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
var Qr;
(function(e) {
  e.event = "event", e.props = "prop";
})(Qr || (Qr = {}));
function Jt() {
}
function ou(e) {
  var t, r = void 0;
  return function() {
    for (var n = [], i = arguments.length; i--; ) n[i] = arguments[i];
    return t && n.length === t.length && n.every(function(s, u) {
      return s === t[u];
    }) || (t = n, r = e.apply(void 0, n)), r;
  };
}
function en(e) {
  return !!(e || "").match(/\d/);
}
function Pr(e) {
  return e == null;
}
function su(e) {
  return typeof e == "number" && isNaN(e);
}
function to(e) {
  return Pr(e) || su(e) || typeof e == "number" && !isFinite(e);
}
function ro(e) {
  return e.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function lu(e) {
  switch (e) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function uu(e, t, r) {
  var n = lu(r), i = e.search(/[1-9]/);
  return i = i === -1 ? e.length : i, e.substring(0, i) + e.substring(i, e.length).replace(n, "$1" + t);
}
function cu(e) {
  var t = at(e);
  t.current = e;
  var r = at(function() {
    for (var n = [], i = arguments.length; i--; ) n[i] = arguments[i];
    return t.current.apply(t, n);
  });
  return r.current;
}
function Ca(e, t) {
  t === void 0 && (t = !0);
  var r = e[0] === "-", n = r && t;
  e = e.replace("-", "");
  var i = e.split("."), s = i[0], u = i[1] || "";
  return {
    beforeDecimal: s,
    afterDecimal: u,
    hasNegation: r,
    addNegation: n
  };
}
function fu(e) {
  if (!e)
    return e;
  var t = e[0] === "-";
  t && (e = e.substring(1, e.length));
  var r = e.split("."), n = r[0].replace(/^0+/, "") || "0", i = r[1] || "";
  return (t ? "-" : "") + n + (i ? "." + i : "");
}
function no(e, t, r) {
  for (var n = "", i = r ? "0" : "", s = 0; s <= t - 1; s++)
    n += e[s] || i;
  return n;
}
function di(e, t) {
  return Array(t + 1).join(e);
}
function ao(e) {
  var t = e + "", r = t[0] === "-" ? "-" : "";
  r && (t = t.substring(1));
  var n = t.split(/[eE]/g), i = n[0], s = n[1];
  if (s = Number(s), !s)
    return r + i;
  i = i.replace(".", "");
  var u = 1 + s, c = i.length;
  return u < 0 ? i = "0." + di("0", Math.abs(u)) + i : u >= c ? i = i + di("0", u - c) : i = (i.substring(0, u) || "0") + "." + i.substring(u), r + i;
}
function vi(e, t, r) {
  if (["", "-"].indexOf(e) !== -1)
    return e;
  var n = (e.indexOf(".") !== -1 || r) && t, i = Ca(e), s = i.beforeDecimal, u = i.afterDecimal, c = i.hasNegation, h = parseFloat("0." + (u || "0")), m = u.length <= t ? "0." + u : h.toFixed(t), y = m.split("."), x = s;
  s && Number(y[0]) && (x = s.split("").reverse().reduce(function(k, N, P) {
    return k.length > P ? (Number(k[0]) + Number(N)).toString() + k.substring(1, k.length) : N + k;
  }, y[0]));
  var j = no(y[1] || "", t, r), R = c ? "-" : "", T = n ? "." : "";
  return "" + R + x + T + j;
}
function dr(e, t) {
  if (e.value = e.value, e !== null) {
    if (e.createTextRange) {
      var r = e.createTextRange();
      return r.move("character", t), r.select(), !0;
    }
    return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(t, t), !0) : (e.focus(), !1);
  }
}
var io = ou(function(e, t) {
  for (var r = 0, n = 0, i = e.length, s = t.length; e[r] === t[r] && r < i; )
    r++;
  for (; e[i - 1 - n] === t[s - 1 - n] && s - n > r && i - n > r; )
    n++;
  return {
    from: { start: r, end: i - n },
    to: { start: r, end: s - n }
  };
}), du = function(e, t) {
  var r = Math.min(e.selectionStart, t);
  return {
    from: { start: r, end: e.selectionEnd },
    to: { start: r, end: t }
  };
};
function vu(e, t, r) {
  return Math.min(Math.max(e, t), r);
}
function ia(e) {
  return Math.max(e.selectionStart, e.selectionEnd);
}
function mu() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function hu(e) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: e.length
    },
    lastValue: ""
  };
}
function pu(e) {
  var t = e.currentValue, r = e.formattedValue, n = e.currentValueIndex, i = e.formattedValueIndex;
  return t[n] === r[i];
}
function gu(e, t, r, n, i, s, u) {
  u === void 0 && (u = pu);
  var c = i.findIndex(function(z) {
    return z;
  }), h = e.slice(0, c);
  !t && !r.startsWith(h) && (t = h, r = h + r, n = n + h.length);
  for (var m = r.length, y = e.length, x = {}, j = new Array(m), R = 0; R < m; R++) {
    j[R] = -1;
    for (var T = 0, k = y; T < k; T++) {
      var N = u({
        currentValue: r,
        lastValue: t,
        formattedValue: e,
        currentValueIndex: R,
        formattedValueIndex: T
      });
      if (N && x[T] !== !0) {
        j[R] = T, x[T] = !0;
        break;
      }
    }
  }
  for (var P = n; P < m && (j[P] === -1 || !s(r[P])); )
    P++;
  var V = P === m || j[P] === -1 ? y : j[P];
  for (P = n - 1; P > 0 && j[P] === -1; )
    P--;
  var D = P === -1 || j[P] === -1 ? 0 : j[P] + 1;
  return D > V ? V : n - D < V - n ? D : V;
}
function mi(e, t, r, n) {
  var i = e.length;
  if (t = vu(t, 0, i), n === "left") {
    for (; t >= 0 && !r[t]; )
      t--;
    t === -1 && (t = r.indexOf(!0));
  } else {
    for (; t <= i && !r[t]; )
      t++;
    t > i && (t = r.lastIndexOf(!0));
  }
  return t === -1 && (t = i), t;
}
function xu(e) {
  for (var t = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), r = 0, n = t.length; r < n; r++)
    t[r] = !!(en(e[r]) || en(e[r - 1]));
  return t;
}
function oo(e, t, r, n, i, s) {
  s === void 0 && (s = Jt);
  var u = cu(function(T, k) {
    var N, P;
    return to(T) ? (P = "", N = "") : typeof T == "number" || k ? (P = typeof T == "number" ? ao(T) : T, N = n(P)) : (P = i(T, void 0), N = n(P)), { formattedValue: N, numAsString: P };
  }), c = vt(function() {
    return u(Pr(e) ? t : e, r);
  }), h = c[0], m = c[1], y = function(T, k) {
    T.formattedValue !== h.formattedValue && m({
      formattedValue: T.formattedValue,
      numAsString: T.value
    }), s(T, k);
  }, x = e, j = r;
  Pr(e) && (x = h.numAsString, j = !0);
  var R = u(x, j);
  return rs(function() {
    m(R);
  }, [R.formattedValue]), [h, y];
}
function bu(e) {
  return e.replace(/[^0-9]/g, "");
}
function yu(e) {
  return e;
}
function _u(e) {
  var t = e.type;
  t === void 0 && (t = "text");
  var r = e.displayType;
  r === void 0 && (r = "input");
  var n = e.customInput, i = e.renderText, s = e.getInputRef, u = e.format;
  u === void 0 && (u = yu);
  var c = e.removeFormatting;
  c === void 0 && (c = bu);
  var h = e.defaultValue, m = e.valueIsNumericString, y = e.onValueChange, x = e.isAllowed, j = e.onChange;
  j === void 0 && (j = Jt);
  var R = e.onKeyDown;
  R === void 0 && (R = Jt);
  var T = e.onMouseUp;
  T === void 0 && (T = Jt);
  var k = e.onFocus;
  k === void 0 && (k = Jt);
  var N = e.onBlur;
  N === void 0 && (N = Jt);
  var P = e.value, V = e.getCaretBoundary;
  V === void 0 && (V = xu);
  var D = e.isValidInputCharacter;
  D === void 0 && (D = en);
  var z = e.isCharacterSame, H = eo(e, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]), Y = oo(P, h, !!m, u, c, y), W = Y[0], G = W.formattedValue, ce = W.numAsString, Ne = Y[1], Ve = at(), ze = at({ formattedValue: G, numAsString: ce }), Pe = function(U, K) {
    ze.current = { formattedValue: U.formattedValue, numAsString: U.value }, Ne(U, K);
  }, Re = vt(!1), Ee = Re[0], Q = Re[1], B = at(null), re = at({
    setCaretTimeout: null,
    focusTimeout: null
  });
  wt(function() {
    return Q(!0), function() {
      clearTimeout(re.current.setCaretTimeout), clearTimeout(re.current.focusTimeout);
    };
  }, []);
  var ye = u, je = function(U, K) {
    var ne = parseFloat(K);
    return {
      formattedValue: U,
      value: K,
      floatValue: isNaN(ne) ? void 0 : ne
    };
  }, _e = function(U, K, ne) {
    U.selectionStart === 0 && U.selectionEnd === U.value.length || (dr(U, K), re.current.setCaretTimeout = setTimeout(function() {
      U.value === ne && U.selectionStart !== K && dr(U, K);
    }, 0));
  }, g = function(U, K, ne) {
    return mi(U, K, V(U), ne);
  }, O = function(U, K, ne) {
    var se = V(K), Oe = gu(K, G, U, ne, se, D, z);
    return Oe = mi(K, Oe, se), Oe;
  }, ae = function(U) {
    var K = U.formattedValue;
    K === void 0 && (K = "");
    var ne = U.input, se = U.source, Oe = U.event, xe = U.numAsString, le;
    if (ne) {
      var Ke = U.inputValue || ne.value, He = ia(ne);
      ne.value = K, le = O(Ke, K, He), le !== void 0 && _e(ne, le, K);
    }
    K !== G && Pe(je(K, xe), { event: Oe, source: se });
  };
  wt(function() {
    var U = ze.current, K = U.formattedValue, ne = U.numAsString;
    (G !== K || ce !== ne) && Pe(je(G, ce), {
      event: void 0,
      source: Qr.props
    });
  }, [G, ce]);
  var fe = B.current ? ia(B.current) : void 0, oe = typeof window < "u" ? ma : wt;
  oe(function() {
    var U = B.current;
    if (G !== ze.current.formattedValue && U) {
      var K = O(ze.current.formattedValue, G, fe);
      U.value = G, _e(U, K, G);
    }
  }, [G]);
  var he = function(U, K, ne) {
    var se = K.target, Oe = Ve.current ? du(Ve.current, se.selectionEnd) : io(G, U), xe = Object.assign(Object.assign({}, Oe), { lastValue: G }), le = c(U, xe), Ke = ye(le);
    if (le = c(Ke, void 0), x && !x(je(Ke, le))) {
      var He = K.target, Xe = ia(He), it = O(U, G, Xe);
      return He.value = G, _e(He, it, G), !1;
    }
    return ae({
      formattedValue: Ke,
      numAsString: le,
      inputValue: U,
      event: K,
      source: ne,
      input: K.target
    }), !0;
  }, de = function(U, K) {
    K === void 0 && (K = 0);
    var ne = U.selectionStart, se = U.selectionEnd;
    Ve.current = { selectionStart: ne, selectionEnd: se + K };
  }, ge = function(U) {
    var K = U.target, ne = K.value, se = he(ne, U, Qr.event);
    se && j(U), Ve.current = void 0;
  }, me = function(U) {
    var K = U.target, ne = U.key, se = K.selectionStart, Oe = K.selectionEnd, xe = K.value;
    xe === void 0 && (xe = "");
    var le;
    ne === "ArrowLeft" || ne === "Backspace" ? le = Math.max(se - 1, 0) : ne === "ArrowRight" ? le = Math.min(se + 1, xe.length) : ne === "Delete" && (le = se);
    var Ke = 0;
    ne === "Delete" && se === Oe && (Ke = 1);
    var He = ne === "ArrowLeft" || ne === "ArrowRight";
    if (le === void 0 || se !== Oe && !He) {
      R(U), de(K, Ke);
      return;
    }
    var Xe = le;
    if (He) {
      var it = ne === "ArrowLeft" ? "left" : "right";
      Xe = g(xe, le, it), Xe !== le && U.preventDefault();
    } else ne === "Delete" && !D(xe[le]) ? Xe = g(xe, le, "right") : ne === "Backspace" && !D(xe[le]) && (Xe = g(xe, le, "left"));
    Xe !== le && _e(K, Xe, xe), R(U), de(K, Ke);
  }, Ie = function(U) {
    var K = U.target, ne = function() {
      var se = K.selectionStart, Oe = K.selectionEnd, xe = K.value;
      if (xe === void 0 && (xe = ""), se === Oe) {
        var le = g(xe, se);
        le !== se && _e(K, le, xe);
      }
    };
    ne(), requestAnimationFrame(function() {
      ne();
    }), T(U), de(K);
  }, mt = function(U) {
    U.persist && U.persist();
    var K = U.target, ne = U.currentTarget;
    B.current = K, re.current.focusTimeout = setTimeout(function() {
      var se = K.selectionStart, Oe = K.selectionEnd, xe = K.value;
      xe === void 0 && (xe = "");
      var le = g(xe, se);
      le !== se && !(se === 0 && Oe === xe.length) && _e(K, le, xe), k(Object.assign(Object.assign({}, U), { currentTarget: ne }));
    }, 0);
  }, st = function(U) {
    B.current = null, clearTimeout(re.current.focusTimeout), clearTimeout(re.current.setCaretTimeout), N(U);
  }, It = Ee && mu() ? "numeric" : void 0, lt = Object.assign({ inputMode: It }, H, {
    type: t,
    value: G,
    onChange: ge,
    onKeyDown: me,
    onMouseUp: Ie,
    onFocus: mt,
    onBlur: st
  });
  if (r === "text")
    return i ? qt.createElement(qt.Fragment, null, i(G, H) || null) : qt.createElement("span", Object.assign({}, H, { ref: s }), G);
  if (n) {
    var Qe = n;
    return qt.createElement(Qe, Object.assign({}, lt, { ref: s }));
  }
  return qt.createElement("input", Object.assign({}, lt, { ref: s }));
}
function hi(e, t) {
  var r = t.decimalScale, n = t.fixedDecimalScale, i = t.prefix;
  i === void 0 && (i = "");
  var s = t.suffix;
  s === void 0 && (s = "");
  var u = t.allowNegative, c = t.thousandsGroupStyle;
  if (c === void 0 && (c = "thousand"), e === "" || e === "-")
    return e;
  var h = Bn(t), m = h.thousandSeparator, y = h.decimalSeparator, x = r !== 0 && e.indexOf(".") !== -1 || r && n, j = Ca(e, u), R = j.beforeDecimal, T = j.afterDecimal, k = j.addNegation;
  return r !== void 0 && (T = no(T, r, !!n)), m && (R = uu(R, m, c)), i && (R = i + R), s && (T = T + s), k && (R = "-" + R), e = R + (x && y || "") + T, e;
}
function Bn(e) {
  var t = e.decimalSeparator;
  t === void 0 && (t = ".");
  var r = e.thousandSeparator, n = e.allowedDecimalSeparators;
  return r === !0 && (r = ","), n || (n = [t, "."]), {
    decimalSeparator: t,
    thousandSeparator: r,
    allowedDecimalSeparators: n
  };
}
function wu(e, t) {
  e === void 0 && (e = "");
  var r = new RegExp("(-)"), n = new RegExp("(-)(.)*(-)"), i = r.test(e), s = n.test(e);
  return e = e.replace(/-/g, ""), i && !s && t && (e = "-" + e), e;
}
function Eu(e, t) {
  return new RegExp("(^-)|[0-9]|" + ro(e), "g");
}
function Su(e, t, r) {
  return e === "" ? !0 : !(t != null && t.match(/\d/)) && !(r != null && r.match(/\d/)) && typeof e == "string" && !isNaN(Number(e));
}
function Cu(e, t, r) {
  var n;
  t === void 0 && (t = hu(e));
  var i = r.allowNegative, s = r.prefix;
  s === void 0 && (s = "");
  var u = r.suffix;
  u === void 0 && (u = "");
  var c = r.decimalScale, h = t.from, m = t.to, y = m.start, x = m.end, j = Bn(r), R = j.allowedDecimalSeparators, T = j.decimalSeparator, k = e[x] === T;
  if (en(e) && (e === s || e === u) && t.lastValue === "")
    return e;
  if (x - y === 1 && R.indexOf(e[y]) !== -1) {
    var N = c === 0 ? "" : T;
    e = e.substring(0, y) + N + e.substring(y + 1, e.length);
  }
  var P = function(B, re, ye) {
    var je = !1, _e = !1;
    s.startsWith("-") ? je = !1 : B.startsWith("--") ? (je = !1, _e = !0) : u.startsWith("-") && B.length === u.length ? je = !1 : B[0] === "-" && (je = !0);
    var g = je ? 1 : 0;
    return _e && (g = 2), g && (B = B.substring(g), re -= g, ye -= g), { value: B, start: re, end: ye, hasNegation: je };
  }, V = P(e, y, x), D = V.hasNegation;
  n = V, e = n.value, y = n.start, x = n.end;
  var z = P(t.lastValue, h.start, h.end), H = z.start, Y = z.end, W = z.value, G = e.substring(y, x);
  e.length && W.length && (H > W.length - u.length || Y < s.length) && !(G && u.startsWith(G)) && (e = W);
  var ce = 0;
  e.startsWith(s) ? ce += s.length : y < s.length && (ce = y), e = e.substring(ce), x -= ce;
  var Ne = e.length, Ve = e.length - u.length;
  e.endsWith(u) ? Ne = Ve : (x > Ve || x > e.length - u.length) && (Ne = x), e = e.substring(0, Ne), e = wu(D ? "-" + e : e, i), e = (e.match(Eu(T)) || []).join("");
  var ze = e.indexOf(T);
  e = e.replace(new RegExp(ro(T), "g"), function(B, re) {
    return re === ze ? "." : "";
  });
  var Pe = Ca(e, i), Re = Pe.beforeDecimal, Ee = Pe.afterDecimal, Q = Pe.addNegation;
  return m.end - m.start < h.end - h.start && Re === "" && k && !parseFloat(Ee) && (e = Q ? "-" : ""), e;
}
function ju(e, t) {
  var r = t.prefix;
  r === void 0 && (r = "");
  var n = t.suffix;
  n === void 0 && (n = "");
  var i = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), s = e[0] === "-";
  i.fill(!1, 0, r.length + (s ? 1 : 0));
  var u = e.length;
  return i.fill(!1, u - n.length + 1, u + 1), i;
}
function Ru(e) {
  var t = Bn(e), r = t.thousandSeparator, n = t.decimalSeparator, i = e.prefix;
  i === void 0 && (i = "");
  var s = e.allowNegative;
  if (s === void 0 && (s = !0), r === n)
    throw new Error(`
        Decimal separator can't be same as thousand separator.
        thousandSeparator: ` + r + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
        decimalSeparator: ` + n + ` (default value for decimalSeparator is .)
     `);
  return i.startsWith("-") && s && (console.error(`
      Prefix can't start with '-' when allowNegative is true.
      prefix: ` + i + `
      allowNegative: ` + s + `
    `), s = !1), Object.assign(Object.assign({}, e), { allowNegative: s });
}
function ku(e) {
  e = Ru(e), e.decimalSeparator, e.allowedDecimalSeparators, e.thousandsGroupStyle;
  var t = e.suffix, r = e.allowNegative, n = e.allowLeadingZeros, i = e.onKeyDown;
  i === void 0 && (i = Jt);
  var s = e.onBlur;
  s === void 0 && (s = Jt);
  var u = e.thousandSeparator, c = e.decimalScale, h = e.fixedDecimalScale, m = e.prefix;
  m === void 0 && (m = "");
  var y = e.defaultValue, x = e.value, j = e.valueIsNumericString, R = e.onValueChange, T = eo(e, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]), k = Bn(e), N = k.decimalSeparator, P = k.allowedDecimalSeparators, V = function(Q) {
    return hi(Q, e);
  }, D = function(Q, B) {
    return Cu(Q, B, e);
  }, z = Pr(x) ? y : x, H = j ?? Su(z, m, t);
  Pr(x) ? Pr(y) || (H = H || typeof y == "number") : H = H || typeof x == "number";
  var Y = function(Q) {
    return to(Q) ? Q : (typeof Q == "number" && (Q = ao(Q)), H && typeof c == "number" ? vi(Q, c, !!h) : Q);
  }, W = oo(Y(x), Y(y), !!H, V, D, R), G = W[0], ce = G.numAsString, Ne = G.formattedValue, Ve = W[1], ze = function(Q) {
    var B = Q.target, re = Q.key, ye = B.selectionStart, je = B.selectionEnd, _e = B.value;
    if (_e === void 0 && (_e = ""), (re === "Backspace" || re === "Delete") && je < m.length) {
      Q.preventDefault();
      return;
    }
    if (ye !== je) {
      i(Q);
      return;
    }
    re === "Backspace" && _e[0] === "-" && ye === m.length + 1 && r && dr(B, 1), c && h && (re === "Backspace" && _e[ye - 1] === N ? (dr(B, ye - 1), Q.preventDefault()) : re === "Delete" && _e[ye] === N && Q.preventDefault()), P != null && P.includes(re) && _e[ye] === N && dr(B, ye + 1);
    var g = u === !0 ? "," : u;
    re === "Backspace" && _e[ye - 1] === g && dr(B, ye - 1), re === "Delete" && _e[ye] === g && dr(B, ye + 1), i(Q);
  }, Pe = function(Q) {
    var B = ce;
    if (B.match(/\d/g) || (B = ""), n || (B = fu(B)), h && c && (B = vi(B, c, h)), B !== ce) {
      var re = hi(B, e);
      Ve({
        formattedValue: re,
        value: B,
        floatValue: parseFloat(B)
      }, {
        event: Q,
        source: Qr.event
      });
    }
    s(Q);
  }, Re = function(Q) {
    return Q === N ? !0 : en(Q);
  }, Ee = function(Q) {
    var B = Q.currentValue, re = Q.lastValue, ye = Q.formattedValue, je = Q.currentValueIndex, _e = Q.formattedValueIndex, g = B[je], O = ye[_e], ae = io(re, B), fe = ae.to, oe = function(he) {
      return D(he).indexOf(".") + m.length;
    };
    return x === 0 && h && c && B[fe.start] === N && oe(B) < je && oe(ye) > _e ? !1 : je >= fe.start && je < fe.end && P && P.includes(g) && O === N ? !0 : g === O;
  };
  return Object.assign(Object.assign({}, T), {
    value: Ne,
    valueIsNumericString: !1,
    isValidInputCharacter: Re,
    isCharacterSame: Ee,
    onValueChange: Ve,
    format: V,
    removeFormatting: D,
    getCaretBoundary: function(Q) {
      return ju(Q, e);
    },
    onKeyDown: ze,
    onBlur: Pe
  });
}
function Ou(e) {
  var t = ku(e);
  return qt.createElement(_u, Object.assign({}, t));
}
const md = tn(function({
  label: t,
  caption: r,
  disabled: n,
  errorMessage: i,
  leadingIcon: s,
  supportingText: u,
  amountCounter: c,
  trailingElement: h,
  isContentVisible: m,
  value: y,
  defaultValue: x,
  onClearInput: j,
  isVisibilityToggleEnabled: R,
  type: T,
  ...k
}, N) {
  R ?? (R = T === Tt.Password);
  const P = at(null), [V, D] = vt(
    m ?? T !== Tt.Password
  );
  wt(() => {
    D(m ?? T !== Tt.Password);
  }, [T, m]);
  function z() {
    D((Y) => !Y);
  }
  function H() {
    var Y;
    P.current && ((Y = P.current.querySelector("input")) == null || Y.focus());
  }
  return /* @__PURE__ */ o.jsx(
    Sa,
    {
      label: t,
      caption: r,
      disabled: n,
      errorMessage: i,
      amountCounter: c,
      required: k.required,
      children: /* @__PURE__ */ o.jsxs(
        "div",
        {
          className: A("relative flex flex-row items-center gap-x-3", Ji),
          onClick: H,
          ref: P,
          children: [
            s && /* @__PURE__ */ o.jsx("span", { className: "text-neutral-10 dark:text-neutral-92", children: s }),
            /* @__PURE__ */ o.jsx(
              Tu,
              {
                ...k,
                inputRef: N,
                value: y,
                type: T === Tt.Password && V ? Tt.Text : T,
                disabled: n,
                className: A(
                  Xi,
                  Zi,
                  qi,
                  ru
                )
              }
            ),
            u && /* @__PURE__ */ o.jsx(Dn, { children: u }),
            /* @__PURE__ */ o.jsx(
              Pu,
              {
                value: y,
                type: T,
                onClearInput: j,
                isContentVisible: V,
                trailingElement: h,
                isVisibilityToggleEnabled: R,
                onToggleButtonClick: z
              }
            )
          ]
        }
      )
    }
  );
});
function Tu({
  type: e,
  inputRef: t,
  ...r
}) {
  function n(i) {
    if (e === Tt.Number) {
      const s = i.currentTarget;
      s.blur(), i.stopPropagation(), setTimeout(() => {
        s.focus({ preventScroll: !0 });
      }, 0);
    }
  }
  return e === Tt.NumericFormat ? /* @__PURE__ */ o.jsx(Nu, { inputRef: t, ...r, type: e }) : /* @__PURE__ */ o.jsx(
    "input",
    {
      ref: t,
      ...r,
      type: e,
      onWheel: (i) => {
        var s;
        n(i), (s = r.onWheel) == null || s.call(r, i);
      }
    }
  );
}
function Nu({
  inputRef: e,
  className: t,
  type: r,
  ...n
}) {
  return /* @__PURE__ */ o.jsx(
    Ou,
    {
      className: t,
      valueIsNumericString: !0,
      getInputRef: e,
      ...n
    }
  );
}
function Pu({
  value: e,
  type: t,
  onClearInput: r,
  isContentVisible: n,
  trailingElement: i,
  onToggleButtonClick: s,
  isVisibilityToggleEnabled: u
}) {
  const c = !!(t === Tt.Text && e && r), h = !!(t === Tt.Password && u), m = !!(i && !c && !h);
  if (c)
    return /* @__PURE__ */ o.jsx(
      nt,
      {
        className: "text-neutral-10 dark:text-neutral-92 [&_svg]:h-5 [&_svg]:w-5",
        onClick: r,
        tabIndex: -1,
        children: /* @__PURE__ */ o.jsx(rn, {})
      }
    );
  if (h)
    return /* @__PURE__ */ o.jsx(
      nt,
      {
        onClick: s,
        className: "text-neutral-10 dark:text-neutral-92 [&_svg]:h-5 [&_svg]:w-5",
        tabIndex: -1,
        children: n ? /* @__PURE__ */ o.jsx(zi, {}) : /* @__PURE__ */ o.jsx(Yi, {})
      }
    );
  if (m)
    return /* @__PURE__ */ o.jsx(ns, { children: i });
}
const hd = tn(function({
  label: t,
  caption: r,
  disabled: n,
  errorMessage: i,
  value: s,
  amountCounter: u,
  isVisibilityToggleEnabled: c,
  isResizeEnabled: h,
  required: m,
  isContentVisible: y,
  ...x
}, j) {
  const [R, T] = vt(
    y ?? !0
  );
  wt(() => {
    T(y ?? !0);
  }, [y]);
  function k() {
    T((N) => !N);
  }
  return /* @__PURE__ */ o.jsx(
    Sa,
    {
      label: t,
      caption: r,
      disabled: n || !R,
      errorMessage: i,
      amountCounter: u,
      required: m,
      children: /* @__PURE__ */ o.jsxs("div", { className: "relative", children: [
        /* @__PURE__ */ o.jsx(
          "textarea",
          {
            disabled: n || !R,
            required: m,
            ref: j,
            className: A(
              "peer block min-h-[50px]",
              Ji,
              Xi,
              Zi,
              qi,
              R && h ? "resize-y" : "resize-none",
              !R && "not-visible select-none text-transparent dark:text-transparent"
            ),
            value: R ? s : "",
            ...x
          }
        ),
        !R && /* @__PURE__ */ o.jsx("div", { className: "absolute left-0 top-0 flex h-full w-full flex-col items-stretch gap-y-2 px-md py-sm peer-[.not-visible]:select-none", children: /* @__PURE__ */ o.jsx(Au, { rows: 3, halfWidthRow: 3 }) }),
        c && /* @__PURE__ */ o.jsx("span", { className: "absolute bottom-4 right-4 flex", children: /* @__PURE__ */ o.jsx(
          nt,
          {
            onClick: k,
            className: "text-neutral-10 dark:text-neutral-92 [&_svg]:h-5 [&_svg]:w-5",
            tabIndex: -1,
            children: R ? /* @__PURE__ */ o.jsx(zi, {}) : /* @__PURE__ */ o.jsx(Yi, {})
          }
        ) })
      ] })
    }
  );
});
function Au({ rows: e, halfWidthRow: t }) {
  return /* @__PURE__ */ o.jsx(o.Fragment, { children: Array.from({ length: e }).map((r, n) => {
    const s = t === n + 1 ? "w-1/2" : "w-full";
    return /* @__PURE__ */ o.jsx(
      "div",
      {
        className: `h-2.5 rounded bg-neutral-92/60 dark:bg-neutral-10/60 ${s}`
      },
      n
    );
  }) });
}
var ja = /* @__PURE__ */ ((e) => (e.Horizontal = "horizontal", e.Vertical = "vertical", e))(ja || {});
const so = "text-neutral-10 dark:text-neutral-92", lo = "text-neutral-40 dark:text-neutral-60", Du = "py-xxs px-sm", Iu = "p-sm", uo = "bg-shader-primary-light-12 dark:bg-shader-primary-dark-12", Lu = "-top-3 right-3", Mu = "-top-1 right-3", co = "text-neutral-10 dark:text-neutral-92", fo = "text-neutral-60 dark:text-neutral-40";
function Fu({
  icon: e,
  text: t,
  isSelected: r,
  hasBadge: n,
  onClick: i,
  isDisabled: s = !1
}) {
  const u = r ? so : lo, c = t ? Du : Iu, h = r && uo, m = t ? Lu : Mu, y = r ? co : fo, x = s ? "cursor-not-allowed opacity-60" : "state-layer", j = (R) => {
    if (s) {
      R.preventDefault();
      return;
    }
    i == null || i(R);
  };
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      onClick: j,
      className: A(
        "inline-flex cursor-pointer flex-col items-center justify-center space-y-1"
      ),
      children: [
        /* @__PURE__ */ o.jsxs(
          "div",
          {
            className: A(
              "relative inline-flex rounded-full",
              c,
              h,
              x
            ),
            children: [
              /* @__PURE__ */ o.jsx("div", { className: A("inline-flex [&_svg]:h-6 [&_svg]:w-6", u), children: e }),
              n && /* @__PURE__ */ o.jsx("div", { className: A("absolute", m), children: /* @__PURE__ */ o.jsx(An, { type: Ge.PrimarySolid }) })
            ]
          }
        ),
        t && /* @__PURE__ */ o.jsx("span", { className: A("text-center text-label-md", y), children: t })
      ]
    }
  );
}
function Bu({
  icon: e,
  text: t,
  isSelected: r,
  hasBadge: n,
  onClick: i,
  isDisabled: s = !1
}) {
  const u = r ? so : lo, c = r && uo, h = r ? co : fo, m = s ? "cursor-not-allowed opacity-60" : "state-layer cursor-pointer ", y = (x) => {
    if (s) {
      x.preventDefault();
      return;
    }
    i == null || i(x);
  };
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      onClick: y,
      className: A(
        "relative inline-flex w-full flex-row items-center justify-between rounded-full p-sm",
        c,
        m
      ),
      children: [
        /* @__PURE__ */ o.jsxs("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ o.jsx("div", { className: A("inline-flex [&_svg]:h-6 [&_svg]:w-6", u), children: e }),
          t && /* @__PURE__ */ o.jsx("span", { className: A("text-center text-label-lg", h), children: t })
        ] }),
        n && /* @__PURE__ */ o.jsx(An, { type: Ge.PrimarySolid })
      ]
    }
  );
}
function vo(e) {
  const { type: t, text: r } = e;
  return t === ja.Vertical && r ? /* @__PURE__ */ o.jsx(Bu, { ...e }) : /* @__PURE__ */ o.jsx(Fu, { ...e });
}
function pd({
  title: e,
  subtitle: t,
  badgeType: r,
  badgeText: n,
  isLocked: i,
  avatarContent: s,
  onOptionsClick: u,
  onLockAccountClick: c,
  onUnlockAccountClick: h,
  onCopy: m,
  copyText: y,
  onOpen: x,
  isCopyable: j,
  isExternal: R,
  isSelected: T,
  isActive: k,
  showSelected: N,
  badgeTooltipText: P,
  badgeTooltipPosition: V = fr.Bottom
}) {
  const D = s;
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: A(
        "state-layer group relative flex w-full items-center justify-between space-x-3 rounded-xl px-sm py-xs hover:cursor-pointer",
        k && "state-active",
        {
          "opacity-60": i && N
        }
      ),
      children: [
        /* @__PURE__ */ o.jsxs("div", { className: "flex items-center space-x-3", children: [
          /* @__PURE__ */ o.jsx(D, { isLocked: i }),
          /* @__PURE__ */ o.jsxs("div", { className: "flex flex-col items-start py-xs", children: [
            /* @__PURE__ */ o.jsxs("div", { className: "flex items-center space-x-2", children: [
              /* @__PURE__ */ o.jsx("span", { className: "font-inter text-title-md text-neutral-10 dark:text-neutral-92", children: e }),
              n && r ? P ? /* @__PURE__ */ o.jsx(Mr, { text: P, position: V, children: /* @__PURE__ */ o.jsx(An, { type: r, label: n }) }) : /* @__PURE__ */ o.jsx(An, { type: r, label: n }) : null
            ] }),
            /* @__PURE__ */ o.jsx(
              Gl,
              {
                text: t,
                onCopySuccess: m,
                copyText: y,
                onOpen: x,
                isCopyable: j,
                isExternal: R
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ o.jsxs("div", { className: "z-10 ml-auto flex items-center space-x-2 [&_button]:h-5 [&_button]:w-5 [&_svg]:h-5 [&_svg]:w-5", children: [
          /* @__PURE__ */ o.jsxs("div", { className: "flex items-center space-x-2 [&_button:not(.locked)]:hidden group-hover:[&_button:not(.locked)]:flex [&_svg]:text-neutral-40 [&_svg]:dark:text-neutral-60", children: [
            u && /* @__PURE__ */ o.jsx(nt, { onClick: u, children: /* @__PURE__ */ o.jsx(Gi, {}) }),
            c && h && (i ? /* @__PURE__ */ o.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ o.jsx(
              nt,
              {
                onClick: h,
                testId: "account-unlock",
                className: "locked",
                children: /* @__PURE__ */ o.jsx(ll, {})
              }
            ) }) : /* @__PURE__ */ o.jsx(nt, { onClick: c, testId: "account-lock", children: /* @__PURE__ */ o.jsx(ul, {}) }))
          ] }),
          N && /* @__PURE__ */ o.jsx(nt, { children: T ? /* @__PURE__ */ o.jsx(nl, { className: "h-5 w-5 text-primary-30 dark:text-primary-80" }) : /* @__PURE__ */ o.jsx(Hi, { className: "h-5 w-5 text-neutral-40 dark:text-neutral-60" }) })
        ] })
      ]
    }
  );
}
function Vu({ children: e }) {
  return /* @__PURE__ */ o.jsx("ul", { className: "list-none rounded-lg border border-neutral-80 bg-neutral-100 py-xs dark:border-neutral-20 dark:bg-neutral-6", children: e });
}
var Rn = /* @__PURE__ */ ((e) => (e.Top = "top", e.Bottom = "bottom", e))(Rn || {});
function Wu({
  children: e,
  hasLastBorderNoneClass: t,
  isContentCentered: r
}) {
  return /* @__PURE__ */ o.jsx(
    "td",
    {
      className: A(
        "h-14 border-b border-shader-neutral-light-8 px-md dark:border-shader-neutral-dark-8",
        { "last:border-none": t },
        { "flex items-center justify-center": r }
      ),
      children: e
    }
  );
}
function gd({
  children: e,
  supportingLabel: t
}) {
  return /* @__PURE__ */ o.jsxs("div", { className: "flex flex-row items-baseline gap-1", children: [
    /* @__PURE__ */ o.jsx("span", { children: e }),
    t && /* @__PURE__ */ o.jsx("span", { className: "text-body-sm text-neutral-60 dark:text-neutral-40", children: t })
  ] });
}
function xd() {
  return /* @__PURE__ */ o.jsx(Ml, {});
}
var kn = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e))(kn || {});
const bd = tn(
  ({
    disabled: e,
    label: t,
    leadingIcon: r,
    supportingText: n,
    errorMessage: i,
    caption: s,
    options: u,
    placeholder: c,
    onValueChange: h,
    onOptionClick: m,
    value: y,
    dropdownPosition: x = Rn.Bottom,
    size: j = kn.Default
  }, R) => {
    const [T, k] = vt(!1), N = z(y, u), P = N || c, V = j === kn.Small ? "px-sm" : "px-md", D = j === kn.Small ? "text-body-md" : "text-body-lg";
    wt(() => {
      e && T && W();
    }, [e, T]);
    function z(G, ce = []) {
      return ce.find(
        (Ne) => typeof Ne == "string" ? Ne === G : Ne.id === G
      ) ?? ce[0];
    }
    function H() {
      k((G) => !G);
    }
    function Y(G) {
      W();
      const ce = typeof G == "string" ? G : G.id;
      m == null || m(ce), G !== N && (h == null || h(ce));
    }
    function W() {
      k(!1);
    }
    return /* @__PURE__ */ o.jsx(
      Sa,
      {
        label: t,
        caption: s,
        disabled: e,
        errorMessage: i,
        labelHtmlTag: Qi.Div,
        children: /* @__PURE__ */ o.jsxs("div", { className: "relative flex w-full flex-col", children: [
          /* @__PURE__ */ o.jsxs(
            nt,
            {
              ref: R,
              onClick: H,
              disabled: e,
              className: A(
                "flex flex-row items-center gap-x-3 rounded-lg border border-neutral-80 py-sm hover:enabled:border-neutral-50 focus-visible:enabled:border-primary-30 active:enabled:border-primary-30 disabled:cursor-not-allowed  group-[.errored]:border-error-30 group-[.opened]:border-primary-30 dark:border-neutral-20 dark:hover:enabled:border-neutral-60 dark:group-[.errored]:border-error-80 dark:group-[.opened]:border-primary-80 [&:is(:focus,_:focus-visible,_:active)]:enabled:border-primary-30 dark:[&:is(:focus,_:focus-visible,_:active)]:enabled:border-primary-80 [&_svg]:h-5 [&_svg]:w-5",
                V
              ),
              children: [
                r && /* @__PURE__ */ o.jsx("span", { className: "text-neutral-10 dark:text-neutral-92", children: r }),
                /* @__PURE__ */ o.jsxs("div", { className: "flex w-full flex-row items-baseline gap-x-3", children: [
                  P && /* @__PURE__ */ o.jsx(
                    "div",
                    {
                      className: A(
                        "block w-full text-start text-neutral-10 dark:text-neutral-92",
                        D
                      ),
                      children: /* @__PURE__ */ o.jsx(pi, { option: P })
                    }
                  ),
                  n && /* @__PURE__ */ o.jsx("div", { className: "ml-auto", children: /* @__PURE__ */ o.jsx(Dn, { children: n }) })
                ] }),
                /* @__PURE__ */ o.jsx(
                  hl,
                  {
                    className: A(
                      "text-neutral-10 transition-transform dark:text-neutral-92",
                      {
                        " rotate-180": T
                      }
                    )
                  }
                )
              ]
            }
          ),
          T && /* @__PURE__ */ o.jsx(
            "div",
            {
              className: "fixed left-0 top-0 z-[49] h-screen w-screen bg-transparent",
              onClick: W
            }
          ),
          /* @__PURE__ */ o.jsx(
            "div",
            {
              className: A("absolute z-50 min-w-full", {
                hidden: !T,
                "top-full": !x || x === Rn.Bottom,
                "bottom-full": x === Rn.Top
              }),
              children: /* @__PURE__ */ o.jsx(Vu, { children: u.map((G) => {
                const ce = typeof G == "string";
                return /* @__PURE__ */ o.jsx(
                  Al,
                  {
                    onClick: () => Y(G),
                    hideBottomBorder: !0,
                    children: /* @__PURE__ */ o.jsx(pi, { option: G })
                  },
                  ce ? G : G.id
                );
              }) })
            }
          )
        ] })
      }
    );
  }
);
function pi({ option: e }) {
  return typeof e == "string" ? e : "renderLabel" in e ? e.renderLabel() : e.label;
}
var Or = /* @__PURE__ */ ((e) => (e.Asc = "asc", e.Desc = "desc", e))(Or || {});
function Uu({
  label: e,
  columnKey: t,
  hasSort: r,
  hasCheckbox: n,
  isChecked: i,
  isIndeterminate: s,
  isContentCentered: u,
  onSortClick: c,
  onCheckboxChange: h,
  sortOrder: m
}) {
  const y = () => {
    const T = m === Or.Asc ? Or.Desc : Or.Asc;
    c && c(t, T);
  }, x = "text-neutral-10 dark:text-neutral-92", j = "text-label-lg", R = r ? m === Or.Asc ? /* @__PURE__ */ o.jsx(oi, { className: "shrink-0" }) : m === Or.Desc ? /* @__PURE__ */ o.jsx(ml, { className: "shrink-0" }) : /* @__PURE__ */ o.jsx(oi, { className: "invisible shrink-0 group-hover:visible" }) : null;
  return /* @__PURE__ */ o.jsx(
    "th",
    {
      onClick: r ? y : void 0,
      className: A(
        "state-layer group relative h-14 border-b border-shader-neutral-light-8 px-md after:pointer-events-none dark:border-shader-neutral-dark-8",
        {
          "cursor-pointer": r
        }
      ),
      children: /* @__PURE__ */ o.jsxs(
        "div",
        {
          className: A(
            "flex flex-row items-center gap-1 [&_svg]:h-4 [&_svg]:w-4",
            x,
            j,
            {
              "justify-center": u
            }
          ),
          children: [
            n ? /* @__PURE__ */ o.jsx(
              Ki,
              {
                isChecked: i,
                isIndeterminate: s,
                onCheckedChange: h
              }
            ) : /* @__PURE__ */ o.jsx(
              "span",
              {
                className: A({
                  "text-left": !u
                }),
                children: e
              }
            ),
            R
          ]
        }
      )
    }
  );
}
var Ut = /* @__PURE__ */ ((e) => (e.Outlined = "outlined", e.Filled = "filled", e))(Ut || {});
const $u = {
  [Ut.Outlined]: "bg-transparent",
  [Ut.Filled]: "bg-neutral-92 dark:bg-neutral-12"
}, Gu = {
  [Ut.Outlined]: "border-l border-r border-t border-neutral-70 dark:border-neutral-40",
  [Ut.Filled]: "bg-neutral-92 dark:bg-neutral-12"
}, Hu = {
  [Ut.Outlined]: "rounded-b-3xl border-b border-l border-r border-neutral-70  dark:border-neutral-40",
  [Ut.Filled]: "rounded-b-3xl bg-neutral-92 dark:bg-neutral-12"
};
function yd({
  searchValue: e,
  suggestions: t,
  onSearchValueChange: r,
  onSuggestionClick: n,
  placeholder: i,
  isLoading: s = !1,
  type: u = Ut.Outlined,
  renderSuggestion: c
}) {
  const h = at(null), m = at(null), [y, x] = vt(!0), [j, R] = vt(null);
  function T(Y) {
    const W = Y.target.value;
    r(W);
  }
  wt(() => {
    const Y = (W) => {
      var G;
      W.key === "Escape" && (x(!1), (G = h.current) == null || G.blur());
    };
    return document.addEventListener("keydown", Y), () => {
      document.removeEventListener("keydown", Y);
    };
  }, []), wt(() => {
    const Y = (W) => {
      var ce;
      const G = h == null ? void 0 : h.current;
      !G || G.contains(W == null ? void 0 : W.target) || (ce = m.current) != null && ce.contains(W.target) || x(!1);
    };
    return document.addEventListener("click", Y, !0), document.addEventListener("touchstart", Y, !0), () => {
      document.removeEventListener("click", Y, !0), document.removeEventListener("touchstart", Y, !0);
    };
  }, [h]);
  const k = y && t && t.length > 0, N = k ? "rounded-t-3xl border-b border-b-transparent" : u === Ut.Outlined ? "rounded-3xl border-b" : "rounded-full", P = Gu[u], V = $u[u], D = Hu[u], z = (Y) => {
    var W;
    n == null || n(Y), r(""), x(!1), R(null), (W = h.current) == null || W.blur();
  }, H = (Y) => {
    t && (t == null ? void 0 : t.length) > 0 && (Y.key === "ArrowDown" ? (Y.preventDefault(), R(
      (W) => W === null || W >= t.length - 1 ? 0 : W + 1
    )) : Y.key === "ArrowUp" ? (Y.preventDefault(), R(
      (W) => W === null || W <= 0 ? t.length - 1 : W - 1
    )) : Y.key === "Enter" && (Y.preventDefault(), j !== null && t[j] ? z(t[j]) : t.length === 1 && z(t[0])));
  };
  return /* @__PURE__ */ o.jsxs("div", { className: "relative w-full", children: [
    /* @__PURE__ */ o.jsxs(
      "div",
      {
        className: A(
          "flex items-center overflow-hidden px-md py-sm text-neutral-10 dark:text-neutral-92 [&_svg]:h-6 [&_svg]:w-6",
          N,
          P
        ),
        children: [
          /* @__PURE__ */ o.jsx(
            "input",
            {
              ref: h,
              type: "text",
              value: e,
              onChange: T,
              onKeyDown: H,
              onFocus: () => x(!0),
              placeholder: i,
              className: A(
                "w-full flex-1 outline-none placeholder:text-neutral-40 placeholder:dark:text-neutral-60",
                V
              )
            }
          ),
          /* @__PURE__ */ o.jsx(vl, {})
        ]
      }
    ),
    k && c && /* @__PURE__ */ o.jsxs(
      "div",
      {
        ref: m,
        className: A(
          "absolute left-0 top-full flex w-full flex-col items-center overflow-hidden bg-neutral-100 dark:bg-neutral-10",
          D
        ),
        children: [
          /* @__PURE__ */ o.jsx(Ol, { width: "w-11/12" }),
          s ? /* @__PURE__ */ o.jsx("div", { className: "px-md py-sm", children: /* @__PURE__ */ o.jsx($i, { className: "animate-spin" }) }) : t.map((Y, W) => /* @__PURE__ */ o.jsx(
            "div",
            {
              onClick: () => z(Y),
              onMouseEnter: () => R(W),
              className: A(
                "w-full cursor-pointer px-md py-sm",
                j === W ? "bg-shader-primary-dark-16 dark:bg-shader-inverted-dark-16" : ""
              ),
              children: c(Y, W)
            },
            Y.id
          ))
        ]
      }
    )
  ] });
}
var Jr = /* @__PURE__ */ ((e) => (e.Default = "default", e.Outlined = "outlined", e.Filled = "filled", e))(Jr || {}), hr = /* @__PURE__ */ ((e) => (e.Placeholder = "placeholder", e.BgSolid = "bg-solid", e.BgWhite = "bg-white", e.BgTransparent = "bg-transparent", e))(hr || {}), Ir = /* @__PURE__ */ ((e) => (e.Rounded = "rounded", e.SquareRounded = "square-rounded", e))(Ir || {}), On = /* @__PURE__ */ ((e) => (e.Link = "link", e.SupportingText = "supporting-text", e.Button = "button", e))(On || {});
const Yu = "cursor-default opacity-40", gi = "h-10 w-10", xi = {
  [Ir.SquareRounded]: `${gi} rounded-md`,
  [Ir.Rounded]: `${gi} rounded-full`
}, zu = {
  [hr.Placeholder]: "",
  [hr.BgSolid]: "bg-neutral-96 dark:bg-neutral-10",
  [hr.BgWhite]: "bg-white dark:bg-neutral-6",
  [hr.BgTransparent]: ""
}, Ku = {
  [Jr.Default]: "border border-transparent",
  [Jr.Outlined]: "border border-shader-neutral-light-8 dark:border-shader-primary-dark-8 p-xs",
  [Jr.Filled]: "border border-transparent bg-neutral-96 dark:bg-neutral-10 p-xs"
};
function _d({
  isDisabled: e = !1,
  type: t = Jr.Default,
  isHoverable: r,
  onClick: n,
  children: i,
  testId: s
}) {
  function u() {
    e || n == null || n();
  }
  return /* @__PURE__ */ o.jsx(
    "div",
    {
      onClick: u,
      className: A(
        "relative inline-flex w-full items-center gap-3 rounded-xl px-sm py-xs",
        Ku[t],
        {
          "state-layer": r || !e && n,
          [Yu]: e,
          "cursor-pointer": n
        }
      ),
      "data-testid": s,
      children: i
    }
  );
}
function wd({
  type: e,
  onClick: t,
  subtitle: r,
  title: n,
  icon: i,
  iconAfterText: s,
  buttonType: u,
  buttonDisabled: c
}) {
  function h(m) {
    t && (m.stopPropagation(), t());
  }
  return e === On.Link ? /* @__PURE__ */ o.jsx(
    "div",
    {
      onClick: h,
      className: "shrink-0 text-neutral-10 dark:text-neutral-92 [&_svg]:h-5 [&_svg]:w-5",
      children: i || /* @__PURE__ */ o.jsx(wa, {})
    }
  ) : e === On.SupportingText ? /* @__PURE__ */ o.jsxs("div", { className: "shrink-0 text-right", children: [
    n && /* @__PURE__ */ o.jsx("div", { className: "font-inter text-label-md text-neutral-10 dark:text-neutral-92", children: n }),
    r && /* @__PURE__ */ o.jsx("div", { className: "font-inter text-label-sm text-neutral-60 dark:text-neutral-40", children: r })
  ] }) : e === On.Button ? /* @__PURE__ */ o.jsx("div", { className: "shrink-0", children: /* @__PURE__ */ o.jsx(
    _t,
    {
      type: u || Ce.Outlined,
      size: tt.Small,
      text: n,
      onClick: h,
      icon: i,
      iconAfterText: s,
      disabled: c
    }
  ) }) : null;
}
function Xu({ variant: e = Ir.Rounded }) {
  return e === Ir.Rounded ? /* @__PURE__ */ o.jsx(Zu, {}) : /* @__PURE__ */ o.jsx(qu, {});
}
function Zu() {
  return /* @__PURE__ */ o.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      children: [
        /* @__PURE__ */ o.jsxs("g", { "clip-path": "url(#clip0_880_55185)", children: [
          /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
              fill: "#5B9CFE"
            }
          ),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
              fill: "url(#paint0_linear_880_55185)",
              "fill-opacity": "0.2"
            }
          ),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
              fill: "url(#paint1_linear_880_55185)",
              "fill-opacity": "0.2"
            }
          ),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M0.5 20C0.5 9.23045 9.23045 0.5 20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20Z",
              stroke: "#002F6D",
              "stroke-opacity": "0.08"
            }
          )
        ] }),
        /* @__PURE__ */ o.jsxs("defs", { children: [
          /* @__PURE__ */ o.jsxs(
            "linearGradient",
            {
              id: "paint0_linear_880_55185",
              x1: "20",
              y1: "0",
              x2: "29.5238",
              y2: "22.381",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ o.jsx("stop", { offset: "0.990135", "stop-opacity": "0" }),
                /* @__PURE__ */ o.jsx("stop", { offset: "1" })
              ]
            }
          ),
          /* @__PURE__ */ o.jsxs(
            "linearGradient",
            {
              id: "paint1_linear_880_55185",
              x1: "20",
              y1: "0",
              x2: "11.4286",
              y2: "9.04762",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ o.jsx("stop", { offset: "0.9999", "stop-opacity": "0" }),
                /* @__PURE__ */ o.jsx("stop", { offset: "1" })
              ]
            }
          ),
          /* @__PURE__ */ o.jsx("clipPath", { id: "clip0_880_55185", children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
              fill: "white"
            }
          ) })
        ] })
      ]
    }
  );
}
function qu() {
  return /* @__PURE__ */ o.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      children: [
        /* @__PURE__ */ o.jsxs("g", { "clip-path": "url(#clip0_880_55190)", children: [
          /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
              fill: "#5B9CFE"
            }
          ),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
              fill: "url(#paint0_linear_880_55190)",
              "fill-opacity": "0.2"
            }
          ),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
              fill: "url(#paint1_linear_880_55190)",
              "fill-opacity": "0.2"
            }
          ),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H32C36.1421 0.5 39.5 3.85786 39.5 8V32C39.5 36.1421 36.1421 39.5 32 39.5H8C3.85786 39.5 0.5 36.1421 0.5 32V8Z",
              stroke: "#002F6D",
              "stroke-opacity": "0.08"
            }
          )
        ] }),
        /* @__PURE__ */ o.jsxs("defs", { children: [
          /* @__PURE__ */ o.jsxs(
            "linearGradient",
            {
              id: "paint0_linear_880_55190",
              x1: "20",
              y1: "0",
              x2: "29.5238",
              y2: "22.381",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ o.jsx("stop", { offset: "0.990135", "stop-opacity": "0" }),
                /* @__PURE__ */ o.jsx("stop", { offset: "1" })
              ]
            }
          ),
          /* @__PURE__ */ o.jsxs(
            "linearGradient",
            {
              id: "paint1_linear_880_55190",
              x1: "20",
              y1: "0",
              x2: "11.4286",
              y2: "9.04762",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ o.jsx("stop", { offset: "0.9999", "stop-opacity": "0" }),
                /* @__PURE__ */ o.jsx("stop", { offset: "1" })
              ]
            }
          ),
          /* @__PURE__ */ o.jsx("clipPath", { id: "clip0_880_55190", children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
              fill: "white"
            }
          ) })
        ] })
      ]
    }
  );
}
function Ed({
  type: e = hr.BgSolid,
  shape: t = Ir.Rounded,
  url: r,
  children: n
}) {
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: A(
        xi[t],
        zu[e],
        "flex shrink-0 items-center justify-center  overflow-hidden"
      ),
      children: [
        e === hr.Placeholder && !n && /* @__PURE__ */ o.jsx(Xu, { variant: t }),
        r && !n && /* @__PURE__ */ o.jsx(
          "img",
          {
            src: r,
            className: A(xi[t], "object-cover"),
            alt: "Card Image"
          }
        ),
        n
      ]
    }
  );
}
function Sd({
  title: e,
  subtitle: t,
  clickableAction: r,
  icon: n,
  isTextTruncated: i,
  tooltipText: s,
  tooltipPosition: u
}) {
  const c = (h) => {
    h == null || h.stopPropagation();
  };
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: A("flex w-full flex-col", {
        truncate: i
      }),
      children: [
        /* @__PURE__ */ o.jsxs(
          "div",
          {
            className: A("flex flex-row items-center gap-x-xxs", {
              "grow-1": i
            }),
            children: [
              /* @__PURE__ */ o.jsx(
                "div",
                {
                  className: A("font-inter text-title-md text-neutral-10 dark:text-neutral-92", {
                    truncate: i
                  }),
                  children: e
                }
              ),
              s ? /* @__PURE__ */ o.jsx(Mr, { text: s, position: u, children: n }) : /* @__PURE__ */ o.jsx("div", { className: "flex items-center", children: n }),
              r && /* @__PURE__ */ o.jsx("div", { onClick: c, className: "flex items-center", children: r })
            ]
          }
        ),
        t && /* @__PURE__ */ o.jsx(
          "div",
          {
            className: A("font-inter text-body-md text-neutral-40 dark:text-neutral-60", {
              truncate: i
            }),
            children: t
          }
        )
      ]
    }
  );
}
var Qt = /* @__PURE__ */ ((e) => (e.Default = "default", e.Highlight = "highlight", e.Secondary = "secondary", e))(Qt || {}), At = /* @__PURE__ */ ((e) => (e.Default = "default", e.Large = "large", e))(At || {});
const Ju = {
  [Qt.Default]: "bg-neutral-96 dark:bg-neutral-10",
  [Qt.Highlight]: "bg-primary-30 dark:bg-primary-80",
  [Qt.Secondary]: "bg-secondary-90 dark:bg-secondary-10"
}, Qu = {
  [Qt.Default]: "text-neutral-10 dark:text-neutral-92",
  [Qt.Highlight]: "text-neutral-100 dark:text-primary-10",
  [Qt.Secondary]: "text-neutral-10 dark:text-neutral-92"
}, ec = {
  [At.Default]: "gap-y-sm",
  [At.Large]: "gap-y-md"
}, tc = {
  [At.Default]: "text-title-md",
  [At.Large]: "text-headline-sm"
}, rc = {
  [At.Default]: "text-label-md",
  [At.Large]: "text-label-lg"
}, nc = {
  [At.Default]: "text-label-sm",
  [At.Large]: "text-label-md"
};
function Cd({
  label: e,
  tooltipPosition: t,
  tooltipText: r,
  value: n,
  supportingLabel: i,
  type: s = Qt.Default,
  size: u = At.Default,
  icon: c,
  copyText: h,
  onCopySuccess: m,
  onCopyError: y
}) {
  const x = Ju[s], j = ec[u], R = Qu[s], T = tc[u], k = nc[u], N = rc[u];
  async function P(V) {
    if (navigator.clipboard && h)
      try {
        await navigator.clipboard.writeText(h), m == null || m(V, h);
      } catch (D) {
        console.error("Failed to copy:", D), y == null || y(D, h);
      }
  }
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: A(
        "flex h-full w-full flex-col justify-between rounded-2xl p-md--rs",
        x,
        j,
        R
      ),
      children: [
        /* @__PURE__ */ o.jsxs(
          "div",
          {
            className: A("flex flex-row items-center", {
              "w-full justify-between": c
            }),
            children: [
              /* @__PURE__ */ o.jsxs("div", { className: "flex flex-row items-center gap-xxs", children: [
                /* @__PURE__ */ o.jsx("span", { className: A(k, "whitespace-pre-line"), children: e }),
                r && /* @__PURE__ */ o.jsx(Mr, { text: r, position: t, children: /* @__PURE__ */ o.jsx(Fn, { className: "opacity-40" }) })
              ] }),
              c && /* @__PURE__ */ o.jsx("span", { className: "text-neutral-10 dark:text-neutral-92", children: c })
            ]
          }
        ),
        /* @__PURE__ */ o.jsxs("div", { className: "flex w-full flex-row items-baseline gap-xxs", children: [
          /* @__PURE__ */ o.jsx("span", { className: A("break-all", T), children: n }),
          i && /* @__PURE__ */ o.jsx("span", { className: A("opacity-40", N), children: i }),
          h && /* @__PURE__ */ o.jsx("div", { className: "self-center", children: /* @__PURE__ */ o.jsx(nt, { onClick: P, children: /* @__PURE__ */ o.jsx(Ea, { className: "text-neutral-60 dark:text-neutral-40" }) }) })
        ] })
      ]
    }
  );
}
function er(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), r === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function ac(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function mo(...e) {
  return (t) => e.forEach((r) => ac(r, t));
}
function br(...e) {
  return E.useCallback(mo(...e), e);
}
function ic(e, t) {
  const r = E.createContext(t);
  function n(s) {
    const { children: u, ...c } = s, h = E.useMemo(() => c, Object.values(c));
    return /* @__PURE__ */ o.jsx(r.Provider, { value: h, children: u });
  }
  function i(s) {
    const u = E.useContext(r);
    if (u) return u;
    if (t !== void 0) return t;
    throw new Error(`\`${s}\` must be used within \`${e}\``);
  }
  return n.displayName = e + "Provider", [n, i];
}
function oc(e, t = []) {
  let r = [];
  function n(s, u) {
    const c = E.createContext(u), h = r.length;
    r = [...r, u];
    function m(x) {
      const { scope: j, children: R, ...T } = x, k = (j == null ? void 0 : j[e][h]) || c, N = E.useMemo(() => T, Object.values(T));
      return /* @__PURE__ */ o.jsx(k.Provider, { value: N, children: R });
    }
    function y(x, j) {
      const R = (j == null ? void 0 : j[e][h]) || c, T = E.useContext(R);
      if (T) return T;
      if (u !== void 0) return u;
      throw new Error(`\`${x}\` must be used within \`${s}\``);
    }
    return m.displayName = s + "Provider", [m, y];
  }
  const i = () => {
    const s = r.map((u) => E.createContext(u));
    return function(c) {
      const h = (c == null ? void 0 : c[e]) || s;
      return E.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: h } }),
        [c, h]
      );
    };
  };
  return i.scopeName = e, [n, sc(i, ...t)];
}
function sc(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(s) {
      const u = n.reduce((c, { useScope: h, scopeName: m }) => {
        const x = h(s)[`__scope${m}`];
        return { ...c, ...x };
      }, {});
      return E.useMemo(() => ({ [`__scope${t.scopeName}`]: u }), [u]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
var In = globalThis != null && globalThis.document ? E.useLayoutEffect : () => {
}, lc = E.useId || (() => {
}), uc = 0;
function oa(e) {
  const [t, r] = E.useState(lc());
  return In(() => {
    e || r((n) => n ?? String(uc++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function gr(e) {
  const t = E.useRef(e);
  return E.useEffect(() => {
    t.current = e;
  }), E.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
function cc({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  }
}) {
  const [n, i] = fc({ defaultProp: t, onChange: r }), s = e !== void 0, u = s ? e : n, c = gr(r), h = E.useCallback(
    (m) => {
      if (s) {
        const x = typeof m == "function" ? m(e) : m;
        x !== e && c(x);
      } else
        i(m);
    },
    [s, e, i, c]
  );
  return [u, h];
}
function fc({
  defaultProp: e,
  onChange: t
}) {
  const r = E.useState(e), [n] = r, i = E.useRef(n), s = gr(t);
  return E.useEffect(() => {
    i.current !== n && (s(n), i.current = n);
  }, [n, i, s]), r;
}
var Ra = E.forwardRef((e, t) => {
  const { children: r, ...n } = e, i = E.Children.toArray(r), s = i.find(vc);
  if (s) {
    const u = s.props.children, c = i.map((h) => h === s ? E.Children.count(u) > 1 ? E.Children.only(null) : E.isValidElement(u) ? u.props.children : null : h);
    return /* @__PURE__ */ o.jsx(xa, { ...n, ref: t, children: E.isValidElement(u) ? E.cloneElement(u, void 0, c) : null });
  }
  return /* @__PURE__ */ o.jsx(xa, { ...n, ref: t, children: r });
});
Ra.displayName = "Slot";
var xa = E.forwardRef((e, t) => {
  const { children: r, ...n } = e;
  if (E.isValidElement(r)) {
    const i = hc(r);
    return E.cloneElement(r, {
      ...mc(n, r.props),
      // @ts-ignore
      ref: t ? mo(t, i) : i
    });
  }
  return E.Children.count(r) > 1 ? E.Children.only(null) : null;
});
xa.displayName = "SlotClone";
var dc = ({ children: e }) => /* @__PURE__ */ o.jsx(o.Fragment, { children: e });
function vc(e) {
  return E.isValidElement(e) && e.type === dc;
}
function mc(e, t) {
  const r = { ...t };
  for (const n in t) {
    const i = e[n], s = t[n];
    /^on[A-Z]/.test(n) ? i && s ? r[n] = (...c) => {
      s(...c), i(...c);
    } : i && (r[n] = i) : n === "style" ? r[n] = { ...i, ...s } : n === "className" && (r[n] = [i, s].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function hc(e) {
  var n, i;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var pc = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Dt = pc.reduce((e, t) => {
  const r = E.forwardRef((n, i) => {
    const { asChild: s, ...u } = n, c = s ? Ra : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ o.jsx(c, { ...u, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function gc(e, t) {
  e && Ni.flushSync(() => e.dispatchEvent(t));
}
function xc(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = gr(e);
  E.useEffect(() => {
    const n = (i) => {
      i.key === "Escape" && r(i);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [r, t]);
}
var bc = "DismissableLayer", ba = "dismissableLayer.update", yc = "dismissableLayer.pointerDownOutside", _c = "dismissableLayer.focusOutside", bi, ho = E.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), po = E.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: i,
      onFocusOutside: s,
      onInteractOutside: u,
      onDismiss: c,
      ...h
    } = e, m = E.useContext(ho), [y, x] = E.useState(null), j = (y == null ? void 0 : y.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, R] = E.useState({}), T = br(t, (W) => x(W)), k = Array.from(m.layers), [N] = [...m.layersWithOutsidePointerEventsDisabled].slice(-1), P = k.indexOf(N), V = y ? k.indexOf(y) : -1, D = m.layersWithOutsidePointerEventsDisabled.size > 0, z = V >= P, H = Sc((W) => {
      const G = W.target, ce = [...m.branches].some((Ne) => Ne.contains(G));
      !z || ce || (i == null || i(W), u == null || u(W), W.defaultPrevented || c == null || c());
    }, j), Y = Cc((W) => {
      const G = W.target;
      [...m.branches].some((Ne) => Ne.contains(G)) || (s == null || s(W), u == null || u(W), W.defaultPrevented || c == null || c());
    }, j);
    return xc((W) => {
      V === m.layers.size - 1 && (n == null || n(W), !W.defaultPrevented && c && (W.preventDefault(), c()));
    }, j), E.useEffect(() => {
      if (y)
        return r && (m.layersWithOutsidePointerEventsDisabled.size === 0 && (bi = j.body.style.pointerEvents, j.body.style.pointerEvents = "none"), m.layersWithOutsidePointerEventsDisabled.add(y)), m.layers.add(y), yi(), () => {
          r && m.layersWithOutsidePointerEventsDisabled.size === 1 && (j.body.style.pointerEvents = bi);
        };
    }, [y, j, r, m]), E.useEffect(() => () => {
      y && (m.layers.delete(y), m.layersWithOutsidePointerEventsDisabled.delete(y), yi());
    }, [y, m]), E.useEffect(() => {
      const W = () => R({});
      return document.addEventListener(ba, W), () => document.removeEventListener(ba, W);
    }, []), /* @__PURE__ */ o.jsx(
      Dt.div,
      {
        ...h,
        ref: T,
        style: {
          pointerEvents: D ? z ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: er(e.onFocusCapture, Y.onFocusCapture),
        onBlurCapture: er(e.onBlurCapture, Y.onBlurCapture),
        onPointerDownCapture: er(
          e.onPointerDownCapture,
          H.onPointerDownCapture
        )
      }
    );
  }
);
po.displayName = bc;
var wc = "DismissableLayerBranch", Ec = E.forwardRef((e, t) => {
  const r = E.useContext(ho), n = E.useRef(null), i = br(t, n);
  return E.useEffect(() => {
    const s = n.current;
    if (s)
      return r.branches.add(s), () => {
        r.branches.delete(s);
      };
  }, [r.branches]), /* @__PURE__ */ o.jsx(Dt.div, { ...e, ref: i });
});
Ec.displayName = wc;
function Sc(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = gr(e), n = E.useRef(!1), i = E.useRef(() => {
  });
  return E.useEffect(() => {
    const s = (c) => {
      if (c.target && !n.current) {
        let h = function() {
          go(
            yc,
            r,
            m,
            { discrete: !0 }
          );
        };
        const m = { originalEvent: c };
        c.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = h, t.addEventListener("click", i.current, { once: !0 })) : h();
      } else
        t.removeEventListener("click", i.current);
      n.current = !1;
    }, u = window.setTimeout(() => {
      t.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(u), t.removeEventListener("pointerdown", s), t.removeEventListener("click", i.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function Cc(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = gr(e), n = E.useRef(!1);
  return E.useEffect(() => {
    const i = (s) => {
      s.target && !n.current && go(_c, r, { originalEvent: s }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function yi() {
  const e = new CustomEvent(ba);
  document.dispatchEvent(e);
}
function go(e, t, r, { discrete: n }) {
  const i = r.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && i.addEventListener(e, t, { once: !0 }), n ? gc(i, s) : i.dispatchEvent(s);
}
var sa = "focusScope.autoFocusOnMount", la = "focusScope.autoFocusOnUnmount", _i = { bubbles: !1, cancelable: !0 }, jc = "FocusScope", xo = E.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: s,
    ...u
  } = e, [c, h] = E.useState(null), m = gr(i), y = gr(s), x = E.useRef(null), j = br(t, (k) => h(k)), R = E.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  E.useEffect(() => {
    if (n) {
      let k = function(D) {
        if (R.paused || !c) return;
        const z = D.target;
        c.contains(z) ? x.current = z : Zt(x.current, { select: !0 });
      }, N = function(D) {
        if (R.paused || !c) return;
        const z = D.relatedTarget;
        z !== null && (c.contains(z) || Zt(x.current, { select: !0 }));
      }, P = function(D) {
        if (document.activeElement === document.body)
          for (const H of D)
            H.removedNodes.length > 0 && Zt(c);
      };
      document.addEventListener("focusin", k), document.addEventListener("focusout", N);
      const V = new MutationObserver(P);
      return c && V.observe(c, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", k), document.removeEventListener("focusout", N), V.disconnect();
      };
    }
  }, [n, c, R.paused]), E.useEffect(() => {
    if (c) {
      Ei.add(R);
      const k = document.activeElement;
      if (!c.contains(k)) {
        const P = new CustomEvent(sa, _i);
        c.addEventListener(sa, m), c.dispatchEvent(P), P.defaultPrevented || (Rc(Pc(bo(c)), { select: !0 }), document.activeElement === k && Zt(c));
      }
      return () => {
        c.removeEventListener(sa, m), setTimeout(() => {
          const P = new CustomEvent(la, _i);
          c.addEventListener(la, y), c.dispatchEvent(P), P.defaultPrevented || Zt(k ?? document.body, { select: !0 }), c.removeEventListener(la, y), Ei.remove(R);
        }, 0);
      };
    }
  }, [c, m, y, R]);
  const T = E.useCallback(
    (k) => {
      if (!r && !n || R.paused) return;
      const N = k.key === "Tab" && !k.altKey && !k.ctrlKey && !k.metaKey, P = document.activeElement;
      if (N && P) {
        const V = k.currentTarget, [D, z] = kc(V);
        D && z ? !k.shiftKey && P === z ? (k.preventDefault(), r && Zt(D, { select: !0 })) : k.shiftKey && P === D && (k.preventDefault(), r && Zt(z, { select: !0 })) : P === V && k.preventDefault();
      }
    },
    [r, n, R.paused]
  );
  return /* @__PURE__ */ o.jsx(Dt.div, { tabIndex: -1, ...u, ref: j, onKeyDown: T });
});
xo.displayName = jc;
function Rc(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (Zt(n, { select: t }), document.activeElement !== r) return;
}
function kc(e) {
  const t = bo(e), r = wi(t, e), n = wi(t.reverse(), e);
  return [r, n];
}
function bo(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const i = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || i ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function wi(e, t) {
  for (const r of e)
    if (!Oc(r, { upTo: t })) return r;
}
function Oc(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Tc(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Zt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && Tc(e) && t && e.select();
  }
}
var Ei = Nc();
function Nc() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = Si(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = Si(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function Si(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function Pc(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Ac = "Portal", yo = E.forwardRef((e, t) => {
  var c;
  const { container: r, ...n } = e, [i, s] = E.useState(!1);
  In(() => s(!0), []);
  const u = r || i && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return u ? os.createPortal(/* @__PURE__ */ o.jsx(Dt.div, { ...n, ref: t }), u) : null;
});
yo.displayName = Ac;
function Dc(e, t) {
  return E.useReducer((r, n) => t[r][n] ?? r, e);
}
var Vn = (e) => {
  const { present: t, children: r } = e, n = Ic(t), i = typeof r == "function" ? r({ present: n.isPresent }) : E.Children.only(r), s = br(n.ref, Lc(i));
  return typeof r == "function" || n.isPresent ? E.cloneElement(i, { ref: s }) : null;
};
Vn.displayName = "Presence";
function Ic(e) {
  const [t, r] = E.useState(), n = E.useRef({}), i = E.useRef(e), s = E.useRef("none"), u = e ? "mounted" : "unmounted", [c, h] = Dc(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return E.useEffect(() => {
    const m = yn(n.current);
    s.current = c === "mounted" ? m : "none";
  }, [c]), In(() => {
    const m = n.current, y = i.current;
    if (y !== e) {
      const j = s.current, R = yn(m);
      e ? h("MOUNT") : R === "none" || (m == null ? void 0 : m.display) === "none" ? h("UNMOUNT") : h(y && j !== R ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, h]), In(() => {
    if (t) {
      const m = (x) => {
        const R = yn(n.current).includes(x.animationName);
        x.target === t && R && Ni.flushSync(() => h("ANIMATION_END"));
      }, y = (x) => {
        x.target === t && (s.current = yn(n.current));
      };
      return t.addEventListener("animationstart", y), t.addEventListener("animationcancel", m), t.addEventListener("animationend", m), () => {
        t.removeEventListener("animationstart", y), t.removeEventListener("animationcancel", m), t.removeEventListener("animationend", m);
      };
    } else
      h("ANIMATION_END");
  }, [t, h]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: E.useCallback((m) => {
      m && (n.current = getComputedStyle(m)), r(m);
    }, [])
  };
}
function yn(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Lc(e) {
  var n, i;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var ua = 0;
function Mc() {
  E.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Ci()), document.body.insertAdjacentElement("beforeend", e[1] ?? Ci()), ua++, () => {
      ua === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), ua--;
    };
  }, []);
}
function Ci() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var Nt = function() {
  return Nt = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var s in r) Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
    }
    return t;
  }, Nt.apply(this, arguments);
};
function _o(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function Fc(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, s; n < i; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var Tn = "right-scroll-bar-position", Nn = "width-before-scroll-bar", Bc = "with-scroll-bars-hidden", Vc = "--removed-body-scroll-bar-size";
function ca(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Wc(e, t) {
  var r = vt(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var i = r.value;
          i !== n && (r.value = n, r.callback(n, i));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var Uc = typeof window < "u" ? E.useLayoutEffect : E.useEffect, ji = /* @__PURE__ */ new WeakMap();
function $c(e, t) {
  var r = Wc(null, function(n) {
    return e.forEach(function(i) {
      return ca(i, n);
    });
  });
  return Uc(function() {
    var n = ji.get(r);
    if (n) {
      var i = new Set(n), s = new Set(e), u = r.current;
      i.forEach(function(c) {
        s.has(c) || ca(c, null);
      }), s.forEach(function(c) {
        i.has(c) || ca(c, u);
      });
    }
    ji.set(r, e);
  }, [e]), r;
}
function Gc(e) {
  return e;
}
function Hc(e, t) {
  t === void 0 && (t = Gc);
  var r = [], n = !1, i = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(s) {
      var u = t(s, n);
      return r.push(u), function() {
        r = r.filter(function(c) {
          return c !== u;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (n = !0; r.length; ) {
        var u = r;
        r = [], u.forEach(s);
      }
      r = {
        push: function(c) {
          return s(c);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(s) {
      n = !0;
      var u = [];
      if (r.length) {
        var c = r;
        r = [], c.forEach(s), u = r;
      }
      var h = function() {
        var y = u;
        u = [], y.forEach(s);
      }, m = function() {
        return Promise.resolve().then(h);
      };
      m(), r = {
        push: function(y) {
          u.push(y), m();
        },
        filter: function(y) {
          return u = u.filter(y), r;
        }
      };
    }
  };
  return i;
}
function Yc(e) {
  e === void 0 && (e = {});
  var t = Hc(null);
  return t.options = Nt({ async: !0, ssr: !1 }, e), t;
}
var wo = function(e) {
  var t = e.sideCar, r = _o(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return E.createElement(n, Nt({}, r));
};
wo.isSideCarExport = !0;
function zc(e, t) {
  return e.useMedium(t), wo;
}
var Eo = Yc(), fa = function() {
}, Wn = E.forwardRef(function(e, t) {
  var r = E.useRef(null), n = E.useState({
    onScrollCapture: fa,
    onWheelCapture: fa,
    onTouchMoveCapture: fa
  }), i = n[0], s = n[1], u = e.forwardProps, c = e.children, h = e.className, m = e.removeScrollBar, y = e.enabled, x = e.shards, j = e.sideCar, R = e.noIsolation, T = e.inert, k = e.allowPinchZoom, N = e.as, P = N === void 0 ? "div" : N, V = e.gapMode, D = _o(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), z = j, H = $c([r, t]), Y = Nt(Nt({}, D), i);
  return E.createElement(
    E.Fragment,
    null,
    y && E.createElement(z, { sideCar: Eo, removeScrollBar: m, shards: x, noIsolation: R, inert: T, setCallbacks: s, allowPinchZoom: !!k, lockRef: r, gapMode: V }),
    u ? E.cloneElement(E.Children.only(c), Nt(Nt({}, Y), { ref: H })) : E.createElement(P, Nt({}, Y, { className: h, ref: H }), c)
  );
});
Wn.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Wn.classNames = {
  fullWidth: Nn,
  zeroRight: Tn
};
var Kc = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Xc() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Kc();
  return t && e.setAttribute("nonce", t), e;
}
function Zc(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function qc(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Jc = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = Xc()) && (Zc(t, r), qc(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Qc = function() {
  var e = Jc();
  return function(t, r) {
    E.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, So = function() {
  var e = Qc(), t = function(r) {
    var n = r.styles, i = r.dynamic;
    return e(n, i), null;
  };
  return t;
}, ef = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, da = function(e) {
  return parseInt(e || "", 10) || 0;
}, tf = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [da(r), da(n), da(i)];
}, rf = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return ef;
  var t = tf(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, nf = So(), Ar = "data-scroll-locked", af = function(e, t, r, n) {
  var i = e.left, s = e.top, u = e.right, c = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(Bc, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(c, "px ").concat(n, `;
  }
  body[`).concat(Ar, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(u, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(c, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Tn, ` {
    right: `).concat(c, "px ").concat(n, `;
  }
  
  .`).concat(Nn, ` {
    margin-right: `).concat(c, "px ").concat(n, `;
  }
  
  .`).concat(Tn, " .").concat(Tn, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Nn, " .").concat(Nn, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(Ar, `] {
    `).concat(Vc, ": ").concat(c, `px;
  }
`);
}, Ri = function() {
  var e = parseInt(document.body.getAttribute(Ar) || "0", 10);
  return isFinite(e) ? e : 0;
}, of = function() {
  E.useEffect(function() {
    return document.body.setAttribute(Ar, (Ri() + 1).toString()), function() {
      var e = Ri() - 1;
      e <= 0 ? document.body.removeAttribute(Ar) : document.body.setAttribute(Ar, e.toString());
    };
  }, []);
}, sf = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, i = n === void 0 ? "margin" : n;
  of();
  var s = E.useMemo(function() {
    return rf(i);
  }, [i]);
  return E.createElement(nf, { styles: af(s, !t, i, r ? "" : "!important") });
}, ya = !1;
if (typeof window < "u")
  try {
    var _n = Object.defineProperty({}, "passive", {
      get: function() {
        return ya = !0, !0;
      }
    });
    window.addEventListener("test", _n, _n), window.removeEventListener("test", _n, _n);
  } catch {
    ya = !1;
  }
var jr = ya ? { passive: !1 } : !1, lf = function(e) {
  return e.tagName === "TEXTAREA";
}, Co = function(e, t) {
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !lf(e) && r[t] === "visible")
  );
}, uf = function(e) {
  return Co(e, "overflowY");
}, cf = function(e) {
  return Co(e, "overflowX");
}, ki = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var i = jo(e, n);
    if (i) {
      var s = Ro(e, n), u = s[1], c = s[2];
      if (u > c)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, ff = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, df = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, jo = function(e, t) {
  return e === "v" ? uf(t) : cf(t);
}, Ro = function(e, t) {
  return e === "v" ? ff(t) : df(t);
}, vf = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, mf = function(e, t, r, n, i) {
  var s = vf(e, window.getComputedStyle(t).direction), u = s * n, c = r.target, h = t.contains(c), m = !1, y = u > 0, x = 0, j = 0;
  do {
    var R = Ro(e, c), T = R[0], k = R[1], N = R[2], P = k - N - s * T;
    (T || P) && jo(e, c) && (x += P, j += T), c instanceof ShadowRoot ? c = c.host : c = c.parentNode;
  } while (
    // portaled content
    !h && c !== document.body || // self content
    h && (t.contains(c) || t === c)
  );
  return (y && Math.abs(x) < 1 || !y && Math.abs(j) < 1) && (m = !0), m;
}, wn = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Oi = function(e) {
  return [e.deltaX, e.deltaY];
}, Ti = function(e) {
  return e && "current" in e ? e.current : e;
}, hf = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, pf = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, gf = 0, Rr = [];
function xf(e) {
  var t = E.useRef([]), r = E.useRef([0, 0]), n = E.useRef(), i = E.useState(gf++)[0], s = E.useState(So)[0], u = E.useRef(e);
  E.useEffect(function() {
    u.current = e;
  }, [e]), E.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var k = Fc([e.lockRef.current], (e.shards || []).map(Ti), !0).filter(Boolean);
      return k.forEach(function(N) {
        return N.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), k.forEach(function(N) {
          return N.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = E.useCallback(function(k, N) {
    if ("touches" in k && k.touches.length === 2)
      return !u.current.allowPinchZoom;
    var P = wn(k), V = r.current, D = "deltaX" in k ? k.deltaX : V[0] - P[0], z = "deltaY" in k ? k.deltaY : V[1] - P[1], H, Y = k.target, W = Math.abs(D) > Math.abs(z) ? "h" : "v";
    if ("touches" in k && W === "h" && Y.type === "range")
      return !1;
    var G = ki(W, Y);
    if (!G)
      return !0;
    if (G ? H = W : (H = W === "v" ? "h" : "v", G = ki(W, Y)), !G)
      return !1;
    if (!n.current && "changedTouches" in k && (D || z) && (n.current = H), !H)
      return !0;
    var ce = n.current || H;
    return mf(ce, N, k, ce === "h" ? D : z);
  }, []), h = E.useCallback(function(k) {
    var N = k;
    if (!(!Rr.length || Rr[Rr.length - 1] !== s)) {
      var P = "deltaY" in N ? Oi(N) : wn(N), V = t.current.filter(function(H) {
        return H.name === N.type && (H.target === N.target || N.target === H.shadowParent) && hf(H.delta, P);
      })[0];
      if (V && V.should) {
        N.cancelable && N.preventDefault();
        return;
      }
      if (!V) {
        var D = (u.current.shards || []).map(Ti).filter(Boolean).filter(function(H) {
          return H.contains(N.target);
        }), z = D.length > 0 ? c(N, D[0]) : !u.current.noIsolation;
        z && N.cancelable && N.preventDefault();
      }
    }
  }, []), m = E.useCallback(function(k, N, P, V) {
    var D = { name: k, delta: N, target: P, should: V, shadowParent: bf(P) };
    t.current.push(D), setTimeout(function() {
      t.current = t.current.filter(function(z) {
        return z !== D;
      });
    }, 1);
  }, []), y = E.useCallback(function(k) {
    r.current = wn(k), n.current = void 0;
  }, []), x = E.useCallback(function(k) {
    m(k.type, Oi(k), k.target, c(k, e.lockRef.current));
  }, []), j = E.useCallback(function(k) {
    m(k.type, wn(k), k.target, c(k, e.lockRef.current));
  }, []);
  E.useEffect(function() {
    return Rr.push(s), e.setCallbacks({
      onScrollCapture: x,
      onWheelCapture: x,
      onTouchMoveCapture: j
    }), document.addEventListener("wheel", h, jr), document.addEventListener("touchmove", h, jr), document.addEventListener("touchstart", y, jr), function() {
      Rr = Rr.filter(function(k) {
        return k !== s;
      }), document.removeEventListener("wheel", h, jr), document.removeEventListener("touchmove", h, jr), document.removeEventListener("touchstart", y, jr);
    };
  }, []);
  var R = e.removeScrollBar, T = e.inert;
  return E.createElement(
    E.Fragment,
    null,
    T ? E.createElement(s, { styles: pf(i) }) : null,
    R ? E.createElement(sf, { gapMode: e.gapMode }) : null
  );
}
function bf(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const yf = zc(Eo, xf);
var ko = E.forwardRef(function(e, t) {
  return E.createElement(Wn, Nt({}, e, { ref: t, sideCar: yf }));
});
ko.classNames = Wn.classNames;
var _f = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, kr = /* @__PURE__ */ new WeakMap(), En = /* @__PURE__ */ new WeakMap(), Sn = {}, va = 0, Oo = function(e) {
  return e && (e.host || Oo(e.parentNode));
}, wf = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = Oo(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, Ef = function(e, t, r, n) {
  var i = wf(t, Array.isArray(e) ? e : [e]);
  Sn[r] || (Sn[r] = /* @__PURE__ */ new WeakMap());
  var s = Sn[r], u = [], c = /* @__PURE__ */ new Set(), h = new Set(i), m = function(x) {
    !x || c.has(x) || (c.add(x), m(x.parentNode));
  };
  i.forEach(m);
  var y = function(x) {
    !x || h.has(x) || Array.prototype.forEach.call(x.children, function(j) {
      if (c.has(j))
        y(j);
      else
        try {
          var R = j.getAttribute(n), T = R !== null && R !== "false", k = (kr.get(j) || 0) + 1, N = (s.get(j) || 0) + 1;
          kr.set(j, k), s.set(j, N), u.push(j), k === 1 && T && En.set(j, !0), N === 1 && j.setAttribute(r, "true"), T || j.setAttribute(n, "true");
        } catch (P) {
          console.error("aria-hidden: cannot operate on ", j, P);
        }
    });
  };
  return y(t), c.clear(), va++, function() {
    u.forEach(function(x) {
      var j = kr.get(x) - 1, R = s.get(x) - 1;
      kr.set(x, j), s.set(x, R), j || (En.has(x) || x.removeAttribute(n), En.delete(x)), R || x.removeAttribute(r);
    }), va--, va || (kr = /* @__PURE__ */ new WeakMap(), kr = /* @__PURE__ */ new WeakMap(), En = /* @__PURE__ */ new WeakMap(), Sn = {});
  };
}, Sf = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), i = _f(e);
  return i ? (n.push.apply(n, Array.from(i.querySelectorAll("[aria-live]"))), Ef(n, i, r, "aria-hidden")) : function() {
    return null;
  };
}, ka = "Dialog", [To, jd] = oc(ka), [Cf, Et] = To(ka), No = (e) => {
  const {
    __scopeDialog: t,
    children: r,
    open: n,
    defaultOpen: i,
    onOpenChange: s,
    modal: u = !0
  } = e, c = E.useRef(null), h = E.useRef(null), [m = !1, y] = cc({
    prop: n,
    defaultProp: i,
    onChange: s
  });
  return /* @__PURE__ */ o.jsx(
    Cf,
    {
      scope: t,
      triggerRef: c,
      contentRef: h,
      contentId: oa(),
      titleId: oa(),
      descriptionId: oa(),
      open: m,
      onOpenChange: y,
      onOpenToggle: E.useCallback(() => y((x) => !x), [y]),
      modal: u,
      children: r
    }
  );
};
No.displayName = ka;
var Po = "DialogTrigger", Ao = E.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, i = Et(Po, r), s = br(t, i.triggerRef);
    return /* @__PURE__ */ o.jsx(
      Dt.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": Na(i.open),
        ...n,
        ref: s,
        onClick: er(e.onClick, i.onOpenToggle)
      }
    );
  }
);
Ao.displayName = Po;
var Oa = "DialogPortal", [jf, Do] = To(Oa, {
  forceMount: void 0
}), Io = (e) => {
  const { __scopeDialog: t, forceMount: r, children: n, container: i } = e, s = Et(Oa, t);
  return /* @__PURE__ */ o.jsx(jf, { scope: t, forceMount: r, children: E.Children.map(n, (u) => /* @__PURE__ */ o.jsx(Vn, { present: r || s.open, children: /* @__PURE__ */ o.jsx(yo, { asChild: !0, container: i, children: u }) })) });
};
Io.displayName = Oa;
var Ln = "DialogOverlay", Lo = E.forwardRef(
  (e, t) => {
    const r = Do(Ln, e.__scopeDialog), { forceMount: n = r.forceMount, ...i } = e, s = Et(Ln, e.__scopeDialog);
    return s.modal ? /* @__PURE__ */ o.jsx(Vn, { present: n || s.open, children: /* @__PURE__ */ o.jsx(Rf, { ...i, ref: t }) }) : null;
  }
);
Lo.displayName = Ln;
var Rf = E.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, i = Et(Ln, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ o.jsx(ko, { as: Ra, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ o.jsx(
        Dt.div,
        {
          "data-state": Na(i.open),
          ...n,
          ref: t,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), xr = "DialogContent", Mo = E.forwardRef(
  (e, t) => {
    const r = Do(xr, e.__scopeDialog), { forceMount: n = r.forceMount, ...i } = e, s = Et(xr, e.__scopeDialog);
    return /* @__PURE__ */ o.jsx(Vn, { present: n || s.open, children: s.modal ? /* @__PURE__ */ o.jsx(kf, { ...i, ref: t }) : /* @__PURE__ */ o.jsx(Of, { ...i, ref: t }) });
  }
);
Mo.displayName = xr;
var kf = E.forwardRef(
  (e, t) => {
    const r = Et(xr, e.__scopeDialog), n = E.useRef(null), i = br(t, r.contentRef, n);
    return E.useEffect(() => {
      const s = n.current;
      if (s) return Sf(s);
    }, []), /* @__PURE__ */ o.jsx(
      Fo,
      {
        ...e,
        ref: i,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: er(e.onCloseAutoFocus, (s) => {
          var u;
          s.preventDefault(), (u = r.triggerRef.current) == null || u.focus();
        }),
        onPointerDownOutside: er(e.onPointerDownOutside, (s) => {
          const u = s.detail.originalEvent, c = u.button === 0 && u.ctrlKey === !0;
          (u.button === 2 || c) && s.preventDefault();
        }),
        onFocusOutside: er(
          e.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }
), Of = E.forwardRef(
  (e, t) => {
    const r = Et(xr, e.__scopeDialog), n = E.useRef(!1), i = E.useRef(!1);
    return /* @__PURE__ */ o.jsx(
      Fo,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var u, c;
          (u = e.onCloseAutoFocus) == null || u.call(e, s), s.defaultPrevented || (n.current || (c = r.triggerRef.current) == null || c.focus(), s.preventDefault()), n.current = !1, i.current = !1;
        },
        onInteractOutside: (s) => {
          var h, m;
          (h = e.onInteractOutside) == null || h.call(e, s), s.defaultPrevented || (n.current = !0, s.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const u = s.target;
          ((m = r.triggerRef.current) == null ? void 0 : m.contains(u)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && i.current && s.preventDefault();
        }
      }
    );
  }
), Fo = E.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: i, onCloseAutoFocus: s, ...u } = e, c = Et(xr, r), h = E.useRef(null), m = br(t, h);
    return Mc(), /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx(
        xo,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: i,
          onUnmountAutoFocus: s,
          children: /* @__PURE__ */ o.jsx(
            po,
            {
              role: "dialog",
              id: c.contentId,
              "aria-describedby": c.descriptionId,
              "aria-labelledby": c.titleId,
              "data-state": Na(c.open),
              ...u,
              ref: m,
              onDismiss: () => c.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
        /* @__PURE__ */ o.jsx(Tf, { titleId: c.titleId }),
        /* @__PURE__ */ o.jsx(Pf, { contentRef: h, descriptionId: c.descriptionId })
      ] })
    ] });
  }
), Ta = "DialogTitle", Bo = E.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, i = Et(Ta, r);
    return /* @__PURE__ */ o.jsx(Dt.h2, { id: i.titleId, ...n, ref: t });
  }
);
Bo.displayName = Ta;
var Vo = "DialogDescription", Wo = E.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, i = Et(Vo, r);
    return /* @__PURE__ */ o.jsx(Dt.p, { id: i.descriptionId, ...n, ref: t });
  }
);
Wo.displayName = Vo;
var Uo = "DialogClose", $o = E.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, i = Et(Uo, r);
    return /* @__PURE__ */ o.jsx(
      Dt.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: er(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
$o.displayName = Uo;
function Na(e) {
  return e ? "open" : "closed";
}
var Go = "DialogTitleWarning", [Rd, Ho] = ic(Go, {
  contentName: xr,
  titleName: Ta,
  docsSlug: "dialog"
}), Tf = ({ titleId: e }) => {
  const t = Ho(Go), r = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return E.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, Nf = "DialogDescriptionWarning", Pf = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Ho(Nf).contentName}}.`;
  return E.useEffect(() => {
    var s;
    const i = (s = e.current) == null ? void 0 : s.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, Af = No, Df = Ao, If = Io, Yo = Lo, zo = Mo, Pa = Bo, Lf = Wo, Mf = $o, Ff = "VisuallyHidden", Ko = E.forwardRef(
  (e, t) => /* @__PURE__ */ o.jsx(
    Dt.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Ko.displayName = Ff;
var Bf = Ko, pr = /* @__PURE__ */ ((e) => (e.Center = "center", e.Right = "right", e))(pr || {});
const kd = ({
  open: e,
  onOpenChange: t,
  children: r,
  ...n
}) => {
  const i = (s) => {
    const u = document.querySelector(".toast-layer:hover");
    !s && u || t == null || t(s);
  };
  return /* @__PURE__ */ o.jsx(Af, { open: e, onOpenChange: i, ...n, children: r });
}, Od = Df, Vf = Mf, Xo = E.forwardRef(({ showCloseIcon: e, position: t, ...r }, n) => /* @__PURE__ */ o.jsx(
  Yo,
  {
    ref: n,
    className: A("inset-0 z-[99998] bg-shader-neutral-light-48 backdrop-blur-md", {
      fixed: t === pr.Right,
      absolute: t === pr.Center
    }),
    ...r,
    children: /* @__PURE__ */ o.jsx(Vf, { className: A("fixed right-3 top-3", { hidden: !e }), children: /* @__PURE__ */ o.jsx(rn, {}) })
  }
));
Xo.displayName = Yo.displayName;
const Wf = E.forwardRef(
  ({
    className: e,
    containerId: t,
    showCloseOnOverlay: r,
    children: n,
    position: i = pr.Center,
    customWidth: s = "w-80 max-w-[85vw] md:w-96",
    ...u
  }, c) => {
    const [h, m] = vt(
      void 0
    );
    wt(() => {
      const R = t ? document.getElementById(t) : void 0;
      m(R ?? void 0);
    }, [t]);
    const y = i === pr.Right ? "overflow-hidden right-0 h-screen top-0 w-full" : "overflow-y-auto overflow-x-hidden left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl", x = i === pr.Right ? "md:w-96 max-w-[500px]" : s, j = i === pr.Right ? "h-screen" : "max-h-[80vh] h-full";
    return /* @__PURE__ */ o.jsxs(If, { container: h, children: [
      /* @__PURE__ */ o.jsx(Xo, { showCloseIcon: r, position: i }),
      /* @__PURE__ */ o.jsxs(
        zo,
        {
          ref: c,
          className: A(
            "fixed z-[99999] flex flex-col justify-center bg-primary-100 dark:bg-neutral-6",
            y,
            x
          ),
          ...u,
          children: [
            /* @__PURE__ */ o.jsxs(Bf, { children: [
              /* @__PURE__ */ o.jsx(Pa, {}),
              /* @__PURE__ */ o.jsx(Lf, {})
            ] }),
            /* @__PURE__ */ o.jsx("div", { className: A("flex flex-1 flex-col", j), children: n })
          ]
        }
      )
    ] });
  }
);
Wf.displayName = zo.displayName;
const Uf = E.forwardRef((e, t) => /* @__PURE__ */ o.jsx(
  Pa,
  {
    ref: t,
    className: "font-inter text-title-lg text-neutral-10 dark:text-neutral-92",
    ...e
  }
));
Uf.displayName = Pa.displayName;
const $f = E.forwardRef(
  (e, t) => /* @__PURE__ */ o.jsx(
    "div",
    {
      ref: t,
      className: "flex-1 overflow-y-auto p-md--rs text-body-sm text-neutral-40 dark:text-neutral-60",
      ...e
    }
  )
);
$f.displayName = "DialogBody";
const Zo = as({
  isHeaderChecked: !1,
  selectedRowIndexes: /* @__PURE__ */ new Set(),
  isHeaderIndeterminate: !1
}), qo = () => is(Zo);
function Gf({
  children: e,
  selectedRowIndexes: t,
  rowIndexes: r,
  ...n
}) {
  const i = r.length === t.size, s = !i && t.size > 0;
  return /* @__PURE__ */ o.jsx(
    Zo.Provider,
    {
      value: {
        ...n,
        isHeaderChecked: i,
        selectedRowIndexes: t,
        isHeaderIndeterminate: s
      },
      children: e
    }
  );
}
function Td({
  paginationOptions: e,
  action: t,
  supportingLabel: r,
  selectedRowIndexes: n = /* @__PURE__ */ new Set(),
  rowIndexes: i,
  children: s,
  pageSizeSelector: u,
  heightFull: c = !1
}) {
  return /* @__PURE__ */ o.jsx(Gf, { selectedRowIndexes: n, rowIndexes: i, children: /* @__PURE__ */ o.jsxs("div", { className: A("w-full", { "h-full": c }), children: [
    /* @__PURE__ */ o.jsx(
      "div",
      {
        className: A("overflow-auto", {
          "h-full": c
        }),
        children: /* @__PURE__ */ o.jsx(
          "table",
          {
            className: A("w-full table-auto", {
              "h-full": c
            }),
            children: s
          }
        )
      }
    ),
    /* @__PURE__ */ o.jsxs(
      "div",
      {
        className: A("flex w-full items-center gap-sm pt-md", {
          hidden: !r && !e && !t,
          "flex-col justify-between sm:flex-row": e,
          "justify-end": !e && t
        }),
        children: [
          (e || t) && /* @__PURE__ */ o.jsxs("div", { className: "flex gap-2", children: [
            e && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
              /* @__PURE__ */ o.jsx(
                _t,
                {
                  type: Ce.Secondary,
                  size: tt.Small,
                  icon: /* @__PURE__ */ o.jsx(il, {}),
                  disabled: !e.hasFirst,
                  onClick: e.onFirst
                }
              ),
              /* @__PURE__ */ o.jsx(
                _t,
                {
                  type: Ce.Secondary,
                  size: tt.Small,
                  icon: /* @__PURE__ */ o.jsx(el, {}),
                  disabled: !e.hasPrev,
                  onClick: e.onPrev
                }
              ),
              /* @__PURE__ */ o.jsx(
                _t,
                {
                  type: Ce.Secondary,
                  size: tt.Small,
                  icon: /* @__PURE__ */ o.jsx(wa, {}),
                  disabled: !e.hasNext,
                  onClick: e.onNext
                }
              ),
              /* @__PURE__ */ o.jsx(
                _t,
                {
                  type: Ce.Secondary,
                  size: tt.Small,
                  icon: /* @__PURE__ */ o.jsx(ol, {}),
                  disabled: !e.hasLast,
                  onClick: e.onLast
                }
              )
            ] }),
            t && t
          ] }),
          r || u ? /* @__PURE__ */ o.jsxs("div", { className: "flex flex-row items-center gap-x-sm", children: [
            r && /* @__PURE__ */ o.jsx("span", { className: " text-label-md text-neutral-40 dark:text-neutral-60", children: r }),
            u && /* @__PURE__ */ o.jsx("div", { className: "ml-2", children: u })
          ] }) : null
        ]
      }
    )
  ] }) });
}
function Nd(e) {
  return /* @__PURE__ */ o.jsx(_t, { type: Ce.Secondary, size: tt.Small, ...e });
}
function Pd({ children: e }) {
  return /* @__PURE__ */ o.jsx("thead", { children: e });
}
function Ad({
  children: e,
  leading: t
}) {
  return /* @__PURE__ */ o.jsxs("tr", { children: [
    t,
    e
  ] });
}
const Hf = "text-neutral-40 dark:text-neutral-60", Yf = "text-body-md";
function Dd({ children: e }) {
  return /* @__PURE__ */ o.jsx("tbody", { className: A(Hf, Yf), children: e });
}
function Id({
  rowIndex: e,
  onCheckboxChange: t
}) {
  const { selectedRowIndexes: r } = qo();
  return /* @__PURE__ */ o.jsx(Wu, { isContentCentered: !0, children: /* @__PURE__ */ o.jsx(
    Ki,
    {
      onCheckedChange: (n) => {
        t(n.target.checked);
      },
      isChecked: r.has(e)
    }
  ) });
}
function Ld({ onCheckboxChange: e }) {
  const { isHeaderChecked: t, isHeaderIndeterminate: r } = qo();
  return /* @__PURE__ */ o.jsx(
    Uu,
    {
      isContentCentered: !0,
      hasCheckbox: !0,
      onCheckboxChange: (n) => {
        e(n.target.checked);
      },
      isChecked: t,
      columnKey: 1,
      isIndeterminate: r
    }
  );
}
function Md({
  items: e,
  activeId: t,
  onClickItem: r,
  isCollapsible: n = !1,
  onToggleNavbar: i
}) {
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: A("flex h-fit w-full", {
        "flex-col px-md py-xs sm:h-full sm:w-auto sm:px-none sm:py-xl": n
      }),
      children: [
        n && /* @__PURE__ */ o.jsxs("div", { className: "flex w-full items-center justify-between sm:mb-[48px] sm:flex-col", children: [
          /* @__PURE__ */ o.jsx("div", { className: "flex justify-center [&_svg]:h-[38px] [&_svg]:w-[38px]", children: /* @__PURE__ */ o.jsx(sl, { className: "text-neutral-10 dark:text-neutral-92" }) }),
          /* @__PURE__ */ o.jsx(
            "div",
            {
              className: "state-layer relative rounded-full p-xs hover:cursor-pointer dark:text-neutral-92 sm:hidden [&_svg]:h-6 [&_svg]:w-6",
              onClick: i,
              children: /* @__PURE__ */ o.jsx(cl, {})
            }
          )
        ] }),
        /* @__PURE__ */ o.jsx(
          "div",
          {
            className: A({
              "flex w-full justify-between px-sm py-xxs": !n,
              "hidden sm:flex sm:flex-col sm:gap-2": n
            }),
            children: e.map((s) => /* @__PURE__ */ o.jsx(
              "div",
              {
                className: A("flex items-center", {
                  "px-xs py-xxs": !n,
                  "py-xxs pl-xs pr-sm": n
                }),
                "data-testid": `nav-${s.id}`,
                children: /* @__PURE__ */ o.jsx(
                  vo,
                  {
                    ...s,
                    isSelected: s.id === t,
                    onClick: (u) => {
                      s.onClick && s.onClick(u), s.isDisabled || r(s.id);
                    }
                  }
                )
              },
              s.id
            ))
          }
        )
      ]
    }
  );
}
function Fd({
  items: e,
  activeId: t,
  onClickItem: r,
  isOpen: n,
  onToggleNavbar: i
}) {
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(
      "div",
      {
        onClick: i,
        className: A("duration-800 transition-opacity ease-out", {
          "opacity-1 fixed left-0 top-0 h-full w-full bg-shader-neutral-light-72": n,
          "-translate-x-full opacity-0": !n
        })
      }
    ),
    /* @__PURE__ */ o.jsx(
      "div",
      {
        className: A(
          "z-999 rounded-tb-3xl fixed left-0 top-0 h-full w-11/12 rounded-tr-3xl bg-white px-lg py-lg transition-transform duration-300 ease-out dark:bg-neutral-6",
          {
            "translate-x-0": n,
            "-translate-x-full": !n
          }
        ),
        children: /* @__PURE__ */ o.jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ o.jsx("div", { className: "[&_svg]:h-5 [&_svg]:w-5", children: /* @__PURE__ */ o.jsx(
            _t,
            {
              type: Ce.Ghost,
              onClick: i,
              icon: /* @__PURE__ */ o.jsx(Ui, {})
            }
          ) }),
          e.map((s) => /* @__PURE__ */ o.jsx(
            vo,
            {
              ...s,
              type: ja.Vertical,
              isSelected: s.id === t,
              onClick: () => {
                r(s.id), i && i();
              }
            },
            s.id
          ))
        ] })
      }
    )
  ] });
}
const zf = "text-neutral-10 dark:text-neutral-92 transition-transform ease-linear";
function Bd({
  onToggle: e,
  children: t,
  isExpanded: r,
  hideArrow: n
}) {
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      onClick: e,
      className: A(
        "state-layer relative flex cursor-pointer items-center justify-between gap-md overflow-hidden rounded-xl py-sm--rs",
        {
          "pr-md--rs": !n
        }
      ),
      children: [
        t,
        !n && /* @__PURE__ */ o.jsx("div", { className: "[&_svg]:h-5 [&_svg]:w-5", children: /* @__PURE__ */ o.jsx(
          _t,
          {
            type: Ce.Ghost,
            icon: /* @__PURE__ */ o.jsx(
              Qs,
              {
                className: A(zf, {
                  "rotate-180": r
                })
              }
            )
          }
        ) })
      ]
    }
  );
}
function Vd({
  isExpanded: e,
  children: t
}) {
  return /* @__PURE__ */ o.jsx(
    "div",
    {
      className: A({
        hidden: !e
      }),
      children: t
    }
  );
}
function Wd({
  children: e,
  hideBorder: t
}) {
  return /* @__PURE__ */ o.jsx(
    "div",
    {
      className: A("rounded-xl bg-neutral-100 dark:bg-neutral-6", {
        "border border-shader-neutral-light-8 dark:border-shader-neutral-dark-8": !t
      }),
      children: e
    }
  );
}
function Ud(e, t = 6, r = 6) {
  return e.length > t + r ? `${e.slice(0, t)}...${e.slice(-r)}` : e;
}
export {
  Wd as Accordion,
  Vd as AccordionContent,
  Bd as AccordionHeader,
  pd as Account,
  Gl as Address,
  An as Badge,
  Ge as BadgeType,
  _t as Button,
  Mn as ButtonHtmlType,
  Jf as ButtonPill,
  ed as ButtonSegment,
  Tr as ButtonSegmentType,
  tt as ButtonSize,
  Ce as ButtonType,
  nt as ButtonUnstyled,
  _d as Card,
  wd as CardAction,
  On as CardActionType,
  Sd as CardBody,
  Ed as CardImage,
  Jr as CardType,
  Ki as Checkbox,
  fd as Chip,
  kd as Dialog,
  $f as DialogBody,
  Vf as DialogClose,
  Wf as DialogContent,
  pr as DialogPosition,
  Uf as DialogTitle,
  Od as DialogTrigger,
  Cd as DisplayStats,
  At as DisplayStatsSize,
  Qt as DisplayStatsType,
  Ol as Divider,
  mr as DividerType,
  Vu as Dropdown,
  Rn as DropdownPosition,
  nd as Header,
  ls as IOTA_PRIMITIVES_COLOR_PALETTE,
  Ir as ImageShape,
  hr as ImageType,
  id as InfoBox,
  jn as InfoBoxStyle,
  Vt as InfoBoxType,
  md as Input,
  Tt as InputType,
  td as KeyValueInfo,
  rd as LabelText,
  dt as LabelTextSize,
  Al as ListItem,
  ld as LoadingIndicator,
  Md as Navbar,
  vo as NavbarItem,
  ja as NavbarItemType,
  Fd as NavbarSlideout,
  ad as Panel,
  Ml as Placeholder,
  Qf as RadioButton,
  iu as Resize,
  us as SHADER_COLOR_PALETTE,
  Bt as ScreenSize,
  yd as Search,
  Ut as SearchBarType,
  dd as SegmentedButton,
  Nr as SegmentedButtonType,
  bd as Select,
  kn as SelectSize,
  ud as Skeleton,
  od as Snackbar,
  Pt as SnackbarType,
  Td as Table,
  Nd as TableActionButton,
  Dd as TableBody,
  Wu as TableCellBase,
  xd as TableCellPlaceholder,
  gd as TableCellText,
  Pd as TableHeader,
  Uu as TableHeaderCell,
  Or as TableHeaderCellSortOrder,
  Ld as TableHeaderCheckbox,
  Ad as TableRow,
  Id as TableRowCheckbox,
  hd as TextArea,
  vd as Title,
  Dr as TitleSize,
  cd as Toggle,
  ga as ToggleLabelPosition,
  tr as ToggleSize,
  Mr as Tooltip,
  fr as TooltipPosition,
  Cn as ValueSize,
  sd as VisualAssetCard,
  pa as VisualAssetType,
  Ud as truncate,
  Zf as uiKitResponsivePreset,
  qf as uiKitStaticPreset
};
//# sourceMappingURL=index.es.js.map
